webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(16);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VISIBILITYCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FULLYENTERVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXITVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PARTIALLYEXITVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOCATIONCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATECHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return eventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isOnServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isInBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultOffsets; });
var VISIBILITYCHANGE = 'visibilityChange';
var ENTERVIEWPORT = 'enterViewport';
var FULLYENTERVIEWPORT = 'fullyEnterViewport';
var EXITVIEWPORT = 'exitViewport';
var PARTIALLYEXITVIEWPORT = 'partiallyExitViewport';
var LOCATIONCHANGE = 'locationChange';
var STATECHANGE = 'stateChange';
var eventTypes = [
    VISIBILITYCHANGE,
    ENTERVIEWPORT,
    FULLYENTERVIEWPORT,
    EXITVIEWPORT,
    PARTIALLYEXITVIEWPORT,
    LOCATIONCHANGE,
    STATECHANGE,
];
var isOnServer = typeof window === 'undefined';
var isInBrowser = !isOnServer;
var defaultOffsets = { top: 0, bottom: 0 };
//# sourceMappingURL=constants.js.map

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollMonitorContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__watcher_js__ = __webpack_require__(4);


function getViewportHeight(element) {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["k" /* isOnServer */]) {
        return 0;
    }
    if (element === document.body) {
        return window.innerHeight || document.documentElement.clientHeight;
    }
    else {
        return element.clientHeight;
    }
}
function getContentHeight(element) {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["k" /* isOnServer */]) {
        return 0;
    }
    if (element === document.body) {
        // jQuery approach
        // whichever is greatest
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight);
    }
    else {
        return element.scrollHeight;
    }
}
function scrollTop(element) {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["k" /* isOnServer */]) {
        return 0;
    }
    if (element === document.body) {
        return (window.pageYOffset ||
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop);
    }
    else {
        return element.scrollTop;
    }
}
var browserSupportsPassive = false;
if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["j" /* isInBrowser */]) {
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function () {
                browserSupportsPassive = true;
            },
        });
        window.addEventListener('test', null, opts);
    }
    catch (e) { }
}
var useCapture = browserSupportsPassive ? { capture: false, passive: true } : false;
var ScrollMonitorContainer = /** @class */ (function () {
    function ScrollMonitorContainer(item, parentWatcher) {
        this.eventTypes = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */];
        var self = this;
        this.item = item;
        this.watchers = [];
        this.viewportTop = null;
        this.viewportBottom = null;
        this.documentHeight = getContentHeight(item);
        this.viewportHeight = getViewportHeight(item);
        this.DOMListener = function () {
            ScrollMonitorContainer.prototype.DOMListener.apply(self, arguments);
        };
        if (parentWatcher) {
            this.containerWatcher = parentWatcher.create(item);
        }
        var previousDocumentHeight;
        var calculateViewportI;
        function calculateViewport() {
            self.viewportTop = scrollTop(item);
            self.viewportBottom = self.viewportTop + self.viewportHeight;
            self.documentHeight = getContentHeight(item);
            if (self.documentHeight !== previousDocumentHeight) {
                calculateViewportI = self.watchers.length;
                while (calculateViewportI--) {
                    self.watchers[calculateViewportI].recalculateLocation();
                }
                previousDocumentHeight = self.documentHeight;
            }
        }
        var updateAndTriggerWatchersI;
        function updateAndTriggerWatchers() {
            // update all watchers then trigger the events so one can rely on another being up to date.
            updateAndTriggerWatchersI = self.watchers.length;
            while (updateAndTriggerWatchersI--) {
                self.watchers[updateAndTriggerWatchersI].update();
            }
            updateAndTriggerWatchersI = self.watchers.length;
            while (updateAndTriggerWatchersI--) {
                self.watchers[updateAndTriggerWatchersI].triggerCallbacks(undefined);
            }
        }
        this.update = function () {
            calculateViewport();
            updateAndTriggerWatchers();
        };
        this.recalculateLocations = function () {
            this.documentHeight = 0;
            this.update();
        };
    }
    ScrollMonitorContainer.prototype.listenToDOM = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["j" /* isInBrowser */]) {
            if (this.item === document.body) {
                window.addEventListener('scroll', this.DOMListener, useCapture);
            }
            else {
                this.item.addEventListener('scroll', this.DOMListener, useCapture);
            }
            window.addEventListener('resize', this.DOMListener);
            this.destroy = function () {
                if (this.item === document.body) {
                    window.removeEventListener('scroll', this.DOMListener, useCapture);
                    this.containerWatcher.destroy();
                }
                else {
                    this.item.removeEventListener('scroll', this.DOMListener, useCapture);
                }
                window.removeEventListener('resize', this.DOMListener);
            };
        }
    };
    ScrollMonitorContainer.prototype.destroy = function () {
        // noop, override for your own purposes.
        // in listenToDOM, for example.
    };
    ScrollMonitorContainer.prototype.DOMListener = function (event) {
        //alert('got scroll');
        this.updateState();
        this.updateAndTriggerWatchers(event);
    };
    ScrollMonitorContainer.prototype.updateState = function () {
        var viewportTop = scrollTop(this.item);
        var viewportHeight = getViewportHeight(this.item);
        var contentHeight = getContentHeight(this.item);
        var needsRecalcuate = viewportHeight !== this.viewportHeight || contentHeight !== this.contentHeight;
        this.viewportTop = viewportTop;
        this.viewportHeight = viewportHeight;
        this.viewportBottom = viewportTop + viewportHeight;
        this.contentHeight = contentHeight;
        if (needsRecalcuate) {
            var i = this.watchers.length;
            while (i--) {
                this.watchers[i].recalculateLocation();
            }
        }
    };
    ScrollMonitorContainer.prototype.updateAndTriggerWatchers = function (event) {
        var i = this.watchers.length;
        while (i--) {
            this.watchers[i].update();
        }
        i = this.watchers.length;
        while (i--) {
            this.watchers[i].triggerCallbacks(event);
        }
    };
    ScrollMonitorContainer.prototype.createContainer = function (input) {
        var item;
        if (typeof input === 'string') {
            item = document.querySelector(input);
        }
        else if (Array.isArray(input) || input instanceof NodeList) {
            item = input[0];
        }
        else {
            item = input;
        }
        var container = new ScrollMonitorContainer(item, this);
        this.updateState();
        container.listenToDOM();
        return container;
    };
    ScrollMonitorContainer.prototype.create = function (input, offsets) {
        var item;
        if (typeof item === 'string') {
            item = document.querySelector(item);
        }
        else if (Array.isArray(input) || input instanceof NodeList) {
            item = input[0];
        }
        else {
            item = input;
        }
        var watcher = new __WEBPACK_IMPORTED_MODULE_1__watcher_js__["a" /* Watcher */](this, item, offsets);
        this.watchers.push(watcher);
        return watcher;
    };
    /**
     * @deprecated since version 1.1
     */
    ScrollMonitorContainer.prototype.beget = function (input, offsets) {
        return this.create(input, offsets);
    };
    return ScrollMonitorContainer;
}());

//# sourceMappingURL=container.js.map

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Watcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(2);

var Watcher = /** @class */ (function () {
    function Watcher(container, watchItem, offsets) {
        this.container = container;
        this.watchItem = watchItem;
        this.locked = false;
        this.callbacks = {};
        var self = this;
        if (!offsets) {
            this.offsets = __WEBPACK_IMPORTED_MODULE_0__constants_js__["h" /* defaultOffsets */];
        }
        else if (typeof offsets === 'number') {
            this.offsets = { top: offsets, bottom: offsets };
        }
        else {
            this.offsets = {
                top: 'top' in offsets ? offsets.top : __WEBPACK_IMPORTED_MODULE_0__constants_js__["h" /* defaultOffsets */].top,
                bottom: 'bottom' in offsets ? offsets.bottom : __WEBPACK_IMPORTED_MODULE_0__constants_js__["h" /* defaultOffsets */].bottom,
            };
        }
        for (var i = 0, j = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].length; i < j; i++) {
            self.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */][i]] = [];
        }
        this.locked = false;
        var wasInViewport;
        var wasFullyInViewport;
        var wasAboveViewport;
        var wasBelowViewport;
        var listenerToTriggerListI;
        var listener;
        var needToTriggerStateChange = false;
        function triggerCallbackArray(listeners, event) {
            needToTriggerStateChange = true;
            if (listeners.length === 0) {
                return;
            }
            listenerToTriggerListI = listeners.length;
            while (listenerToTriggerListI--) {
                listener = listeners[listenerToTriggerListI];
                listener.callback.call(self, event, self);
                if (listener.isOne) {
                    listeners.splice(listenerToTriggerListI, 1);
                }
            }
        }
        this.triggerCallbacks = function triggerCallbacks(event) {
            if (this.isInViewport && !wasInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* ENTERVIEWPORT */]], event);
            }
            if (this.isFullyInViewport && !wasFullyInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* FULLYENTERVIEWPORT */]], event);
            }
            if (this.isAboveViewport !== wasAboveViewport &&
                this.isBelowViewport !== wasBelowViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* VISIBILITYCHANGE */]], event);
                // if you skip completely past this element
                if (!wasFullyInViewport && !this.isFullyInViewport) {
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* FULLYENTERVIEWPORT */]], event);
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* PARTIALLYEXITVIEWPORT */]], event);
                }
                if (!wasInViewport && !this.isInViewport) {
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* ENTERVIEWPORT */]], event);
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* EXITVIEWPORT */]], event);
                }
            }
            if (!this.isFullyInViewport && wasFullyInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* PARTIALLYEXITVIEWPORT */]], event);
            }
            if (!this.isInViewport && wasInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* EXITVIEWPORT */]], event);
            }
            if (this.isInViewport !== wasInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* VISIBILITYCHANGE */]], event);
            }
            if (needToTriggerStateChange) {
                needToTriggerStateChange = false;
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* STATECHANGE */]], event);
            }
            wasInViewport = this.isInViewport;
            wasFullyInViewport = this.isFullyInViewport;
            wasAboveViewport = this.isAboveViewport;
            wasBelowViewport = this.isBelowViewport;
        };
        this.recalculateLocation = function () {
            if (this.locked) {
                return;
            }
            var previousTop = this.top;
            var previousBottom = this.bottom;
            if (this.watchItem.nodeName) {
                // a dom element
                var cachedDisplay = this.watchItem.style.display;
                if (cachedDisplay === 'none') {
                    this.watchItem.style.display = '';
                }
                var containerOffset = 0;
                var container = this.container;
                while (container.containerWatcher) {
                    containerOffset +=
                        container.containerWatcher.top -
                            container.containerWatcher.container.viewportTop;
                    container = container.containerWatcher.container;
                }
                var boundingRect = this.watchItem.getBoundingClientRect();
                this.top = boundingRect.top + this.container.viewportTop - containerOffset;
                this.bottom = boundingRect.bottom + this.container.viewportTop - containerOffset;
                if (cachedDisplay === 'none') {
                    this.watchItem.style.display = cachedDisplay;
                }
            }
            else if (this.watchItem === +this.watchItem) {
                // number
                if (this.watchItem > 0) {
                    this.top = this.bottom = this.watchItem;
                }
                else {
                    this.top = this.bottom = this.container.documentHeight - this.watchItem;
                }
            }
            else {
                // an object with a top and bottom property
                this.top = this.watchItem.top;
                this.bottom = this.watchItem.bottom;
            }
            this.top -= this.offsets.top;
            this.bottom += this.offsets.bottom;
            this.height = this.bottom - this.top;
            if ((previousTop !== undefined || previousBottom !== undefined) &&
                (this.top !== previousTop || this.bottom !== previousBottom)) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* LOCATIONCHANGE */]], undefined);
            }
        };
        this.recalculateLocation();
        this.update();
        wasInViewport = this.isInViewport;
        wasFullyInViewport = this.isFullyInViewport;
        wasAboveViewport = this.isAboveViewport;
        wasBelowViewport = this.isBelowViewport;
    }
    Watcher.prototype.on = function (event, callback, isOne) {
        if (isOne === void 0) { isOne = false; }
        // trigger the event if it applies to the element right now.
        switch (true) {
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* VISIBILITYCHANGE */] && !this.isInViewport && this.isAboveViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* ENTERVIEWPORT */] && this.isInViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* FULLYENTERVIEWPORT */] && this.isFullyInViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* EXITVIEWPORT */] && this.isAboveViewport && !this.isInViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* PARTIALLYEXITVIEWPORT */] && this.isInViewport && this.isAboveViewport:
                callback.call(this, this);
                if (isOne) {
                    return;
                }
        }
        if (this.callbacks[event]) {
            this.callbacks[event].push({ callback: callback, isOne: isOne });
        }
        else {
            throw new Error('Tried to add a scroll monitor listener of type ' +
                event +
                '. Your options are: ' +
                __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].join(', '));
        }
    };
    Watcher.prototype.off = function (event, callback) {
        if (this.callbacks[event]) {
            for (var i = 0, item; (item = this.callbacks[event][i]); i++) {
                if (item.callback === callback) {
                    this.callbacks[event].splice(i, 1);
                    break;
                }
            }
        }
        else {
            throw new Error('Tried to remove a scroll monitor listener of type ' +
                event +
                '. Your options are: ' +
                __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].join(', '));
        }
    };
    Watcher.prototype.one = function (event, callback) {
        this.on(event, callback, true);
    };
    Watcher.prototype.recalculateSize = function () {
        if (this.watchItem instanceof HTMLElement) {
            this.height = this.watchItem.offsetHeight + this.offsets.top + this.offsets.bottom;
            this.bottom = this.top + this.height;
        }
    };
    Watcher.prototype.update = function () {
        this.isAboveViewport = this.top < this.container.viewportTop;
        this.isBelowViewport = this.bottom > this.container.viewportBottom;
        this.isInViewport =
            this.top < this.container.viewportBottom && this.bottom > this.container.viewportTop;
        this.isFullyInViewport =
            (this.top >= this.container.viewportTop &&
                this.bottom <= this.container.viewportBottom) ||
                (this.isAboveViewport && this.isBelowViewport);
    };
    Watcher.prototype.destroy = function () {
        var index = this.container.watchers.indexOf(this), self = this;
        this.container.watchers.splice(index, 1);
        self.callbacks = {};
    };
    // prevent recalculating the element location
    Watcher.prototype.lock = function () {
        this.locked = true;
    };
    Watcher.prototype.unlock = function () {
        this.locked = false;
    };
    return Watcher;
}());

var eventHandlerFactory = function (type) {
    return function (callback, isOne) {
        if (isOne === void 0) { isOne = false; }
        this.on.call(this, type, callback, isOne);
    };
};
for (var i = 0, j = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].length; i < j; i++) {
    var type = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */][i];
    Watcher.prototype[type] = eventHandlerFactory(type);
}
//# sourceMappingURL=watcher.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}var d="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),c=[],u=!1,a=-1,s=void 0,v=void 0,f=function(t){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})},m=function(e){var t=e||window.event;return!!f(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))},o=function(){setTimeout(function(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)})};exports.disableBodyScroll=function(i,e){if(d){if(!i)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(i&&!c.some(function(e){return e.targetElement===i})){var t={targetElement:i,options:e||{}};c=[].concat(r(c),[t]),i.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},i.ontouchmove=function(e){var t,o,n,r;1===e.targetTouches.length&&(o=i,r=(t=e).targetTouches[0].clientY-a,!f(t.target)&&(o&&0===o.scrollTop&&0<r?m(t):(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&r<0?m(t):t.stopPropagation()))},u||(document.addEventListener("touchmove",m,l?{passive:!1}:void 0),u=!0)}}else{n=e,setTimeout(function(){if(void 0===v){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:i,options:e||{}};c=[].concat(r(c),[o])}var n},exports.clearAllBodyScrollLocks=function(){d?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1),c=[],a=-1):(o(),c=[])},exports.enableBodyScroll=function(t){if(d){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,c=c.filter(function(e){return e.targetElement!==t}),u&&0===c.length&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1)}else 1===c.length&&c[0].targetElement===t?(o(),c=[]):c=c.filter(function(e){return e.targetElement!==t})}});


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_container_js__ = __webpack_require__(3);
/* unused harmony reexport ScrollMonitorContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_watcher_js__ = __webpack_require__(4);
/* unused harmony reexport Watcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_types__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_constants_js__ = __webpack_require__(2);





// this is needed for the type, but if we're not in a browser the only
// way listenToDOM will be called is if you call scrollmonitor.createContainer
// and you can't do that until you have a DOM element.
var scrollMonitor = new __WEBPACK_IMPORTED_MODULE_0__src_container_js__["a" /* ScrollMonitorContainer */](__WEBPACK_IMPORTED_MODULE_3__src_constants_js__["j" /* isInBrowser */] ? document.body : undefined);
if (__WEBPACK_IMPORTED_MODULE_3__src_constants_js__["j" /* isInBrowser */]) {
    scrollMonitor.updateState();
    scrollMonitor.listenToDOM();
}
//@ts-ignore
window.scrollMonitor = scrollMonitor;
/* harmony default export */ __webpack_exports__["a"] = (scrollMonitor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = numberFormat;
/**
 * JavaScript equivalent of PHPs number_format()
 */
function numberFormat(number, decimals, dec_point, thousands_sep) {

    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
        dec = typeof dec_point === 'undefined' ? '.' : dec_point,
        s = '',
        toFixedFix = function toFixedFix(n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=types.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(68);
var enhanceError = __webpack_require__(18);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(19);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(19);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Headers */
/* unused harmony export Request */
/* unused harmony export Response */
/* unused harmony export DOMException */
/* unused harmony export fetch */
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Toggle = function Toggle() {
  var toggles = document.querySelectorAll('.js-toggle');
  if (!toggles.length > 0) return;[].concat(_toConsumableArray(toggles)).forEach(function (toggle) {
    var trigger = toggle.querySelector('.js-toggle-trigger');
    var panel = toggle.querySelector('.js-toggle-panel');

    trigger.addEventListener('click', function (e) {
      var close = toggle.querySelector('.js-toggle-close');

      toggle.classList.toggle('active');
      trigger.classList.toggle('active');
      panel.classList.toggle('active');

      close.addEventListener('click', function (e) {
        toggle.classList.remove('active');
        trigger.classList.remove('active');
        panel.classList.remove('active');
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Toggle);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = dimensionsValidation;
/* harmony export (immutable) */ __webpack_exports__["a"] = dimensionsFeedback;
/**
 * Helper function to determine
 * dimensions validation status and messages.
 */
function dimensionsValidation(width, length, hasRubber, formElement, diameter) {
  var priceBar = formElement.querySelector('.js-woo-price-bar');
  var wrapper = formElement.querySelector('.js-woo-additional-options');
  var min = parseFloat(priceBar.dataset.min);
  var max = parseFloat(priceBar.dataset.max);
  var rubberWidth = parseFloat(priceBar.dataset.rubberwidth);

  if (!priceBar || !min || !max) {
    return {
      status: false,
      message: 'Waardes konden niet worden opgehaald. Ververs de pagina.'
    };
  }

  if (hasRubber && !rubberWidth) {
    return {
      status: false,
      message: 'Rubberbreedte kon niet opgehaald worden.'
    };
  }

  var originalMax = max;

  // Increase maximum if rubber_edge is checked
  if (hasRubber) {
    max = max + rubberWidth * 2;
  } else {
    max = originalMax;
  }

  if (!width || !length) {
    return {
      status: false,
      message: 'Voer het gewenste formaat in.'
    };
  } else if (width && length && (width < min || length < min)) {
    return {
      status: false,
      message: diameter ? 'Vul een maat van minimaal ' + min + ' cm in.' : 'Vul maten van minimaal ' + min + ' cm in.'
    };
  } else if (width && length && width > max && length > max) {
    return {
      status: false,
      message: diameter ? 'De maat overschrijdt de maximale rolbreedte van ' + max + ' cm.' : 'Beide zijden overschrijden de maximale rolbreedte van ' + max + ' cm.'
    };
  } else if (width && length && (width.includes(',') || length.includes(','))) {
    return {
      status: false,
      message: 'Gebruik geen komma\'s (,) om getallen te scheiden maar een punt.'
    };
  } else {
    if (wrapper) {
      // Show next options if valid
      wrapper.classList.remove('inactive');
      wrapper.classList.add('active');
    }

    return {
      status: true,
      message: ''
    };
  }
}

/**
 * Helper function to determine
 * minimum and maximium validation message.
 */
function dimensionsFeedback(width, length, hasRubber, formElement, diameter) {
  var priceBar = formElement.querySelector('.js-woo-price-bar');
  var min = parseFloat(priceBar.dataset.min);
  var max = parseFloat(priceBar.dataset.max);
  var rubberWidth = parseFloat(priceBar.dataset.rubberwidth);
  var widthCheck = document.querySelector('.js-product-check-width');
  var lengthCheck = document.querySelector('.js-product-check-length');

  if (!priceBar || !min || !max) {
    return 'Waardes konden niet worden opgehaald. Ververs de pagina.';
  }

  if (hasRubber && !rubberWidth) {
    return {
      status: false,
      message: 'Rubberbreedte kon niet opgehaald worden.'
    };
  }

  var originalMax = max;

  // Increase maximum if rubber_edge is checked
  if (hasRubber) {
    max = max + rubberWidth * 2;
  } else {
    max = originalMax;
  }

  if (width && length && (width < min || length < min)) {
    if (widthCheck && lengthCheck) {
      widthCheck.classList.remove('valid');
      lengthCheck.classList.remove('valid');
    }

    return diameter ? 'Vul een maat van minimaal ' + min + ' cm in.' : 'Vul maten van minimaal ' + min + ' cm in.';
  } else if (width && length && width > max && length > max) {
    if (widthCheck && lengthCheck) {
      widthCheck.classList.remove('valid');
      lengthCheck.classList.remove('valid');
    }

    return diameter ? 'De maat overschrijdt de maximale rolbreedte van ' + max + ' cm. <a href="/klantenservice" target="_blank">Neem contact met ons op</a> om je wensen te bespreken.' : 'Beide zijden overschrijden de maximale rolbreedte van ' + max + ' cm. <a href="/klantenservice" target="_blank">Neem contact met ons op</a> om je wensen te bespreken.';
  } else if (width && length && (width.includes(',') || length.includes(','))) {
    if (widthCheck && lengthCheck) {
      widthCheck.classList.remove('valid');
      lengthCheck.classList.remove('valid');
    }

    return 'Gebruik geen komma\'s (,) om getallen te scheiden maar een punt.';
  } else if (width && length) {
    var rubber = formElement.querySelector('.js-options-rubber');
    if (rubber) {
      rubber.classList.remove('active-error');
      rubber.classList.add('active');
    } else {
      var extras = formElement.querySelector('.js-options-extras');
      if (extras) {
        extras.classList.remove('inactive');
        extras.classList.add('active');
      }
    }

    if (widthCheck && lengthCheck) {
      widthCheck.classList.add('valid');
      lengthCheck.classList.add('valid');
    }

    var fillingMat = formElement.querySelector('.js-woo-filling-mat');
    if (fillingMat) {
      fillingMat.classList.remove('inactive');
      fillingMat.classList.add('active');
    }

    var additionalProducts = formElement.querySelector('.js-woo-additional-products');
    if (additionalProducts) {
      additionalProducts.classList.remove('inactive');
      additionalProducts.classList.add('active');
    }

    return '';
  } else {
    return '';
  }
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(69);
var cookies = __webpack_require__(70);
var buildURL = __webpack_require__(17);
var buildFullPath = __webpack_require__(71);
var parseHeaders = __webpack_require__(74);
var isURLSameOrigin = __webpack_require__(75);
var createError = __webpack_require__(20);
var defaults = __webpack_require__(9);
var Cancel = __webpack_require__(10);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(18);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.25.0"
};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smoothscroll__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smoothscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smoothscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_objectFitPolyfill__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_objectFitPolyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_objectFitPolyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_fit_images__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ObserveFontFace__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_FormValidation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_SendForm__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_DependsOn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_LazyLoadImage__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_LazyLoadPicture__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_LazyLoadVideo__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_UploadButton__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_ReadMore__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_Video__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_StickyHeader__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_NavMobile__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_SearchMobile__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_Toggle__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__woocommerce_CalculatePrice__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__woocommerce_DimensionsFeedback__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__woocommerce_ShowOptions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__woocommerce_ProductFilters__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__woocommerce_ProductFilterToggle__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__woocommerce_MonitorVariationChange__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__datalayer_AddToCart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_ChatActivity__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_FillerMat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_UpdateColorURL__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_ScrollAnimation__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_TriggerTarget__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_CheckoutFieldFocus__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_CheckoutFieldValues__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_FaqToggle__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modules_TargetClick__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modules_ParentClick__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modules_Click__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modules_CheckoutStepValidator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__woocommerce_AddProductPopup__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__woocommerce_Message__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__woocommerce_ShoppingCart__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modules_GalleryMenu__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modules_ThumbnailSlider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modules_GoBack__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modules_Swatches__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modules_ProductSlider__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modules_SingleProductSticky__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modules_ProductSwatchesClick__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modules_Lightbox__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modules_OpenSampleTab__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modules_AddFillingMat__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modules_ItemSlider__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modules_OpenPopup__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__modules_PdpRemoveDoubleElements__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__modules_ProjectsSlider__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__modules_ProjectSliderMobile__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modules_CheckoutBusiness__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__modules_CheckoutUpdatePrice__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__modules_HeaderSearch__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__woocommerce_ProductOptionRubber__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__woocommerce_ProductFillingMat__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__woocommerce_ProductAdditionalProducts__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__woocommerce_VariationBuitenmat__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__modules_CardsSlider__ = __webpack_require__(124);
/**
 * Main.js
 *
 * @since 1.0.0
 */




// import Raven from 'raven-js'
































// import ClassCheckWoocommerce from './modules/ClassCheckWoocommerce'




















// import CheckoutValidator from './modules/CheckoutValidator'







// import DataLayerPurchase from './modules/DataLayerPurchase'

// import HideChatIfCookie from './modules/HideChatIfCookie'
(function IIFE() {
  // Raven
  // .config('https://3c38a13f1d9c4d3fa0067e8973a5590e@sentry.io/1439045')
  // .install()
  Object(__WEBPACK_IMPORTED_MODULE_3__modules_ObserveFontFace__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_54__modules_CheckoutBusiness__["a" /* default */])();
  // CheckoutValidator()
  Object(__WEBPACK_IMPORTED_MODULE_53__modules_ProjectSliderMobile__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_52__modules_ProjectsSlider__["a" /* default */])();
  __WEBPACK_IMPORTED_MODULE_2_object_fit_images___default()();
  Object(__WEBPACK_IMPORTED_MODULE_4__modules_FormValidation__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_5__modules_SendForm__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_6__modules_DependsOn__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_7__modules_LazyLoadImage__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_8__modules_LazyLoadPicture__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_9__modules_LazyLoadVideo__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_10__modules_UploadButton__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_11__modules_ReadMore__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_12__modules_Video__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_13__modules_StickyHeader__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_14__modules_NavMobile__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_15__modules_SearchMobile__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_16__modules_Toggle__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_17__woocommerce_CalculatePrice__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_18__woocommerce_DimensionsFeedback__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_19__woocommerce_ShowOptions__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_20__woocommerce_ProductFilters__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_21__woocommerce_ProductFilterToggle__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_22__woocommerce_MonitorVariationChange__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_23__datalayer_AddToCart__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_24__modules_ChatActivity__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_25__modules_FillerMat__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_26__modules_UpdateColorURL__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_28__modules_TriggerTarget__["a" /* default */])();
  // HideChatIfCookie()
  var scrollAnimate = new __WEBPACK_IMPORTED_MODULE_27__modules_ScrollAnimation__["a" /* default */]();
  scrollAnimate.start();
  Object(__WEBPACK_IMPORTED_MODULE_29__modules_CheckoutFieldFocus__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_30__modules_CheckoutFieldValues__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_34__modules_Click__["a" /* toggleActiveClick */])();
  Object(__WEBPACK_IMPORTED_MODULE_32__modules_TargetClick__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_33__modules_ParentClick__["a" /* default */])();
  // ClassCheckWoocommerce()
  Object(__WEBPACK_IMPORTED_MODULE_35__modules_CheckoutStepValidator__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_36__woocommerce_AddProductPopup__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_37__woocommerce_Message__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_38__woocommerce_ShoppingCart__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_39__modules_GalleryMenu__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_40__modules_ThumbnailSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_41__modules_GoBack__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_42__modules_Swatches__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_43__modules_ProductSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_44__modules_SingleProductSticky__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_45__modules_ProductSwatchesClick__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_46__modules_Lightbox__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_47__modules_OpenSampleTab__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_48__modules_AddFillingMat__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_49__modules_ItemSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_50__modules_OpenPopup__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_51__modules_PdpRemoveDoubleElements__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_55__modules_CheckoutUpdatePrice__["a" /* default */])();
  // DataLayerPurchase()
  Object(__WEBPACK_IMPORTED_MODULE_56__modules_HeaderSearch__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_57__woocommerce_ProductOptionRubber__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_58__woocommerce_ProductFillingMat__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_59__woocommerce_ProductAdditionalProducts__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_60__woocommerce_VariationBuitenmat__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_61__modules_CardsSlider__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_31__modules_FaqToggle__["a" /* default */])();
})();

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, smoothScroll) {
  'use strict';

  // Support RequireJS and CommonJS/NodeJS module formats.
  // Attach smoothScroll to the `window` when executed as a <script>.

  // RequireJS
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (smoothScroll),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // CommonJS
  } else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = smoothScroll();

  } else {
    root.smoothScroll = smoothScroll();
  }

})(this, function(){
'use strict';

// Do not initialize smoothScroll when running server side, handle it in client:
if (typeof window !== 'object') return;

// We do not want this script to be applied in browsers that do not support those
// That means no smoothscroll on IE9 and below.
if(document.querySelectorAll === void 0 || window.pageYOffset === void 0 || history.pushState === void 0) { return; }

// Get the top position of an element in the document
var getTop = function(element, start) {
    // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
    if(element.nodeName === 'HTML') return -start
    return element.getBoundingClientRect().top + start
}
// ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
var easeInOutCubic = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }

// calculate the scroll position we should be in
// given the start and end point of the scroll
// the time elapsed from the beginning of the scroll
// and the total duration of the scroll (default 500ms)
var position = function(start, end, elapsed, duration) {
    if (elapsed > duration) return end;
    return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
    // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
}

// we use requestAnimationFrame to be called by the browser before every repaint
// if the first argument is an element then scroll to the top of this element
// if the first argument is numeric then scroll to this location
// if the callback exist, it is called when the scrolling is finished
// if context is set then scroll that element, else scroll window
var smoothScroll = function(el, duration, callback, context){
    duration = duration || 500;
    context = context || window;
    var start = context.scrollTop || window.pageYOffset;

    if (typeof el === 'number') {
      var end = parseInt(el);
    } else {
      var end = getTop(el, start);
    }

    var clock = Date.now();
    var requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
        function(fn){window.setTimeout(fn, 15);};

    var step = function(){
        var elapsed = Date.now() - clock;
        if (context !== window) {
          context.scrollTop = position(start, end, elapsed, duration);
        }
        else {
          window.scroll(0, position(start, end, elapsed, duration));
        }

        if (elapsed > duration) {
            if (typeof callback === 'function') {
                callback(el);
            }
        } else {
            requestAnimationFrame(step);
        }
    }
    step();
}

var linkHandler = function(ev) {
    if (!ev.defaultPrevented) {
        ev.preventDefault();

        if (location.hash !== this.hash) window.history.pushState(null, null, this.hash)
        // using the history api to solve issue #1 - back doesn't work
        // most browser don't update :target when the history api is used:
        // THIS IS A BUG FROM THE BROWSERS.
        // change the scrolling duration in this call
        var node = document.getElementById(this.hash.substring(1))
        if (!node) return; // Do not scroll to non-existing node

        smoothScroll(node, 500, function (el) {
            location.replace('#' + el.id)
            // this will cause the :target to be activated.
        });
    }
}

// We look for all the internal links in the documents and attach the smoothscroll function
document.addEventListener("DOMContentLoaded", function () {
    var internal = document.querySelectorAll('a[href^="#"]:not([href="#"])'), a;
    for(var i=internal.length; a=internal[--i];){
        a.addEventListener("click", linkHandler, false);
    }
});

// return smoothscroll API
return smoothScroll;

});


/***/ }),
/* 40 */
/***/ (function(module, exports) {

!function(){"use strict";if("undefined"!=typeof window){var t=window.navigator.userAgent.match(/Edge\/(\d{2})\./),e=!!t&&parseInt(t[1],10)>=16;if("objectFit"in document.documentElement.style!=!1&&!e)return void(window.objectFitPolyfill=function(){return!1});var i=function(t){var e=window.getComputedStyle(t,null),i=e.getPropertyValue("position"),n=e.getPropertyValue("overflow"),o=e.getPropertyValue("display");i&&"static"!==i||(t.style.position="relative"),"hidden"!==n&&(t.style.overflow="hidden"),o&&"inline"!==o||(t.style.display="block"),0===t.clientHeight&&(t.style.height="100%"),-1===t.className.indexOf("object-fit-polyfill")&&(t.className=t.className+" object-fit-polyfill")},n=function(t){var e=window.getComputedStyle(t,null),i={"max-width":"none","max-height":"none","min-width":"0px","min-height":"0px",top:"auto",right:"auto",bottom:"auto",left:"auto","margin-top":"0px","margin-right":"0px","margin-bottom":"0px","margin-left":"0px"};for(var n in i){e.getPropertyValue(n)!==i[n]&&(t.style[n]=i[n])}},o=function(t,e,i){var n,o,l,a,d;if(i=i.split(" "),i.length<2&&(i[1]=i[0]),"x"===t)n=i[0],o=i[1],l="left",a="right",d=e.clientWidth;else{if("y"!==t)return;n=i[1],o=i[0],l="top",a="bottom",d=e.clientHeight}return n===l||o===l?void(e.style[l]="0"):n===a||o===a?void(e.style[a]="0"):"center"===n||"50%"===n?(e.style[l]="50%",void(e.style["margin-"+l]=d/-2+"px")):n.indexOf("%")>=0?(n=parseInt(n),void(n<50?(e.style[l]=n+"%",e.style["margin-"+l]=d*(n/-100)+"px"):(n=100-n,e.style[a]=n+"%",e.style["margin-"+a]=d*(n/-100)+"px"))):void(e.style[l]=n)},l=function(t){var e=t.dataset?t.dataset.objectFit:t.getAttribute("data-object-fit"),l=t.dataset?t.dataset.objectPosition:t.getAttribute("data-object-position");e=e||"cover",l=l||"50% 50%";var a=t.parentNode;i(a),n(t),t.style.position="absolute",t.style.height="100%",t.style.width="auto","scale-down"===e&&(t.style.height="auto",t.clientWidth<a.clientWidth&&t.clientHeight<a.clientHeight?(o("x",t,l),o("y",t,l)):(e="contain",t.style.height="100%")),"none"===e?(t.style.width="auto",t.style.height="auto",o("x",t,l),o("y",t,l)):"cover"===e&&t.clientWidth>a.clientWidth||"contain"===e&&t.clientWidth<a.clientWidth?(t.style.top="0",t.style.marginTop="0",o("x",t,l)):"scale-down"!==e&&(t.style.width="100%",t.style.height="auto",t.style.left="0",t.style.marginLeft="0",o("y",t,l))},a=function(t){if(void 0===t)t=document.querySelectorAll("[data-object-fit]");else if(t&&t.nodeName)t=[t];else{if("object"!=typeof t||!t.length||!t[0].nodeName)return!1;t=t}for(var i=0;i<t.length;i++)if(t[i].nodeName){var n=t[i].nodeName.toLowerCase();"img"!==n||e?"video"===n&&(t[i].readyState>0?l(t[i]):t[i].addEventListener("loadedmetadata",function(){l(this)})):t[i].complete?l(t[i]):t[i].addEventListener("load",function(){l(this)})}return!0};document.addEventListener("DOMContentLoaded",function(){a()}),window.addEventListener("resize",function(){a()}),window.objectFitPolyfill=a}}();

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.4 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fontfaceobserver__);
/**
 * Observe Fontface
 *
 * @since 1.0.0
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var font = new __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default.a('museo-sans'); // Add font here
  font.load().then(function () {
    if (!document.documentElement.classList.contains("fonts-loaded")) {
      document.documentElement.classList.add("fonts-loaded");
    }
  });
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function t(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function u(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function z(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function A(a,b){function c(){var a=k;z(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);z(a)};function B(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var C=null,D=null,E=null,F=null;function G(){if(null===D)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);D=!!a&&603>parseInt(a[1],10)}else D=!1;return D}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
B.prototype.load=function(a,b){var c=this,k=a||"BESbswy",r=0,n=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=n?b(Error(""+n+"ms timeout exceeded")):document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},b)}e()}),N=new Promise(function(a,c){r=setTimeout(function(){c(Error(""+n+"ms timeout exceeded"))},n)});Promise.race([N,M]).then(function(){clearTimeout(r);a(c)},
b)}else m(function(){function v(){var b;if(b=-1!=f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===C&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),C=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=C&&(f==w&&g==w&&h==w||f==x&&g==x&&h==x||f==y&&g==y&&h==y)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(r),a(c))}function I(){if((new Date).getTime()-H>=n)d.parentNode&&d.parentNode.removeChild(d),b(Error(""+
n+"ms timeout exceeded"));else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,g=p.a.offsetWidth,h=q.a.offsetWidth,v();r=setTimeout(I,50)}}var e=new t(k),p=new t(k),q=new t(k),f=-1,g=-1,h=-1,w=-1,x=-1,y=-1,d=document.createElement("div");d.dir="ltr";u(e,L(c,"sans-serif"));u(p,L(c,"serif"));u(q,L(c,"monospace"));d.appendChild(e.a);d.appendChild(p.a);d.appendChild(q.a);document.body.appendChild(d);w=e.a.offsetWidth;x=p.a.offsetWidth;y=q.a.offsetWidth;I();A(e,function(a){f=a;v()});u(e,
L(c,'"'+c.family+'",sans-serif'));A(p,function(a){g=a;v()});u(p,L(c,'"'+c.family+'",serif'));A(q,function(a){h=a;v()});u(q,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=B:(window.FontFaceObserver=B,window.FontFaceObserver.prototype.load=B.prototype.load);}());


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_script_loader_hyperform_dist_hyperform_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_script_loader_hyperform_dist_hyperform_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_script_loader_hyperform_dist_hyperform_js__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Form validation
 *
 * @since 1.0.0
 */


var FormValidation = function FormValidation() {
  var forms = document.querySelectorAll('.js-form');
  if (!forms) return;[].concat(_toConsumableArray(forms)).forEach(function (form) {

    window.hyperform(form);
    var inputs = form.querySelectorAll('input,textarea,select');[].concat(_toConsumableArray(inputs)).forEach(function (input) {

      // All required inputs
      if (input.required) {
        input.addEventListener('invalid', function (e) {
          return e.preventDefault();
        });
      }

      // All required file-uploaders
      if (input.required && input.classList.contains('js-upload-input')) {
        input.addEventListener('invalid', function (e) {
          input.closest('.js-upload-button').classList.add('is-invalid');
        });
        input.addEventListener('valid', function (e) {
          input.closest('.js-upload-button').classList.remove('is-invalid');
        });
      }
    });
  }); // End forEach
};

/* harmony default export */ __webpack_exports__["a"] = (FormValidation);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)(__webpack_require__(47))

/***/ }),
/* 46 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = "/*! hyperform.js.org */\nvar hyperform = (function () {\n                       'use strict';\n\n                       /* the following code is borrowed from the WebComponents project, licensed\n                        * under the BSD license. Source:\n                        * <https://github.com/webcomponents/webcomponentsjs/blob/5283db1459fa2323e5bfc8b9b5cc1753ed85e3d0/src/WebComponents/dom.js#L53-L78>\n                        */\n                       // defaultPrevented is broken in IE.\n                       // https://connect.microsoft.com/IE/feedback/details/790389/event-defaultprevented-returns-false-after-preventdefault-was-called\n\n                       var workingDefaultPrevented = function () {\n                         var e = document.createEvent('Event');\n                         e.initEvent('foo', true, true);\n                         e.preventDefault();\n                         return e.defaultPrevented;\n                       }();\n\n                       if (!workingDefaultPrevented) {\n                         (function () {\n                           var origPreventDefault = window.Event.prototype.preventDefault;\n                           window.Event.prototype.preventDefault = function () {\n                             if (!this.cancelable) {\n                               return;\n                             }\n\n                             origPreventDefault.call(this);\n\n                             Object.defineProperty(this, 'defaultPrevented', {\n                               get: function get() {\n                                 return true;\n                               },\n                               configurable: true\n                             });\n                           };\n                         })();\n                       }\n                       /* end of borrowed code */\n\n                       function create_event(name) {\n                         var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n\n                         var _ref$bubbles = _ref.bubbles;\n                         var bubbles = _ref$bubbles === undefined ? true : _ref$bubbles;\n                         var _ref$cancelable = _ref.cancelable;\n                         var cancelable = _ref$cancelable === undefined ? false : _ref$cancelable;\n\n                         var event = document.createEvent('Event');\n                         event.initEvent(name, bubbles, cancelable);\n                         return event;\n                       }\n\n                       function trigger_event (element, event) {\n                         var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};\n\n                         var _ref2$bubbles = _ref2.bubbles;\n                         var bubbles = _ref2$bubbles === undefined ? true : _ref2$bubbles;\n                         var _ref2$cancelable = _ref2.cancelable;\n                         var cancelable = _ref2$cancelable === undefined ? false : _ref2$cancelable;\n                         var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};\n\n                         if (!(event instanceof window.Event)) {\n                           event = create_event(event, { bubbles: bubbles, cancelable: cancelable });\n                         }\n\n                         for (var key in payload) {\n                           if (payload.hasOwnProperty(key)) {\n                             event[key] = payload[key];\n                           }\n                         }\n\n                         element.dispatchEvent(event);\n\n                         return event;\n                       }\n\n                       /* shim layer for the Element.matches method */\n\n                       var ep = window.Element.prototype;\n                       var native_matches = ep.matches || ep.matchesSelector || ep.msMatchesSelector || ep.webkitMatchesSelector;\n\n                       function matches (element, selector) {\n                                              return native_matches.call(element, selector);\n                       }\n\n                       /**\n                        * mark an object with a '__hyperform=true' property\n                        *\n                        * We use this to distinguish our properties from the native ones. Usage:\n                        * js> mark(obj);\n                        * js> assert(obj.__hyperform === true)\n                        */\n\n                       function mark (obj) {\n                         if (['object', 'function'].indexOf(typeof obj) > -1) {\n                           delete obj.__hyperform;\n                           Object.defineProperty(obj, '__hyperform', {\n                             configurable: true,\n                             enumerable: false,\n                             value: true\n                           });\n                         }\n\n                         return obj;\n                       }\n\n                       /**\n                        * the internal storage for messages\n                        */\n                       var store = new WeakMap();\n\n                       /* jshint -W053 */ /* allow new String() */\n                       /**\n                        * handle validation messages\n                        *\n                        * Falls back to browser-native errors, if any are available. The messages\n                        * are String objects so that we can mark() them.\n                        */\n                       var message_store = {\n                         set: function set(element, message) {\n                           var is_custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;\n\n                           if (element instanceof window.HTMLFieldSetElement) {\n                             var wrapped_form = get_wrapper(element);\n                             if (wrapped_form && !wrapped_form.settings.extendFieldset) {\n                               /* make this a no-op for <fieldset> in strict mode */\n                               return message_store;\n                             }\n                           }\n\n                           if (typeof message === 'string') {\n                             message = new String(message);\n                           }\n                           if (is_custom) {\n                             message.is_custom = true;\n                           }\n                           mark(message);\n                           store.set(element, message);\n\n                           /* allow the :invalid selector to match */\n                           if ('_original_setCustomValidity' in element) {\n                             element._original_setCustomValidity(message.toString());\n                           }\n\n                           return message_store;\n                         },\n                         get: function get(element) {\n                           var message = store.get(element);\n                           if (message === undefined && '_original_validationMessage' in element) {\n                             /* get the browser's validation message, if we have none. Maybe it\n                              * knows more than we. */\n                             message = new String(element._original_validationMessage);\n                           }\n                           return message ? message : new String('');\n                         },\n                         delete: function _delete(element) {\n                           var is_custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n                           if ('_original_setCustomValidity' in element) {\n                             element._original_setCustomValidity('');\n                           }\n                           var message = store.get(element);\n                           if (message && is_custom && !message.is_custom) {\n                             /* do not delete \"native\" messages, if asked */\n                             return false;\n                           }\n                           return store.delete(element);\n                         }\n                       };\n\n                       /**\n                        * counter that will be incremented with every call\n                        *\n                        * Will enforce uniqueness, as long as no more than 1 hyperform scripts\n                        * are loaded. (In that case we still have the \"random\" part below.)\n                        */\n\n                       var uid = 0;\n\n                       /**\n                        * generate a random ID\n                        *\n                        * @see https://gist.github.com/gordonbrander/2230317\n                        */\n                       function generate_id () {\n                         var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hf_';\n\n                         return prefix + uid++ + Math.random().toString(36).substr(2);\n                       }\n\n                       /**\n                        * get all radio buttons (including `element`) that belong to element's\n                        * radio group\n                        */\n\n                       function get_radiogroup(element) {\n                         if (element.form) {\n                           return Array.prototype.filter.call(element.form.elements, function (radio) {\n                             return radio.type === 'radio' && radio.name === element.name;\n                           });\n                         }\n                         return [element];\n                       }\n\n                       var warningsCache = new WeakMap();\n\n                       var DefaultRenderer = {\n\n                         /**\n                          * called when a warning should become visible\n                          */\n                         attachWarning: function attachWarning(warning, element) {\n                           /* should also work, if element is last,\n                            * http://stackoverflow.com/a/4793630/113195 */\n                           element.parentNode.insertBefore(warning, element.nextSibling);\n                         },\n\n                         /**\n                          * called when a warning should vanish\n                          */\n                         detachWarning: function detachWarning(warning, element) {\n                           /* be conservative here, since an overwritten attachWarning() might not\n                            * actually have attached the warning. */\n                           if (warning.parentNode) {\n                             warning.parentNode.removeChild(warning);\n                           }\n                         },\n\n                         /**\n                          * called when feedback to an element's state should be handled\n                          *\n                          * i.e., showing and hiding warnings\n                          */\n                         showWarning: function showWarning(element) {\n                           var whole_form_validated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n                           /* don't render error messages on subsequent radio buttons of the\n                            * same group. This assumes, that element.validity.valueMissing is the only\n                            * possible validation failure for radio buttons. */\n                           if (whole_form_validated && element.type === 'radio' && get_radiogroup(element)[0] !== element) {\n                             return;\n                           }\n\n                           var msg = message_store.get(element).toString();\n                           var warning = warningsCache.get(element);\n\n                           if (msg) {\n                             if (!warning) {\n                               var wrapper = get_wrapper(element);\n                               warning = document.createElement('div');\n                               warning.className = wrapper && wrapper.settings.classes.warning || 'hf-warning';\n                               warning.id = generate_id();\n                               warning.setAttribute('aria-live', 'polite');\n                               warningsCache.set(element, warning);\n                             }\n\n                             element.setAttribute('aria-errormessage', warning.id);\n                             if (!element.hasAttribute('aria-describedby')) {\n                               element.setAttribute('aria-describedby', warning.id);\n                             }\n                             Renderer.setMessage(warning, msg, element);\n                             Renderer.attachWarning(warning, element);\n                           } else if (warning && warning.parentNode) {\n                             if (element.getAttribute('aria-describedby') === warning.id) {\n                               element.removeAttribute('aria-describedby');\n                             }\n                             element.removeAttribute('aria-errormessage');\n                             Renderer.detachWarning(warning, element);\n                           }\n                         },\n\n                         /**\n                          * set the warning's content\n                          *\n                          * Overwrite this method, if you want, e.g., to allow HTML in warnings\n                          * or preprocess the content.\n                          */\n                         setMessage: function setMessage(warning, message, element) {\n                           warning.textContent = message;\n                         }\n\n                       };\n\n                       var Renderer = {\n\n                         attachWarning: DefaultRenderer.attachWarning,\n                         detachWarning: DefaultRenderer.detachWarning,\n                         showWarning: DefaultRenderer.showWarning,\n                         setMessage: DefaultRenderer.setMessage,\n\n                         set: function set(renderer, action) {\n                           if (renderer.indexOf('_') > -1) {\n                             /* global console */\n                             // TODO delete before next non-patch version\n                             console.log('Renderer.set: please use camelCase names. ' + renderer + ' will be removed in the next non-patch release.');\n                             renderer = renderer.replace(/_([a-z])/g, function (g) {\n                               return g[1].toUpperCase();\n                             });\n                           }\n                           if (!action) {\n                             action = DefaultRenderer[renderer];\n                           }\n                           Renderer[renderer] = action;\n                         },\n\n                         getWarning: function getWarning(element) {\n                           return warningsCache.get(element);\n                         }\n\n                       };\n\n                       var registry = Object.create(null);\n\n                       /**\n                        * run all actions registered for a hook\n                        *\n                        * Every action gets called with a state object as `this` argument and with the\n                        * hook's call arguments as call arguments.\n                        *\n                        * @return mixed the returned value of the action calls or undefined\n                        */\n                       function call_hook(hook) {\n                         var result;\n                         var call_args = Array.prototype.slice.call(arguments, 1);\n\n                         if (hook in registry) {\n                           result = registry[hook].reduce(function (args) {\n\n                             return function (previousResult, currentAction) {\n                               var interimResult = currentAction.apply({\n                                 state: previousResult,\n                                 hook: hook\n                               }, args);\n                               return interimResult !== undefined ? interimResult : previousResult;\n                             };\n                           }(call_args), result);\n                         }\n\n                         return result;\n                       }\n\n                       /**\n                        * Filter a value through hooked functions\n                        *\n                        * Allows for additional parameters:\n                        * js> do_filter('foo', null, current_element)\n                        */\n                       function do_filter(hook, initial_value) {\n                         var result = initial_value;\n                         var call_args = Array.prototype.slice.call(arguments, 1);\n\n                         if (hook in registry) {\n                           result = registry[hook].reduce(function (previousResult, currentAction) {\n                             call_args[0] = previousResult;\n                             var interimResult = currentAction.apply({\n                               state: previousResult,\n                               hook: hook\n                             }, call_args);\n                             return interimResult !== undefined ? interimResult : previousResult;\n                           }, result);\n                         }\n\n                         return result;\n                       }\n\n                       /**\n                        * remove an action again\n                        */\n                       function remove_hook(hook, action) {\n                         if (hook in registry) {\n                           for (var i = 0; i < registry[hook].length; i++) {\n                             if (registry[hook][i] === action) {\n                               registry[hook].splice(i, 1);\n                               break;\n                             }\n                           }\n                         }\n                       }\n                       /**\n                        * add an action to a hook\n                        */\n                       function add_hook(hook, action, position) {\n                         if (!(hook in registry)) {\n                           registry[hook] = [];\n                         }\n                         if (position === undefined) {\n                           position = registry[hook].length;\n                         }\n                         registry[hook].splice(position, 0, action);\n                       }\n\n                       /* and datetime-local? Spec says “Nah!” */\n\n                       var dates = ['datetime', 'date', 'month', 'week', 'time'];\n\n                       var plain_numbers = ['number', 'range'];\n\n                       /* everything that returns something meaningful for valueAsNumber and\n                        * can have the step attribute */\n                       var numbers = dates.concat(plain_numbers, 'datetime-local');\n\n                       /* the spec says to only check those for syntax in validity.typeMismatch.\n                        * ¯\\_(ツ)_/¯ */\n                       var type_checked = ['email', 'url'];\n\n                       /* check these for validity.badInput */\n                       var input_checked = ['email', 'date', 'month', 'week', 'time', 'datetime', 'datetime-local', 'number', 'range', 'color'];\n\n                       var text_types = ['text', 'search', 'tel', 'password'].concat(type_checked);\n\n                       /* input element types, that are candidates for the validation API.\n                        * Missing from this set are: button, hidden, menu (from <button>), reset and\n                        * the types for non-<input> elements. */\n                       var validation_candidates = ['checkbox', 'color', 'file', 'image', 'radio', 'submit'].concat(numbers, text_types);\n\n                       /* all known types of <input> */\n                       var inputs = ['button', 'hidden', 'reset'].concat(validation_candidates);\n\n                       /* apparently <select> and <textarea> have types of their own */\n                       var non_inputs = ['select-one', 'select-multiple', 'textarea'];\n\n                       /**\n                        * get the element's type in a backwards-compatible way\n                        */\n                       function get_type (element) {\n                         if (element instanceof window.HTMLTextAreaElement) {\n                           return 'textarea';\n                         } else if (element instanceof window.HTMLSelectElement) {\n                           return element.hasAttribute('multiple') ? 'select-multiple' : 'select-one';\n                         } else if (element instanceof window.HTMLButtonElement) {\n                           return (element.getAttribute('type') || 'submit').toLowerCase();\n                         } else if (element instanceof window.HTMLInputElement) {\n                           var attr = (element.getAttribute('type') || '').toLowerCase();\n                           if (attr && inputs.indexOf(attr) > -1) {\n                             return attr;\n                           } else {\n                             /* perhaps the DOM has in-depth knowledge. Take that before returning\n                              * 'text'. */\n                             return element.type || 'text';\n                           }\n                         }\n\n                         return '';\n                       }\n\n                       /**\n                        * check if an element should be ignored due to any of its parents\n                        *\n                        * Checks <fieldset disabled> and <datalist>.\n                        */\n                       function is_in_disallowed_parent(element) {\n                         var p = element.parentNode;\n                         while (p && p.nodeType === 1) {\n                           if (p instanceof window.HTMLFieldSetElement && p.hasAttribute('disabled')) {\n                             /* quick return, if it's a child of a disabled fieldset */\n                             return true;\n                           } else if (p.nodeName.toUpperCase() === 'DATALIST') {\n                             /* quick return, if it's a child of a datalist\n                              * Do not use HTMLDataListElement to support older browsers,\n                              * too.\n                              * @see https://html.spec.whatwg.org/multipage/forms.html#the-datalist-element:barred-from-constraint-validation\n                              */\n                             return true;\n                           } else if (p === element.form) {\n                             /* the outer boundary. We can stop looking for relevant elements. */\n                             break;\n                           }\n                           p = p.parentNode;\n                         }\n                         return false;\n                       }\n\n                       /**\n                        * check if an element is a candidate for constraint validation\n                        *\n                        * @see https://html.spec.whatwg.org/multipage/forms.html#barred-from-constraint-validation\n                        */\n                       function is_validation_candidate (element) {\n\n                         /* allow a shortcut via filters, e.g. to validate type=hidden fields */\n                         var filtered = do_filter('is_validation_candidate', null, element);\n                         if (filtered !== null) {\n                           return !!filtered;\n                         }\n\n                         /* it must be any of those elements */\n                         if (element instanceof window.HTMLSelectElement || element instanceof window.HTMLTextAreaElement || element instanceof window.HTMLButtonElement || element instanceof window.HTMLInputElement) {\n\n                           var type = get_type(element);\n                           /* its type must be in the whitelist */\n                           if (non_inputs.indexOf(type) > -1 || validation_candidates.indexOf(type) > -1) {\n\n                             /* it mustn't be disabled or readonly */\n                             if (!element.hasAttribute('disabled') && !element.hasAttribute('readonly')) {\n\n                               var wrapped_form = get_wrapper(element);\n\n                               if (\n                               /* the parent form doesn't allow non-standard \"novalidate\" attributes... */\n                               wrapped_form && !wrapped_form.settings.novalidateOnElements ||\n                               /* ...or it doesn't have such an attribute/property */\n                               !element.hasAttribute('novalidate') && !element.noValidate) {\n\n                                 /* it isn't part of a <fieldset disabled> */\n                                 if (!is_in_disallowed_parent(element)) {\n\n                                   /* then it's a candidate */\n                                   return true;\n                                 }\n                               }\n                             }\n                           }\n                         }\n\n                         /* this is no HTML5 validation candidate... */\n                         return false;\n                       }\n\n                       function format_date (date) {\n                         var part = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;\n\n                         switch (part) {\n                           case 'date':\n                             return (date.toLocaleDateString || date.toDateString).call(date);\n                           case 'time':\n                             return (date.toLocaleTimeString || date.toTimeString).call(date);\n                           case 'month':\n                             return 'toLocaleDateString' in date ? date.toLocaleDateString(undefined, {\n                               year: 'numeric',\n                               month: '2-digit'\n                             }) : date.toDateString();\n                           // case 'week':\n                           // TODO\n                           default:\n                             return (date.toLocaleString || date.toString).call(date);\n                         }\n                       }\n\n                       function sprintf (str) {\n                         for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n                           args[_key - 1] = arguments[_key];\n                         }\n\n                         var args_length = args.length;\n                         var global_index = 0;\n\n                         return str.replace(/%([0-9]+\\$)?([sl])/g, function (match, position, type) {\n                           var local_index = global_index;\n                           if (position) {\n                             local_index = Number(position.replace(/\\$$/, '')) - 1;\n                           }\n                           global_index += 1;\n\n                           var arg = '';\n                           if (args_length > local_index) {\n                             arg = args[local_index];\n                           }\n\n                           if (arg instanceof Date || typeof arg === 'number' || arg instanceof Number) {\n                             /* try getting a localized representation of dates and numbers, if the\n                              * browser supports this */\n                             if (type === 'l') {\n                               arg = (arg.toLocaleString || arg.toString).call(arg);\n                             } else {\n                               arg = arg.toString();\n                             }\n                           }\n\n                           return arg;\n                         });\n                       }\n\n                       /* For a given date, get the ISO week number\n                        *\n                        * Source: http://stackoverflow.com/a/6117889/113195\n                        *\n                        * Based on information at:\n                        *\n                        *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR\n                        *\n                        * Algorithm is to find nearest thursday, it's year\n                        * is the year of the week number. Then get weeks\n                        * between that date and the first day of that year.\n                        *\n                        * Note that dates in one year can be weeks of previous\n                        * or next year, overlap is up to 3 days.\n                        *\n                        * e.g. 2014/12/29 is Monday in week  1 of 2015\n                        *      2012/1/1   is Sunday in week 52 of 2011\n                        */\n\n                       function get_week_of_year (d) {\n                         /* Copy date so don't modify original */\n                         d = new Date(+d);\n                         d.setUTCHours(0, 0, 0);\n                         /* Set to nearest Thursday: current date + 4 - current day number\n                          * Make Sunday's day number 7 */\n                         d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));\n                         /* Get first day of year */\n                         var yearStart = new Date(d.getUTCFullYear(), 0, 1);\n                         /* Calculate full weeks to nearest Thursday */\n                         var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);\n                         /* Return array of year and week number */\n                         return [d.getUTCFullYear(), weekNo];\n                       }\n\n                       function pad(num) {\n                         var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;\n\n                         var s = num + '';\n                         while (s.length < size) {\n                           s = '0' + s;\n                         }\n                         return s;\n                       }\n\n                       /**\n                        * calculate a string from a date according to HTML5\n                        */\n                       function date_to_string(date, element_type) {\n                         if (!(date instanceof Date)) {\n                           return null;\n                         }\n\n                         switch (element_type) {\n                           case 'datetime':\n                             return date_to_string(date, 'date') + 'T' + date_to_string(date, 'time');\n\n                           case 'datetime-local':\n                             return sprintf('%s-%s-%sT%s:%s:%s.%s', date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate()), pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds()), pad(date.getMilliseconds(), 3)).replace(/(:00)?\\.000$/, '');\n\n                           case 'date':\n                             return sprintf('%s-%s-%s', date.getUTCFullYear(), pad(date.getUTCMonth() + 1), pad(date.getUTCDate()));\n\n                           case 'month':\n                             return sprintf('%s-%s', date.getUTCFullYear(), pad(date.getUTCMonth() + 1));\n\n                           case 'week':\n                             var params = get_week_of_year(date);\n                             return sprintf.call(null, '%s-W%s', params[0], pad(params[1]));\n\n                           case 'time':\n                             return sprintf('%s:%s:%s.%s', pad(date.getUTCHours()), pad(date.getUTCMinutes()), pad(date.getUTCSeconds()), pad(date.getUTCMilliseconds(), 3)).replace(/(:00)?\\.000$/, '');\n                         }\n\n                         return null;\n                       }\n\n                       /**\n                        * return a new Date() representing the ISO date for a week number\n                        *\n                        * @see http://stackoverflow.com/a/16591175/113195\n                        */\n\n                       function get_date_from_week (week, year) {\n                         var date = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));\n\n                         if (date.getUTCDay() <= 4 /* thursday */) {\n                             date.setUTCDate(date.getUTCDate() - date.getUTCDay() + 1);\n                           } else {\n                           date.setUTCDate(date.getUTCDate() + 8 - date.getUTCDay());\n                         }\n\n                         return date;\n                       }\n\n                       /**\n                        * calculate a date from a string according to HTML5\n                        */\n                       function string_to_date (string, element_type) {\n                         var date = new Date(0);\n                         var ms;\n                         switch (element_type) {\n                           case 'datetime':\n                             if (!/^([0-9]{4,})-([0-9]{2})-([0-9]{2})T([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\\.([0-9]{1,3}))?)?$/.test(string)) {\n                               return null;\n                             }\n                             ms = RegExp.$7 || '000';\n                             while (ms.length < 3) {\n                               ms += '0';\n                             }\n                             date.setUTCFullYear(Number(RegExp.$1));\n                             date.setUTCMonth(Number(RegExp.$2) - 1, Number(RegExp.$3));\n                             date.setUTCHours(Number(RegExp.$4), Number(RegExp.$5), Number(RegExp.$6 || 0), Number(ms));\n                             return date;\n\n                           case 'date':\n                             if (!/^([0-9]{4,})-([0-9]{2})-([0-9]{2})$/.test(string)) {\n                               return null;\n                             }\n                             date.setUTCFullYear(Number(RegExp.$1));\n                             date.setUTCMonth(Number(RegExp.$2) - 1, Number(RegExp.$3));\n                             return date;\n\n                           case 'month':\n                             if (!/^([0-9]{4,})-([0-9]{2})$/.test(string)) {\n                               return null;\n                             }\n                             date.setUTCFullYear(Number(RegExp.$1));\n                             date.setUTCMonth(Number(RegExp.$2) - 1, 1);\n                             return date;\n\n                           case 'week':\n                             if (!/^([0-9]{4,})-W(0[1-9]|[1234][0-9]|5[0-3])$/.test(string)) {\n                               return null;\n                             }\n                             return get_date_from_week(Number(RegExp.$2), Number(RegExp.$1));\n\n                           case 'time':\n                             if (!/^([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\\.([0-9]{1,3}))?)?$/.test(string)) {\n                               return null;\n                             }\n                             ms = RegExp.$4 || '000';\n                             while (ms.length < 3) {\n                               ms += '0';\n                             }\n                             date.setUTCHours(Number(RegExp.$1), Number(RegExp.$2), Number(RegExp.$3 || 0), Number(ms));\n                             return date;\n                         }\n\n                         return null;\n                       }\n\n                       /**\n                        * calculate a date from a string according to HTML5\n                        */\n                       function string_to_number (string, element_type) {\n                         var rval = string_to_date(string, element_type);\n                         if (rval !== null) {\n                           return +rval;\n                         }\n                         /* not parseFloat, because we want NaN for invalid values like \"1.2xxy\" */\n                         return Number(string);\n                       }\n\n                       /**\n                        * the following validation messages are from Firefox source,\n                        * http://mxr.mozilla.org/mozilla-central/source/dom/locales/en-US/chrome/dom/dom.properties\n                        * released under MPL license, http://mozilla.org/MPL/2.0/.\n                        */\n\n                       var catalog = {\n                         en: {\n                           TextTooLong: 'Please shorten this text to %l characters or less (you are currently using %l characters).',\n                           ValueMissing: 'Please fill out this field.',\n                           CheckboxMissing: 'Please check this box if you want to proceed.',\n                           RadioMissing: 'Please select one of these options.',\n                           FileMissing: 'Please select a file.',\n                           SelectMissing: 'Please select an item in the list.',\n                           InvalidEmail: 'Please enter an email address.',\n                           InvalidURL: 'Please enter a URL.',\n                           PatternMismatch: 'Please match the requested format.',\n                           PatternMismatchWithTitle: 'Please match the requested format: %l.',\n                           NumberRangeOverflow: 'Please select a value that is no more than %l.',\n                           DateRangeOverflow: 'Please select a value that is no later than %l.',\n                           TimeRangeOverflow: 'Please select a value that is no later than %l.',\n                           NumberRangeUnderflow: 'Please select a value that is no less than %l.',\n                           DateRangeUnderflow: 'Please select a value that is no earlier than %l.',\n                           TimeRangeUnderflow: 'Please select a value that is no earlier than %l.',\n                           StepMismatch: 'Please select a valid value. The two nearest valid values are %l and %l.',\n                           StepMismatchOneValue: 'Please select a valid value. The nearest valid value is %l.',\n                           BadInputNumber: 'Please enter a number.'\n                         }\n                       };\n\n                       /**\n                        * the global language Hyperform will use\n                        */\n                       var language = 'en';\n\n                       /**\n                        * the base language according to BCP47, i.e., only the piece before the first hyphen\n                        */\n                       var base_lang = 'en';\n\n                       /**\n                        * set the language for Hyperform’s messages\n                        */\n                       function set_language(newlang) {\n                         language = newlang;\n                         base_lang = newlang.replace(/[-_].*/, '');\n                       }\n\n                       /**\n                        * add a lookup catalog \"string: translation\" for a language\n                        */\n                       function add_translation(lang, new_catalog) {\n                         if (!(lang in catalog)) {\n                           catalog[lang] = {};\n                         }\n                         for (var key in new_catalog) {\n                           if (new_catalog.hasOwnProperty(key)) {\n                             catalog[lang][key] = new_catalog[key];\n                           }\n                         }\n                       }\n\n                       /**\n                        * return `s` translated into the current language\n                        *\n                        * Defaults to the base language and then English if the former has no\n                        * translation for `s`.\n                        */\n                       function _ (s) {\n                         if (language in catalog && s in catalog[language]) {\n                           return catalog[language][s];\n                         } else if (base_lang in catalog && s in catalog[base_lang]) {\n                           return catalog[base_lang][s];\n                         } else if (s in catalog.en) {\n                           return catalog.en[s];\n                         }\n                         return s;\n                       }\n\n                       var default_step = {\n                         'datetime-local': 60,\n                         datetime: 60,\n                         time: 60\n                       };\n\n                       var step_scale_factor = {\n                         'datetime-local': 1000,\n                         datetime: 1000,\n                         date: 86400000,\n                         week: 604800000,\n                         time: 1000\n                       };\n\n                       var default_step_base = {\n                         week: -259200000\n                       };\n\n                       var default_min = {\n                         range: 0\n                       };\n\n                       var default_max = {\n                         range: 100\n                       };\n\n                       /**\n                        * get previous and next valid values for a stepped input element\n                        */\n                       function get_next_valid (element) {\n                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;\n\n                         var type = get_type(element);\n\n                         var aMin = element.getAttribute('min');\n                         var min = default_min[type] || NaN;\n                         if (aMin) {\n                           var pMin = string_to_number(aMin, type);\n                           if (!isNaN(pMin)) {\n                             min = pMin;\n                           }\n                         }\n\n                         var aMax = element.getAttribute('max');\n                         var max = default_max[type] || NaN;\n                         if (aMax) {\n                           var pMax = string_to_number(aMax, type);\n                           if (!isNaN(pMax)) {\n                             max = pMax;\n                           }\n                         }\n\n                         var aStep = element.getAttribute('step');\n                         var step = default_step[type] || 1;\n                         if (aStep && aStep.toLowerCase() === 'any') {\n                           /* quick return: we cannot calculate prev and next */\n                           return [_('any value'), _('any value')];\n                         } else if (aStep) {\n                           var pStep = string_to_number(aStep, type);\n                           if (!isNaN(pStep)) {\n                             step = pStep;\n                           }\n                         }\n\n                         var default_value = string_to_number(element.getAttribute('value'), type);\n\n                         var value = string_to_number(element.value || element.getAttribute('value'), type);\n\n                         if (isNaN(value)) {\n                           /* quick return: we cannot calculate without a solid base */\n                           return [_('any valid value'), _('any valid value')];\n                         }\n\n                         var step_base = !isNaN(min) ? min : !isNaN(default_value) ? default_value : default_step_base[type] || 0;\n\n                         var scale = step_scale_factor[type] || 1;\n\n                         var prev = step_base + Math.floor((value - step_base) / (step * scale)) * (step * scale) * n;\n                         var next = step_base + (Math.floor((value - step_base) / (step * scale)) + 1) * (step * scale) * n;\n\n                         if (prev < min) {\n                           prev = null;\n                         } else if (prev > max) {\n                           prev = max;\n                         }\n\n                         if (next > max) {\n                           next = null;\n                         } else if (next < min) {\n                           next = min;\n                         }\n\n                         /* convert to date objects, if appropriate */\n                         if (dates.indexOf(type) > -1) {\n                           prev = date_to_string(new Date(prev), type);\n                           next = date_to_string(new Date(next), type);\n                         }\n\n                         return [prev, next];\n                       }\n\n                       /**\n                        * patch String.length to account for non-BMP characters\n                        *\n                        * @see https://mathiasbynens.be/notes/javascript-unicode\n                        * We do not use the simple [...str].length, because it needs a ton of\n                        * polyfills in older browsers.\n                        */\n\n                       function unicode_string_length (str) {\n                         return str.match(/[\\0-\\uD7FF\\uE000-\\uFFFF]|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]|[\\uD800-\\uDBFF](?![\\uDC00-\\uDFFF])|(?:[^\\uD800-\\uDBFF]|^)[\\uDC00-\\uDFFF]/g).length;\n                       }\n\n                       /**\n                        * internal storage for custom error messages\n                        */\n\n                       var store$1 = new WeakMap();\n\n                       /**\n                        * register custom error messages per element\n                        */\n                       var custom_messages = {\n                         set: function set(element, validator, message) {\n                           var messages = store$1.get(element) || {};\n                           messages[validator] = message;\n                           store$1.set(element, messages);\n                           return custom_messages;\n                         },\n                         get: function get(element, validator) {\n                           var _default = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;\n\n                           var messages = store$1.get(element);\n                           if (messages === undefined || !(validator in messages)) {\n                             var data_id = 'data-' + validator.replace(/[A-Z]/g, '-$&').toLowerCase();\n                             if (element.hasAttribute(data_id)) {\n                               /* if the element has a data-validator attribute, use this as fallback.\n                                * E.g., if validator == 'valueMissing', the element can specify a\n                                * custom validation message like this:\n                                *     <input data-value-missing=\"Oh noes!\">\n                                */\n                               return element.getAttribute(data_id);\n                             }\n                             return _default;\n                           }\n                           return messages[validator];\n                         },\n                         delete: function _delete(element) {\n                           var validator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;\n\n                           if (!validator) {\n                             return store$1.delete(element);\n                           }\n                           var messages = store$1.get(element) || {};\n                           if (validator in messages) {\n                             delete messages[validator];\n                             store$1.set(element, messages);\n                             return true;\n                           }\n                           return false;\n                         }\n                       };\n\n                       var internal_registry = new WeakMap();\n\n                       /**\n                        * A registry for custom validators\n                        *\n                        * slim wrapper around a WeakMap to ensure the values are arrays\n                        * (hence allowing > 1 validators per element)\n                        */\n                       var custom_validator_registry = {\n                         set: function set(element, validator) {\n                           var current = internal_registry.get(element) || [];\n                           current.push(validator);\n                           internal_registry.set(element, current);\n                           return custom_validator_registry;\n                         },\n                         get: function get(element) {\n                           return internal_registry.get(element) || [];\n                         },\n                         delete: function _delete(element) {\n                           return internal_registry.delete(element);\n                         }\n                       };\n\n                       /**\n                        * test whether the element suffers from bad input\n                        */\n                       function test_bad_input (element) {\n                         var type = get_type(element);\n\n                         if (input_checked.indexOf(type) === -1) {\n                           /* we're not interested, thanks! */\n                           return true;\n                         }\n\n                         /* the browser hides some bad input from the DOM, e.g. malformed numbers,\n                          * email addresses with invalid punycode representation, ... We try to resort\n                          * to the original method here. The assumption is, that a browser hiding\n                          * bad input will hopefully also always support a proper\n                          * ValidityState.badInput */\n                         if (!element.value) {\n                           if ('_original_validity' in element && !element._original_validity.__hyperform) {\n                             return !element._original_validity.badInput;\n                           }\n                           /* no value and no original badInput: Assume all's right. */\n                           return true;\n                         }\n\n                         var result = true;\n                         switch (type) {\n                           case 'color':\n                             result = /^#[a-f0-9]{6}$/.test(element.value);\n                             break;\n                           case 'number':\n                           case 'range':\n                             result = !isNaN(Number(element.value));\n                             break;\n                           case 'datetime':\n                           case 'date':\n                           case 'month':\n                           case 'week':\n                           case 'time':\n                             result = string_to_date(element.value, type) !== null;\n                             break;\n                           case 'datetime-local':\n                             result = /^([0-9]{4,})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\\.([0-9]{1,3}))?)?$/.test(element.value);\n                             break;\n                           case 'tel':\n                             /* spec says No! Phone numbers can have all kinds of formats, so this\n                              * is expected to be a free-text field. */\n                             // TODO we could allow a setting 'phone_regex' to be evaluated here.\n                             break;\n                           case 'email':\n                             break;\n                         }\n\n                         return result;\n                       }\n\n                       /**\n                        * test the max attribute\n                        *\n                        * we use Number() instead of parseFloat(), because an invalid attribute\n                        * value like \"123abc\" should result in an error.\n                        */\n                       function test_max (element) {\n                         var type = get_type(element);\n\n                         if (!element.value || !element.hasAttribute('max')) {\n                           /* we're not responsible here */\n                           return true;\n                         }\n\n                         var value = void 0,\n                             max = void 0;\n                         if (dates.indexOf(type) > -1) {\n                           value = 1 * string_to_date(element.value, type);\n                           max = 1 * (string_to_date(element.getAttribute('max'), type) || NaN);\n                         } else {\n                           value = Number(element.value);\n                           max = Number(element.getAttribute('max'));\n                         }\n\n                         return isNaN(max) || value <= max;\n                       }\n\n                       /**\n                        * test the maxlength attribute\n                        */\n                       function test_maxlength (element) {\n                         if (!element.value || text_types.indexOf(get_type(element)) === -1 || !element.hasAttribute('maxlength') || !element.getAttribute('maxlength') // catch maxlength=\"\"\n                         ) {\n                             return true;\n                           }\n\n                         var maxlength = parseInt(element.getAttribute('maxlength'), 10);\n\n                         /* check, if the maxlength value is usable at all.\n                          * We allow maxlength === 0 to basically disable input (Firefox does, too).\n                          */\n                         if (isNaN(maxlength) || maxlength < 0) {\n                           return true;\n                         }\n\n                         return unicode_string_length(element.value) <= maxlength;\n                       }\n\n                       /**\n                        * test the min attribute\n                        *\n                        * we use Number() instead of parseFloat(), because an invalid attribute\n                        * value like \"123abc\" should result in an error.\n                        */\n                       function test_min (element) {\n                         var type = get_type(element);\n\n                         if (!element.value || !element.hasAttribute('min')) {\n                           /* we're not responsible here */\n                           return true;\n                         }\n\n                         var value = void 0,\n                             min = void 0;\n                         if (dates.indexOf(type) > -1) {\n                           value = 1 * string_to_date(element.value, type);\n                           min = 1 * (string_to_date(element.getAttribute('min'), type) || NaN);\n                         } else {\n                           value = Number(element.value);\n                           min = Number(element.getAttribute('min'));\n                         }\n\n                         return isNaN(min) || value >= min;\n                       }\n\n                       /**\n                        * test the minlength attribute\n                        */\n                       function test_minlength (element) {\n                         if (!element.value || text_types.indexOf(get_type(element)) === -1 || !element.hasAttribute('minlength') || !element.getAttribute('minlength') // catch minlength=\"\"\n                         ) {\n                             return true;\n                           }\n\n                         var minlength = parseInt(element.getAttribute('minlength'), 10);\n\n                         /* check, if the minlength value is usable at all. */\n                         if (isNaN(minlength) || minlength < 0) {\n                           return true;\n                         }\n\n                         return unicode_string_length(element.value) >= minlength;\n                       }\n\n                       /**\n                        * test the pattern attribute\n                        */\n\n                       function test_pattern (element) {\n                           return !element.value || !element.hasAttribute('pattern') || new RegExp('^(?:' + element.getAttribute('pattern') + ')$').test(element.value);\n                       }\n\n                       function has_submittable_option(select) {\n                         return Array.prototype.some.call(select.options, function (option) {\n                           return option.selected && !option.disabled;\n                         });\n                       }\n\n                       /**\n                        * test the required attribute\n                        */\n                       function test_required (element) {\n                         if (element.type === 'radio') {\n                           /* the happy (and quick) path for radios: */\n                           if (element.hasAttribute('required') && element.checked) {\n                             return true;\n                           }\n\n                           var radiogroup = get_radiogroup(element);\n\n                           /* if any radio in the group is required, we need any (not necessarily the\n                            * same) radio to be checked */\n                           if (radiogroup.some(function (radio) {\n                             return radio.hasAttribute('required');\n                           })) {\n                             return radiogroup.some(function (radio) {\n                               return radio.checked;\n                             });\n                           }\n                           /* not required, validation passes */\n                           return true;\n                         }\n\n                         if (!element.hasAttribute('required')) {\n                           /* nothing to do */\n                           return true;\n                         }\n\n                         if (element instanceof window.HTMLSelectElement) {\n                           return has_submittable_option(element);\n                         }\n\n                         return element.type === 'checkbox' ? element.checked : !!element.value;\n                       }\n\n                       /**\n                        * test the step attribute\n                        */\n                       function test_step (element) {\n                         var type = get_type(element);\n\n                         if (!element.value || numbers.indexOf(type) === -1 || (element.getAttribute('step') || '').toLowerCase() === 'any') {\n                           /* we're not responsible here. Note: If no step attribute is given, we\n                            * need to validate against the default step as per spec. */\n                           return true;\n                         }\n\n                         var step = element.getAttribute('step');\n                         if (step) {\n                           step = string_to_number(step, type);\n                         } else {\n                           step = default_step[type] || 1;\n                         }\n\n                         if (step <= 0 || isNaN(step)) {\n                           /* error in specified \"step\". We cannot validate against it, so the value\n                            * is true. */\n                           return true;\n                         }\n\n                         var scale = step_scale_factor[type] || 1;\n\n                         var value = string_to_number(element.value, type);\n                         var min = string_to_number(element.getAttribute('min') || element.getAttribute('value') || '', type);\n\n                         if (isNaN(min)) {\n                           min = default_step_base[type] || 0;\n                         }\n\n                         if (type === 'month') {\n                           /* type=month has month-wide steps. See\n                            * https://html.spec.whatwg.org/multipage/forms.html#month-state-%28type=month%29\n                            */\n                           min = new Date(min).getUTCFullYear() * 12 + new Date(min).getUTCMonth();\n                           value = new Date(value).getUTCFullYear() * 12 + new Date(value).getUTCMonth();\n                         }\n\n                         var result = Math.abs(min - value) % (step * scale);\n\n                         return result < 0.00000001 ||\n                         /* crappy floating-point arithmetics! */\n                         result > step * scale - 0.00000001;\n                       }\n\n                       var ws_on_start_or_end = /^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g;\n\n                       /**\n                        * trim a string of whitespace\n                        *\n                        * We don't use String.trim() to remove the need to polyfill it.\n                        */\n                       function trim (str) {\n                         return str.replace(ws_on_start_or_end, '');\n                       }\n\n                       /**\n                        * split a string on comma and trim the components\n                        *\n                        * As specified at\n                        * https://html.spec.whatwg.org/multipage/infrastructure.html#split-a-string-on-commas\n                        * plus removing empty entries.\n                        */\n                       function comma_split (str) {\n                         return str.split(',').map(function (item) {\n                           return trim(item);\n                         }).filter(function (b) {\n                           return b;\n                         });\n                       }\n\n                       /* we use a dummy <a> where we set the href to test URL validity\n                        * The definition is out of the \"global\" scope so that JSDOM can be instantiated\n                        * after loading Hyperform for tests.\n                        */\n                       var url_canary;\n\n                       /* see https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address */\n                       var email_pattern = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;\n\n                       /**\n                        * test the type-inherent syntax\n                        */\n                       function test_type (element) {\n                         var type = get_type(element);\n\n                         if (type !== 'file' && !element.value || type !== 'file' && type_checked.indexOf(type) === -1) {\n                           /* we're not responsible for this element */\n                           return true;\n                         }\n\n                         var is_valid = true;\n\n                         switch (type) {\n                           case 'url':\n                             if (!url_canary) {\n                               url_canary = document.createElement('a');\n                             }\n                             var value = trim(element.value);\n                             url_canary.href = value;\n                             is_valid = url_canary.href === value || url_canary.href === value + '/';\n                             break;\n                           case 'email':\n                             if (element.hasAttribute('multiple')) {\n                               is_valid = comma_split(element.value).every(function (value) {\n                                 return email_pattern.test(value);\n                               });\n                             } else {\n                               is_valid = email_pattern.test(trim(element.value));\n                             }\n                             break;\n                           case 'file':\n                             if ('files' in element && element.files.length && element.hasAttribute('accept')) {\n                               var patterns = comma_split(element.getAttribute('accept')).map(function (pattern) {\n                                 if (/^(audio|video|image)\\/\\*$/.test(pattern)) {\n                                   pattern = new RegExp('^' + RegExp.$1 + '/.+$');\n                                 }\n                                 return pattern;\n                               });\n\n                               if (!patterns.length) {\n                                 break;\n                               }\n\n                               fileloop: for (var i = 0; i < element.files.length; i++) {\n                                 /* we need to match a whitelist, so pre-set with false */\n                                 var file_valid = false;\n\n                                 patternloop: for (var j = 0; j < patterns.length; j++) {\n                                   var file = element.files[i];\n                                   var pattern = patterns[j];\n\n                                   var fileprop = file.type;\n\n                                   if (typeof pattern === 'string' && pattern.substr(0, 1) === '.') {\n                                     if (file.name.search('.') === -1) {\n                                       /* no match with any file ending */\n                                       continue patternloop;\n                                     }\n\n                                     fileprop = file.name.substr(file.name.lastIndexOf('.'));\n                                   }\n\n                                   if (fileprop.search(pattern) === 0) {\n                                     /* we found one match and can quit looking */\n                                     file_valid = true;\n                                     break patternloop;\n                                   }\n                                 }\n\n                                 if (!file_valid) {\n                                   is_valid = false;\n                                   break fileloop;\n                                 }\n                               }\n                             }\n                         }\n\n                         return is_valid;\n                       }\n\n                       /**\n                        * boilerplate function for all tests but customError\n                        */\n                       function check$1(test, react) {\n                         return function (element) {\n                           var invalid = !test(element);\n                           if (invalid) {\n                             react(element);\n                           }\n                           return invalid;\n                         };\n                       }\n\n                       /**\n                        * create a common function to set error messages\n                        */\n                       function set_msg(element, msgtype, _default) {\n                         message_store.set(element, custom_messages.get(element, msgtype, _default));\n                       }\n\n                       var badInput = check$1(test_bad_input, function (element) {\n                         return set_msg(element, 'badInput', _('Please match the requested type.'));\n                       });\n\n                       function customError(element) {\n                         /* prevent infinite loops when the custom validators call setCustomValidity(),\n                          * which in turn calls this code again. We check, if there is an already set\n                          * custom validity message there. */\n                         if (element.__hf_custom_validation_running) {\n                           var msg = message_store.get(element);\n                           return msg && msg.is_custom;\n                         }\n\n                         /* check, if there are custom validators in the registry, and call\n                          * them. */\n                         var custom_validators = custom_validator_registry.get(element);\n                         var cvl = custom_validators.length;\n                         var valid = true;\n\n                         if (cvl) {\n                           element.__hf_custom_validation_running = true;\n                           for (var i = 0; i < cvl; i++) {\n                             var result = custom_validators[i](element);\n                             if (result !== undefined && !result) {\n                               valid = false;\n                               /* break on first invalid response */\n                               break;\n                             }\n                           }\n                           delete element.__hf_custom_validation_running;\n                         }\n\n                         /* check, if there are other validity messages already */\n                         if (valid) {\n                           var _msg = message_store.get(element);\n                           valid = !(_msg.toString() && 'is_custom' in _msg);\n                         }\n\n                         return !valid;\n                       }\n\n                       var patternMismatch = check$1(test_pattern, function (element) {\n                         set_msg(element, 'patternMismatch', element.title ? sprintf(_('PatternMismatchWithTitle'), element.title) : _('PatternMismatch'));\n                       });\n\n                       /**\n                        * TODO: when rangeOverflow and rangeUnderflow are both called directly and\n                        * successful, the inRange and outOfRange classes won't get removed, unless\n                        * element.validityState.valid is queried, too.\n                        */\n                       var rangeOverflow = check$1(test_max, function (element) {\n                         var type = get_type(element);\n                         var wrapper = get_wrapper(element);\n                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';\n                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';\n\n                         var msg = void 0;\n\n                         switch (type) {\n                           case 'date':\n                           case 'datetime':\n                           case 'datetime-local':\n                             msg = sprintf(_('DateRangeOverflow'), format_date(string_to_date(element.getAttribute('max'), type), type));\n                             break;\n                           case 'time':\n                             msg = sprintf(_('TimeRangeOverflow'), format_date(string_to_date(element.getAttribute('max'), type), type));\n                             break;\n                           // case 'number':\n                           default:\n                             msg = sprintf(_('NumberRangeOverflow'), string_to_number(element.getAttribute('max'), type));\n                             break;\n                         }\n\n                         set_msg(element, 'rangeOverflow', msg);\n                         element.classList.add(outOfRangeClass);\n                         element.classList.remove(inRangeClass);\n                       });\n\n                       var rangeUnderflow = check$1(test_min, function (element) {\n                         var type = get_type(element);\n                         var wrapper = get_wrapper(element);\n                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';\n                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';\n\n                         var msg = void 0;\n\n                         switch (type) {\n                           case 'date':\n                           case 'datetime':\n                           case 'datetime-local':\n                             msg = sprintf(_('DateRangeUnderflow'), format_date(string_to_date(element.getAttribute('min'), type), type));\n                             break;\n                           case 'time':\n                             msg = sprintf(_('TimeRangeUnderflow'), format_date(string_to_date(element.getAttribute('min'), type), type));\n                             break;\n                           // case 'number':\n                           default:\n                             msg = sprintf(_('NumberRangeUnderflow'), string_to_number(element.getAttribute('min'), type));\n                             break;\n                         }\n\n                         set_msg(element, 'rangeUnderflow', msg);\n                         element.classList.add(outOfRangeClass);\n                         element.classList.remove(inRangeClass);\n                       });\n\n                       var stepMismatch = check$1(test_step, function (element) {\n                         var list = get_next_valid(element);\n                         var min = list[0];\n                         var max = list[1];\n                         var sole = false;\n                         var msg = void 0;\n\n                         if (min === null) {\n                           sole = max;\n                         } else if (max === null) {\n                           sole = min;\n                         }\n\n                         if (sole !== false) {\n                           msg = sprintf(_('StepMismatchOneValue'), sole);\n                         } else {\n                           msg = sprintf(_('StepMismatch'), min, max);\n                         }\n                         set_msg(element, 'stepMismatch', msg);\n                       });\n\n                       var tooLong = check$1(test_maxlength, function (element) {\n                         set_msg(element, 'tooLong', sprintf(_('TextTooLong'), element.getAttribute('maxlength'), unicode_string_length(element.value)));\n                       });\n\n                       var tooShort = check$1(test_minlength, function (element) {\n                         set_msg(element, 'tooShort', sprintf(_('Please lengthen this text to %l characters or more (you are currently using %l characters).'), element.getAttribute('minlength'), unicode_string_length(element.value)));\n                       });\n\n                       var typeMismatch = check$1(test_type, function (element) {\n                         var msg = _('Please use the appropriate format.');\n                         var type = get_type(element);\n\n                         if (type === 'email') {\n                           if (element.hasAttribute('multiple')) {\n                             msg = _('Please enter a comma separated list of email addresses.');\n                           } else {\n                             msg = _('InvalidEmail');\n                           }\n                         } else if (type === 'url') {\n                           msg = _('InvalidURL');\n                         } else if (type === 'file') {\n                           msg = _('Please select a file of the correct type.');\n                         }\n\n                         set_msg(element, 'typeMismatch', msg);\n                       });\n\n                       var valueMissing = check$1(test_required, function (element) {\n                         var msg = _('ValueMissing');\n                         var type = get_type(element);\n\n                         if (type === 'checkbox') {\n                           msg = _('CheckboxMissing');\n                         } else if (type === 'radio') {\n                           msg = _('RadioMissing');\n                         } else if (type === 'file') {\n                           if (element.hasAttribute('multiple')) {\n                             msg = _('Please select one or more files.');\n                           } else {\n                             msg = _('FileMissing');\n                           }\n                         } else if (element instanceof window.HTMLSelectElement) {\n                           msg = _('SelectMissing');\n                         }\n\n                         set_msg(element, 'valueMissing', msg);\n                       });\n\n                       /**\n                        * the \"valid\" property calls all other validity checkers and returns true,\n                        * if all those return false.\n                        *\n                        * This is the major access point for _all_ other API methods, namely\n                        * (check|report)Validity().\n                        */\n                       var valid = function valid(element) {\n                         var wrapper = get_wrapper(element);\n                         var validClass = wrapper && wrapper.settings.classes.valid || 'hf-valid';\n                         var invalidClass = wrapper && wrapper.settings.classes.invalid || 'hf-invalid';\n                         var userInvalidClass = wrapper && wrapper.settings.classes.userInvalid || 'hf-user-invalid';\n                         var userValidClass = wrapper && wrapper.settings.classes.userValid || 'hf-user-valid';\n                         var inRangeClass = wrapper && wrapper.settings.classes.inRange || 'hf-in-range';\n                         var outOfRangeClass = wrapper && wrapper.settings.classes.outOfRange || 'hf-out-of-range';\n                         var validatedClass = wrapper && wrapper.settings.classes.validated || 'hf-validated';\n\n                         element.classList.add(validatedClass);\n\n                         var _arr = [badInput, customError, patternMismatch, rangeOverflow, rangeUnderflow, stepMismatch, tooLong, tooShort, typeMismatch, valueMissing];\n                         for (var _i = 0; _i < _arr.length; _i++) {\n                           var checker = _arr[_i];\n                           if (checker(element)) {\n                             element.classList.add(invalidClass);\n                             element.classList.remove(validClass);\n                             element.classList.remove(userValidClass);\n                             if (element.value !== element.defaultValue) {\n                               element.classList.add(userInvalidClass);\n                             } else {\n                               element.classList.remove(userInvalidClass);\n                             }\n                             element.setAttribute('aria-invalid', 'true');\n                             return false;\n                           }\n                         }\n\n                         message_store.delete(element);\n                         element.classList.remove(invalidClass);\n                         element.classList.remove(userInvalidClass);\n                         element.classList.remove(outOfRangeClass);\n                         element.classList.add(validClass);\n                         element.classList.add(inRangeClass);\n                         if (element.value !== element.defaultValue) {\n                           element.classList.add(userValidClass);\n                         } else {\n                           element.classList.remove(userValidClass);\n                         }\n                         element.setAttribute('aria-invalid', 'false');\n                         return true;\n                       };\n\n                       var validity_state_checkers = {\n                         badInput: badInput,\n                         customError: customError,\n                         patternMismatch: patternMismatch,\n                         rangeOverflow: rangeOverflow,\n                         rangeUnderflow: rangeUnderflow,\n                         stepMismatch: stepMismatch,\n                         tooLong: tooLong,\n                         tooShort: tooShort,\n                         typeMismatch: typeMismatch,\n                         valueMissing: valueMissing,\n                         valid: valid\n                       };\n\n                       /**\n                        * the validity state constructor\n                        */\n                       var ValidityState = function ValidityState(element) {\n                         if (!(element instanceof window.HTMLElement)) {\n                           throw new Error('cannot create a ValidityState for a non-element');\n                         }\n\n                         var cached = ValidityState.cache.get(element);\n                         if (cached) {\n                           return cached;\n                         }\n\n                         if (!(this instanceof ValidityState)) {\n                           /* working around a forgotten `new` */\n                           return new ValidityState(element);\n                         }\n\n                         this.element = element;\n                         ValidityState.cache.set(element, this);\n                       };\n\n                       /**\n                        * the prototype for new validityState instances\n                        */\n                       var ValidityStatePrototype = {};\n                       ValidityState.prototype = ValidityStatePrototype;\n\n                       ValidityState.cache = new WeakMap();\n\n                       /* small wrapper around the actual validator to check if the validator\n                        * should actually be called. `this` refers to the ValidityState object. */\n                       var checker_getter = function checker_getter(func) {\n                         return function () {\n                           if (!is_validation_candidate(this.element)) {\n                             /* not being validated == valid by default */\n                             return true;\n                           }\n                           return func(this.element);\n                         };\n                       };\n\n                       /**\n                        * copy functionality from the validity checkers to the ValidityState\n                        * prototype\n                        */\n                       for (var prop in validity_state_checkers) {\n                         Object.defineProperty(ValidityStatePrototype, prop, {\n                           configurable: true,\n                           enumerable: true,\n                           get: checker_getter(validity_state_checkers[prop]),\n                           set: undefined\n                         });\n                       }\n\n                       /**\n                        * mark the validity prototype, because that is what the client-facing\n                        * code deals with mostly, not the property descriptor thing */\n                       mark(ValidityStatePrototype);\n\n                       /**\n                        * check element's validity and report an error back to the user\n                        */\n                       function reportValidity(element) {\n                         /* if this is a <form>, report validity of all child inputs */\n                         if (element instanceof window.HTMLFormElement) {\n                           element.__hf_form_validation = true;\n                           var form_valid = get_validated_elements(element).map(reportValidity).every(function (b) {\n                             return b;\n                           });\n                           delete element.__hf_form_validation;\n                           return form_valid;\n                         }\n\n                         /* we copy checkValidity() here, b/c we have to check if the \"invalid\"\n                          * event was canceled. */\n                         var valid = ValidityState(element).valid;\n                         var event;\n                         if (valid) {\n                           var wrapped_form = get_wrapper(element);\n                           if (wrapped_form && wrapped_form.settings.validEvent) {\n                             event = trigger_event(element, 'valid', { cancelable: true });\n                           }\n                         } else {\n                           event = trigger_event(element, 'invalid', { cancelable: true });\n                         }\n\n                         if (!event || !event.defaultPrevented) {\n                           Renderer.showWarning(element, !!element.form.__hf_form_validation);\n                         }\n\n                         return valid;\n                       }\n\n                       /**\n                        * submit a form, because `element` triggered it\n                        *\n                        * This method also dispatches a submit event on the form prior to the\n                        * submission. The event contains the trigger element as `submittedVia`.\n                        *\n                        * If the element is a button with a name, the name=value pair will be added\n                        * to the submitted data.\n                        */\n                       function submit_form_via(element) {\n                         /* apparently, the submit event is not triggered in most browsers on\n                          * the submit() method, so we do it manually here to model a natural\n                          * submit as closely as possible.\n                          * Now to the fun fact: If you trigger a submit event from a form, what\n                          * do you think should happen?\n                          * 1) the form will be automagically submitted by the browser, or\n                          * 2) nothing.\n                          * And as you already suspected, the correct answer is: both! Firefox\n                          * opts for 1), Chrome for 2). Yay! */\n                         var event_got_cancelled;\n\n                         var submit_event = create_event('submit', { cancelable: true });\n                         /* force Firefox to not submit the form, then fake preventDefault() */\n                         submit_event.preventDefault();\n                         Object.defineProperty(submit_event, 'defaultPrevented', {\n                           value: false,\n                           writable: true\n                         });\n                         Object.defineProperty(submit_event, 'preventDefault', {\n                           value: function value() {\n                             return submit_event.defaultPrevented = event_got_cancelled = true;\n                           },\n                           writable: true\n                         });\n                         trigger_event(element.form, submit_event, {}, { submittedVia: element });\n\n                         if (!event_got_cancelled) {\n                           add_submit_field(element);\n                           window.HTMLFormElement.prototype.submit.call(element.form);\n                           window.setTimeout(function () {\n                             return remove_submit_field(element);\n                           });\n                         }\n                       }\n\n                       /**\n                        * if a submit button was clicked, add its name=value by means of a type=hidden\n                        * input field\n                        */\n                       function add_submit_field(button) {\n                         if (['image', 'submit'].indexOf(button.type) > -1 && button.name) {\n                           var wrapper = get_wrapper(button.form) || {};\n                           var submit_helper = wrapper.submit_helper;\n                           if (submit_helper) {\n                             if (submit_helper.parentNode) {\n                               submit_helper.parentNode.removeChild(submit_helper);\n                             }\n                           } else {\n                             submit_helper = document.createElement('input');\n                             submit_helper.type = 'hidden';\n                             wrapper.submit_helper = submit_helper;\n                           }\n                           submit_helper.name = button.name;\n                           submit_helper.value = button.value;\n                           button.form.appendChild(submit_helper);\n                         }\n                       }\n\n                       /**\n                        * remove a possible helper input, that was added by `add_submit_field`\n                        */\n                       function remove_submit_field(button) {\n                         if (['image', 'submit'].indexOf(button.type) > -1 && button.name) {\n                           var wrapper = get_wrapper(button.form) || {};\n                           var submit_helper = wrapper.submit_helper;\n                           if (submit_helper && submit_helper.parentNode) {\n                             submit_helper.parentNode.removeChild(submit_helper);\n                           }\n                         }\n                       }\n\n                       /**\n                        * check a form's validity and submit it\n                        *\n                        * The method triggers a cancellable `validate` event on the form. If the\n                        * event is cancelled, form submission will be aborted, too.\n                        *\n                        * If the form is found to contain invalid fields, focus the first field.\n                        */\n                       function check(button) {\n                         /* trigger a \"validate\" event on the form to be submitted */\n                         var val_event = trigger_event(button.form, 'validate', { cancelable: true });\n                         if (val_event.defaultPrevented) {\n                           /* skip the whole submit thing, if the validation is canceled. A user\n                            * can still call form.submit() afterwards. */\n                           return;\n                         }\n\n                         var valid = true;\n                         var first_invalid;\n                         button.form.__hf_form_validation = true;\n                         get_validated_elements(button.form).map(function (element) {\n                           if (!reportValidity(element)) {\n                             valid = false;\n                             if (!first_invalid && 'focus' in element) {\n                               first_invalid = element;\n                             }\n                           }\n                         });\n                         delete button.form.__hf_form_validation;\n\n                         if (valid) {\n                           submit_form_via(button);\n                         } else if (first_invalid) {\n                           /* focus the first invalid element, if validation went south */\n                           first_invalid.focus();\n                           /* tell the tale, if anyone wants to react to it */\n                           trigger_event(button.form, 'forminvalid');\n                         }\n                       }\n\n                       /**\n                        * test if node is a submit button\n                        */\n                       function is_submit_button(node) {\n                         return (\n                           /* must be an input or button element... */\n                           (node.nodeName === 'INPUT' || node.nodeName === 'BUTTON') && (\n\n                           /* ...and have a submitting type */\n                           node.type === 'image' || node.type === 'submit')\n                         );\n                       }\n\n                       /**\n                        * test, if the click event would trigger a submit\n                        */\n                       function is_submitting_click(event, button) {\n                         return (\n                           /* prevented default: won't trigger a submit */\n                           !event.defaultPrevented && (\n\n                           /* left button or middle button (submits in Chrome) */\n                           !('button' in event) || event.button < 2) &&\n\n                           /* must be a submit button... */\n                           is_submit_button(button) &&\n\n                           /* the button needs a form, that's going to be submitted */\n                           button.form &&\n\n                           /* again, if the form should not be validated, we're out of the game */\n                           !button.form.hasAttribute('novalidate')\n                         );\n                       }\n\n                       /**\n                        * test, if the keypress event would trigger a submit\n                        */\n                       function is_submitting_keypress(event) {\n                         return (\n                           /* prevented default: won't trigger a submit */\n                           !event.defaultPrevented && (\n                           /* ...and <Enter> was pressed... */\n                           event.keyCode === 13 &&\n\n                           /* ...on an <input> that is... */\n                           event.target.nodeName === 'INPUT' &&\n\n                           /* ...a standard text input field (not checkbox, ...) */\n                           text_types.indexOf(event.target.type) > -1 ||\n                           /* or <Enter> or <Space> was pressed... */\n                           (event.keyCode === 13 || event.keyCode === 32) &&\n\n                           /* ...on a submit button */\n                           is_submit_button(event.target)) &&\n\n                           /* there's a form... */\n                           event.target.form &&\n\n                           /* ...and the form allows validation */\n                           !event.target.form.hasAttribute('novalidate')\n                         );\n                       }\n\n                       /**\n                        * catch clicks to children of <button>s\n                        */\n                       function get_clicked_button(element) {\n                         if (is_submit_button(element)) {\n                           return element;\n                         } else if (matches(element, 'button:not([type]) *, button[type=\"submit\"] *')) {\n                           return get_clicked_button(element.parentNode);\n                         } else {\n                           return null;\n                         }\n                       }\n\n                       /**\n                        * return event handler to catch explicit submission by click on a button\n                        */\n                       function get_click_handler() {\n                         var ignore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;\n\n                         return function (event) {\n                           var button = get_clicked_button(event.target);\n                           if (button && is_submitting_click(event, button)) {\n                             event.preventDefault();\n                             if (ignore || button.hasAttribute('formnovalidate')) {\n                               /* if validation should be ignored, we're not interested in any checks */\n                               submit_form_via(button);\n                             } else {\n                               check(button);\n                             }\n                           }\n                         };\n                       }\n                       var click_handler = get_click_handler();\n                       var ignored_click_handler = get_click_handler(true);\n\n                       /**\n                        * catch implicit submission by pressing <Enter> in some situations\n                        */\n                       function get_keypress_handler(ignore) {\n                         return function keypress_handler(event) {\n                           if (is_submitting_keypress(event)) {\n                             event.preventDefault();\n\n                             var wrapper = get_wrapper(event.target.form) || { settings: {} };\n                             if (wrapper.settings.preventImplicitSubmit) {\n                               /* user doesn't want an implicit submit. Cancel here. */\n                               return;\n                             }\n\n                             /* check, that there is no submit button in the form. Otherwise\n                             * that should be clicked. */\n                             var el = event.target.form.elements.length;\n                             var submit;\n                             for (var i = 0; i < el; i++) {\n                               if (['image', 'submit'].indexOf(event.target.form.elements[i].type) > -1) {\n                                 submit = event.target.form.elements[i];\n                                 break;\n                               }\n                             }\n\n                             if (submit) {\n                               submit.click();\n                             } else if (ignore) {\n                               submit_form_via(event.target);\n                             } else {\n                               check(event.target);\n                             }\n                           }\n                         };\n                       }\n                       var keypress_handler = get_keypress_handler();\n                       var ignored_keypress_handler = get_keypress_handler(true);\n\n                       /**\n                        * catch all relevant events _prior_ to a form being submitted\n                        *\n                        * @param bool ignore bypass validation, when an attempt to submit the\n                        *                    form is detected. True, when the wrapper's revalidate\n                        *                    setting is 'never'.\n                        */\n                       function catch_submit(listening_node) {\n                         var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n\n                         if (ignore) {\n                           listening_node.addEventListener('click', ignored_click_handler);\n                           listening_node.addEventListener('keypress', ignored_keypress_handler);\n                         } else {\n                           listening_node.addEventListener('click', click_handler);\n                           listening_node.addEventListener('keypress', keypress_handler);\n                         }\n                       }\n\n                       /**\n                        * decommission the event listeners from catch_submit() again\n                        */\n                       function uncatch_submit(listening_node) {\n                         listening_node.removeEventListener('click', ignored_click_handler);\n                         listening_node.removeEventListener('keypress', ignored_keypress_handler);\n                         listening_node.removeEventListener('click', click_handler);\n                         listening_node.removeEventListener('keypress', keypress_handler);\n                       }\n\n                       /**\n                        * remove `property` from element and restore _original_property, if present\n                        */\n                       function uninstall_property (element, property) {\n                         try {\n                           delete element[property];\n                         } catch (e) {\n                           /* Safari <= 9 and PhantomJS will end up here :-( Nothing to do except\n                            * warning */\n                           var wrapper = get_wrapper(element);\n                           if (wrapper && wrapper.settings.debug) {\n                             /* global console */\n                             console.log('[hyperform] cannot uninstall custom property ' + property);\n                           }\n                           return false;\n                         }\n\n                         var original_descriptor = Object.getOwnPropertyDescriptor(element, '_original_' + property);\n\n                         if (original_descriptor) {\n                           Object.defineProperty(element, property, original_descriptor);\n                         }\n                       }\n\n                       /**\n                        * add `property` to an element\n                        *\n                        * ATTENTION! This function will search for an equally named property on the\n                        * *prototype* of an element, if element is a concrete DOM node. Do not use\n                        * it as general-purpose property installer.\n                        *\n                        * js> installer(element, 'foo', { value: 'bar' });\n                        * js> assert(element.foo === 'bar');\n                        */\n                       function install_property (element, property, descriptor) {\n                         descriptor.configurable = true;\n                         descriptor.enumerable = true;\n                         if ('value' in descriptor) {\n                           descriptor.writable = true;\n                         }\n\n                         /* on concrete instances, i.e., <input> elements, the naive lookup\n                          * yields undefined. We have to look on its prototype then. On elements\n                          * like the actual HTMLInputElement object the first line works. */\n                         var original_descriptor = Object.getOwnPropertyDescriptor(element, property);\n                         if (original_descriptor === undefined) {\n                           original_descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(element), property);\n                         }\n\n                         if (original_descriptor) {\n\n                           if (original_descriptor.configurable === false) {\n                             /* Safari <= 9 and PhantomJS will end up here :-( Nothing to do except\n                              * warning */\n                             var wrapper = get_wrapper(element);\n                             if (wrapper && wrapper.settings.debug) {\n                               /* global console */\n                               console.log('[hyperform] cannot install custom property ' + property);\n                             }\n                             return false;\n                           }\n\n                           /* we already installed that property... */\n                           if (original_descriptor.get && original_descriptor.get.__hyperform || original_descriptor.value && original_descriptor.value.__hyperform) {\n                             return;\n                           }\n\n                           /* publish existing property under new name, if it's not from us */\n                           Object.defineProperty(element, '_original_' + property, original_descriptor);\n                         }\n\n                         delete element[property];\n                         Object.defineProperty(element, property, descriptor);\n\n                         return true;\n                       }\n\n                       function is_field (element) {\n                               return element instanceof window.HTMLButtonElement || element instanceof window.HTMLInputElement || element instanceof window.HTMLSelectElement || element instanceof window.HTMLTextAreaElement || element instanceof window.HTMLFieldSetElement || element === window.HTMLButtonElement.prototype || element === window.HTMLInputElement.prototype || element === window.HTMLSelectElement.prototype || element === window.HTMLTextAreaElement.prototype || element === window.HTMLFieldSetElement.prototype;\n                       }\n\n                       /**\n                        * set a custom validity message or delete it with an empty string\n                        */\n                       function setCustomValidity(element, msg) {\n                         if (!msg) {\n                           message_store.delete(element, true);\n                         } else {\n                           message_store.set(element, msg, true);\n                         }\n                         /* live-update the warning */\n                         var warning = Renderer.getWarning(element);\n                         if (warning) {\n                           Renderer.setMessage(warning, msg, element);\n                         }\n                         /* update any classes if the validity state changes */\n                         validity_state_checkers.valid(element);\n                       }\n\n                       /**\n                        * implement the valueAsDate functionality\n                        *\n                        * @see https://html.spec.whatwg.org/multipage/forms.html#dom-input-valueasdate\n                        */\n                       function valueAsDate(element) {\n                         var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;\n\n                         var type = get_type(element);\n                         if (dates.indexOf(type) > -1) {\n                           if (value !== undefined) {\n                             /* setter: value must be null or a Date() */\n                             if (value === null) {\n                               element.value = '';\n                             } else if (value instanceof Date) {\n                               if (isNaN(value.getTime())) {\n                                 element.value = '';\n                               } else {\n                                 element.value = date_to_string(value, type);\n                               }\n                             } else {\n                               throw new window.DOMException('valueAsDate setter encountered invalid value', 'TypeError');\n                             }\n                             return;\n                           }\n\n                           var value_date = string_to_date(element.value, type);\n                           return value_date instanceof Date ? value_date : null;\n                         } else if (value !== undefined) {\n                           /* trying to set a date on a not-date input fails */\n                           throw new window.DOMException('valueAsDate setter cannot set date on this element', 'InvalidStateError');\n                         }\n\n                         return null;\n                       }\n\n                       /**\n                        * implement the valueAsNumber functionality\n                        *\n                        * @see https://html.spec.whatwg.org/multipage/forms.html#dom-input-valueasnumber\n                        */\n                       function valueAsNumber(element) {\n                         var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;\n\n                         var type = get_type(element);\n                         if (numbers.indexOf(type) > -1) {\n                           if (type === 'range' && element.hasAttribute('multiple')) {\n                             /* @see https://html.spec.whatwg.org/multipage/forms.html#do-not-apply */\n                             return NaN;\n                           }\n\n                           if (value !== undefined) {\n                             /* setter: value must be NaN or a finite number */\n                             if (isNaN(value)) {\n                               element.value = '';\n                             } else if (typeof value === 'number' && window.isFinite(value)) {\n                               try {\n                                 /* try setting as a date, but... */\n                                 valueAsDate(element, new Date(value));\n                               } catch (e) {\n                                 /* ... when valueAsDate is not responsible, ... */\n                                 if (!(e instanceof window.DOMException)) {\n                                   throw e;\n                                 }\n                                 /* ... set it via Number.toString(). */\n                                 element.value = value.toString();\n                               }\n                             } else {\n                               throw new window.DOMException('valueAsNumber setter encountered invalid value', 'TypeError');\n                             }\n                             return;\n                           }\n\n                           return string_to_number(element.value, type);\n                         } else if (value !== undefined) {\n                           /* trying to set a number on a not-number input fails */\n                           throw new window.DOMException('valueAsNumber setter cannot set number on this element', 'InvalidStateError');\n                         }\n\n                         return NaN;\n                       }\n\n                       /**\n                        *\n                        */\n                       function stepDown(element) {\n                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;\n\n                         if (numbers.indexOf(get_type(element)) === -1) {\n                           throw new window.DOMException('stepDown encountered invalid type', 'InvalidStateError');\n                         }\n                         if ((element.getAttribute('step') || '').toLowerCase() === 'any') {\n                           throw new window.DOMException('stepDown encountered step \"any\"', 'InvalidStateError');\n                         }\n\n                         var prev = get_next_valid(element, n)[0];\n\n                         if (prev !== null) {\n                           valueAsNumber(element, prev);\n                         }\n                       }\n\n                       /**\n                        *\n                        */\n                       function stepUp(element) {\n                         var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;\n\n                         if (numbers.indexOf(get_type(element)) === -1) {\n                           throw new window.DOMException('stepUp encountered invalid type', 'InvalidStateError');\n                         }\n                         if ((element.getAttribute('step') || '').toLowerCase() === 'any') {\n                           throw new window.DOMException('stepUp encountered step \"any\"', 'InvalidStateError');\n                         }\n\n                         var next = get_next_valid(element, n)[1];\n\n                         if (next !== null) {\n                           valueAsNumber(element, next);\n                         }\n                       }\n\n                       /**\n                        * get the validation message for an element, empty string, if the element\n                        * satisfies all constraints.\n                        */\n                       function validationMessage(element) {\n                         var msg = message_store.get(element);\n                         if (!msg) {\n                           return '';\n                         }\n\n                         /* make it a primitive again, since message_store returns String(). */\n                         return msg.toString();\n                       }\n\n                       /**\n                        * check, if an element will be subject to HTML5 validation at all\n                        */\n                       function willValidate(element) {\n                         return is_validation_candidate(element);\n                       }\n\n                       var gA = function gA(prop) {\n                         return function () {\n                           return do_filter('attr_get_' + prop, this.getAttribute(prop), this);\n                         };\n                       };\n\n                       var sA = function sA(prop) {\n                         return function (value) {\n                           this.setAttribute(prop, do_filter('attr_set_' + prop, value, this));\n                         };\n                       };\n\n                       var gAb = function gAb(prop) {\n                         return function () {\n                           return do_filter('attr_get_' + prop, this.hasAttribute(prop), this);\n                         };\n                       };\n\n                       var sAb = function sAb(prop) {\n                         return function (value) {\n                           if (do_filter('attr_set_' + prop, value, this)) {\n                             this.setAttribute(prop, prop);\n                           } else {\n                             this.removeAttribute(prop);\n                           }\n                         };\n                       };\n\n                       var gAn = function gAn(prop) {\n                         return function () {\n                           return do_filter('attr_get_' + prop, Math.max(0, Number(this.getAttribute(prop))), this);\n                         };\n                       };\n\n                       var sAn = function sAn(prop) {\n                         return function (value) {\n                           value = do_filter('attr_set_' + prop, value, this);\n                           if (/^[0-9]+$/.test(value)) {\n                             this.setAttribute(prop, value);\n                           }\n                         };\n                       };\n\n                       function install_properties(element) {\n                         var _arr = ['accept', 'max', 'min', 'pattern', 'placeholder', 'step'];\n\n                         for (var _i = 0; _i < _arr.length; _i++) {\n                           var prop = _arr[_i];\n                           install_property(element, prop, {\n                             get: gA(prop),\n                             set: sA(prop)\n                           });\n                         }\n\n                         var _arr2 = ['multiple', 'required', 'readOnly'];\n                         for (var _i2 = 0; _i2 < _arr2.length; _i2++) {\n                           var _prop = _arr2[_i2];\n                           install_property(element, _prop, {\n                             get: gAb(_prop.toLowerCase()),\n                             set: sAb(_prop.toLowerCase())\n                           });\n                         }\n\n                         var _arr3 = ['minLength', 'maxLength'];\n                         for (var _i3 = 0; _i3 < _arr3.length; _i3++) {\n                           var _prop2 = _arr3[_i3];\n                           install_property(element, _prop2, {\n                             get: gAn(_prop2.toLowerCase()),\n                             set: sAn(_prop2.toLowerCase())\n                           });\n                         }\n                       }\n\n                       function uninstall_properties(element) {\n                         var _arr4 = ['accept', 'max', 'min', 'pattern', 'placeholder', 'step', 'multiple', 'required', 'readOnly', 'minLength', 'maxLength'];\n\n                         for (var _i4 = 0; _i4 < _arr4.length; _i4++) {\n                           var prop = _arr4[_i4];\n                           uninstall_property(element, prop);\n                         }\n                       }\n\n                       var polyfills = {\n                         checkValidity: {\n                           value: mark(function () {\n                             return checkValidity(this);\n                           })\n                         },\n                         reportValidity: {\n                           value: mark(function () {\n                             return reportValidity(this);\n                           })\n                         },\n                         setCustomValidity: {\n                           value: mark(function (msg) {\n                             return setCustomValidity(this, msg);\n                           })\n                         },\n                         stepDown: {\n                           value: mark(function () {\n                             var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;\n                             return stepDown(this, n);\n                           })\n                         },\n                         stepUp: {\n                           value: mark(function () {\n                             var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;\n                             return stepUp(this, n);\n                           })\n                         },\n                         validationMessage: {\n                           get: mark(function () {\n                             return validationMessage(this);\n                           })\n                         },\n                         validity: {\n                           get: mark(function () {\n                             return ValidityState(this);\n                           })\n                         },\n                         valueAsDate: {\n                           get: mark(function () {\n                             return valueAsDate(this);\n                           }),\n                           set: mark(function (value) {\n                             valueAsDate(this, value);\n                           })\n                         },\n                         valueAsNumber: {\n                           get: mark(function () {\n                             return valueAsNumber(this);\n                           }),\n                           set: mark(function (value) {\n                             valueAsNumber(this, value);\n                           })\n                         },\n                         willValidate: {\n                           get: mark(function () {\n                             return willValidate(this);\n                           })\n                         }\n                       };\n\n                       function polyfill (element) {\n                         if (is_field(element)) {\n\n                           for (var prop in polyfills) {\n                             install_property(element, prop, polyfills[prop]);\n                           }\n\n                           install_properties(element);\n                         } else if (element instanceof window.HTMLFormElement || element === window.HTMLFormElement.prototype) {\n                           install_property(element, 'checkValidity', polyfills.checkValidity);\n                           install_property(element, 'reportValidity', polyfills.reportValidity);\n                         }\n                       }\n\n                       function polyunfill (element) {\n                         if (is_field(element)) {\n\n                           uninstall_property(element, 'checkValidity');\n                           uninstall_property(element, 'reportValidity');\n                           uninstall_property(element, 'setCustomValidity');\n                           uninstall_property(element, 'stepDown');\n                           uninstall_property(element, 'stepUp');\n                           uninstall_property(element, 'validationMessage');\n                           uninstall_property(element, 'validity');\n                           uninstall_property(element, 'valueAsDate');\n                           uninstall_property(element, 'valueAsNumber');\n                           uninstall_property(element, 'willValidate');\n\n                           uninstall_properties(element);\n                         } else if (element instanceof window.HTMLFormElement) {\n                           uninstall_property(element, 'checkValidity');\n                           uninstall_property(element, 'reportValidity');\n                         }\n                       }\n\n                       var instances = new WeakMap();\n\n                       /**\n                        * wrap <form>s, window or document, that get treated with the global\n                        * hyperform()\n                        */\n                       function Wrapper(form, settings) {\n\n                         /* do not allow more than one instance per form. Otherwise we'd end\n                          * up with double event handlers, polyfills re-applied, ... */\n                         var existing = instances.get(form);\n                         if (existing) {\n                           existing.settings = settings;\n                           return existing;\n                         }\n\n                         this.form = form;\n                         this.settings = settings;\n                         this.revalidator = this.revalidate.bind(this);\n\n                         instances.set(form, this);\n\n                         catch_submit(form, settings.revalidate === 'never');\n\n                         if (form === window || form.nodeType === 9) {\n                           /* install on the prototypes, when called for the whole document */\n                           this.install([window.HTMLButtonElement.prototype, window.HTMLInputElement.prototype, window.HTMLSelectElement.prototype, window.HTMLTextAreaElement.prototype, window.HTMLFieldSetElement.prototype]);\n                           polyfill(window.HTMLFormElement);\n                         } else if (form instanceof window.HTMLFormElement || form instanceof window.HTMLFieldSetElement) {\n                           this.install(form.elements);\n                           if (form instanceof window.HTMLFormElement) {\n                             polyfill(form);\n                           }\n                         }\n\n                         if (settings.revalidate === 'oninput' || settings.revalidate === 'hybrid') {\n                           /* in a perfect world we'd just bind to \"input\", but support here is\n                            * abysmal: http://caniuse.com/#feat=input-event */\n                           form.addEventListener('keyup', this.revalidator);\n                           form.addEventListener('change', this.revalidator);\n                         }\n                         if (settings.revalidate === 'onblur' || settings.revalidate === 'hybrid') {\n                           /* useCapture=true, because `blur` doesn't bubble. See\n                            * https://developer.mozilla.org/en-US/docs/Web/Events/blur#Event_delegation\n                            * for a discussion */\n                           form.addEventListener('blur', this.revalidator, true);\n                         }\n                       }\n\n                       Wrapper.prototype = {\n                         destroy: function destroy() {\n                           uncatch_submit(this.form);\n                           instances.delete(this.form);\n                           this.form.removeEventListener('keyup', this.revalidator);\n                           this.form.removeEventListener('change', this.revalidator);\n                           this.form.removeEventListener('blur', this.revalidator, true);\n                           if (this.form === window || this.form.nodeType === 9) {\n                             this.uninstall([window.HTMLButtonElement.prototype, window.HTMLInputElement.prototype, window.HTMLSelectElement.prototype, window.HTMLTextAreaElement.prototype, window.HTMLFieldSetElement.prototype]);\n                             polyunfill(window.HTMLFormElement);\n                           } else if (this.form instanceof window.HTMLFormElement || this.form instanceof window.HTMLFieldSetElement) {\n                             this.uninstall(this.form.elements);\n                             if (this.form instanceof window.HTMLFormElement) {\n                               polyunfill(this.form);\n                             }\n                           }\n                         },\n\n\n                         /**\n                          * revalidate an input element\n                          */\n                         revalidate: function revalidate(event) {\n                           if (event.target instanceof window.HTMLButtonElement || event.target instanceof window.HTMLTextAreaElement || event.target instanceof window.HTMLSelectElement || event.target instanceof window.HTMLInputElement) {\n\n                             if (this.settings.revalidate === 'hybrid') {\n                               /* \"hybrid\" somewhat simulates what browsers do. See for example\n                                * Firefox's :-moz-ui-invalid pseudo-class:\n                                * https://developer.mozilla.org/en-US/docs/Web/CSS/:-moz-ui-invalid */\n                               if (event.type === 'blur' && event.target.value !== event.target.defaultValue || ValidityState(event.target).valid) {\n                                 /* on blur, update the report when the value has changed from the\n                                  * default or when the element is valid (possibly removing a still\n                                  * standing invalidity report). */\n                                 reportValidity(event.target);\n                               } else if (event.type === 'keyup' && event.keyCode !== 9 || event.type === 'change') {\n                                 if (ValidityState(event.target).valid) {\n                                   // report instantly, when an element becomes valid,\n                                   // postpone report to blur event, when an element is invalid\n                                   reportValidity(event.target);\n                                 }\n                               }\n                             } else if (event.type !== 'keyup' || event.keyCode !== 9) {\n                               /* do _not_ validate, when the user \"tabbed\" into the field initially,\n                                * i.e., a keyup event with keyCode 9 */\n                               reportValidity(event.target);\n                             }\n                           }\n                         },\n\n\n                         /**\n                          * install the polyfills on each given element\n                          *\n                          * If you add elements dynamically, you have to call install() on them\n                          * yourself:\n                          *\n                          * js> var form = hyperform(document.forms[0]);\n                          * js> document.forms[0].appendChild(input);\n                          * js> form.install(input);\n                          *\n                          * You can skip this, if you called hyperform on window or document.\n                          */\n                         install: function install(els) {\n                           if (els instanceof window.Element) {\n                             els = [els];\n                           }\n\n                           var els_length = els.length;\n\n                           for (var i = 0; i < els_length; i++) {\n                             polyfill(els[i]);\n                           }\n                         },\n                         uninstall: function uninstall(els) {\n                           if (els instanceof window.Element) {\n                             els = [els];\n                           }\n\n                           var els_length = els.length;\n\n                           for (var i = 0; i < els_length; i++) {\n                             polyunfill(els[i]);\n                           }\n                         }\n                       };\n\n                       /**\n                        * try to get the appropriate wrapper for a specific element by looking up\n                        * its parent chain\n                        *\n                        * @return Wrapper | undefined\n                        */\n                       function get_wrapper(element) {\n                         var wrapped;\n\n                         if (element.form) {\n                           /* try a shortcut with the element's <form> */\n                           wrapped = instances.get(element.form);\n                         }\n\n                         /* walk up the parent nodes until document (including) */\n                         while (!wrapped && element) {\n                           wrapped = instances.get(element);\n                           element = element.parentNode;\n                         }\n\n                         if (!wrapped) {\n                           /* try the global instance, if exists. This may also be undefined. */\n                           wrapped = instances.get(window);\n                         }\n\n                         return wrapped;\n                       }\n\n                       /**\n                        * filter a form's elements for the ones needing validation prior to\n                        * a submit\n                        *\n                        * Returns an array of form elements.\n                        */\n                       function get_validated_elements(form) {\n                         var wrapped_form = get_wrapper(form);\n\n                         return Array.prototype.filter.call(form.elements, function (element) {\n                           /* it must have a name (or validating nameless inputs is allowed) */\n                           if (element.getAttribute('name') || wrapped_form && wrapped_form.settings.validateNameless) {\n                             return true;\n                           }\n                           return false;\n                         });\n                       }\n\n                       /**\n                        * return either the data of a hook call or the result of action, if the\n                        * former is undefined\n                        *\n                        * @return function a function wrapper around action\n                        */\n                       function return_hook_or (hook, action) {\n                         return function () {\n                           var data = call_hook(hook, Array.prototype.slice.call(arguments));\n\n                           if (data !== undefined) {\n                             return data;\n                           }\n\n                           return action.apply(this, arguments);\n                         };\n                       }\n\n                       /**\n                        * check an element's validity with respect to it's form\n                        */\n                       var checkValidity = return_hook_or('checkValidity', function (element) {\n                         /* if this is a <form>, check validity of all child inputs */\n                         if (element instanceof window.HTMLFormElement) {\n                           return get_validated_elements(element).map(checkValidity).every(function (b) {\n                             return b;\n                           });\n                         }\n\n                         /* default is true, also for elements that are no validation candidates */\n                         var valid = ValidityState(element).valid;\n                         if (valid) {\n                           var wrapped_form = get_wrapper(element);\n                           if (wrapped_form && wrapped_form.settings.validEvent) {\n                             trigger_event(element, 'valid');\n                           }\n                         } else {\n                           trigger_event(element, 'invalid', { cancelable: true });\n                         }\n\n                         return valid;\n                       });\n\n                       var version = '0.9.21';\n\n                       /* deprecate the old snake_case names\n                        * TODO: delme before next non-patch release\n                        */\n                       function w(name) {\n                         var deprecated_message = 'Please use camelCase method names! The name \"%s\" is deprecated and will be removed in the next non-patch release.';\n                         /* global console */\n                         console.log(sprintf(deprecated_message, name));\n                       }\n\n                       /**\n                        * public hyperform interface:\n                        */\n                       function hyperform(form) {\n                         var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n\n                         var classes = _ref.classes;\n                         var _ref$debug = _ref.debug;\n                         var debug = _ref$debug === undefined ? false : _ref$debug;\n                         var extend_fieldset = _ref.extend_fieldset;\n                         var extendFieldset = _ref.extendFieldset;\n                         var novalidate_on_elements = _ref.novalidate_on_elements;\n                         var novalidateOnElements = _ref.novalidateOnElements;\n                         var prevent_implicit_submit = _ref.prevent_implicit_submit;\n                         var preventImplicitSubmit = _ref.preventImplicitSubmit;\n                         var revalidate = _ref.revalidate;\n                         var _ref$strict = _ref.strict;\n                         var strict = _ref$strict === undefined ? false : _ref$strict;\n                         var valid_event = _ref.valid_event;\n                         var validEvent = _ref.validEvent;\n                         var _ref$validateNameless = _ref.validateNameless;\n                         var validateNameless = _ref$validateNameless === undefined ? false : _ref$validateNameless;\n\n\n                         if (!classes) {\n                           classes = {};\n                         }\n                         // TODO: clean up before next non-patch release\n                         if (extendFieldset === undefined) {\n                           if (extend_fieldset === undefined) {\n                             extendFieldset = !strict;\n                           } else {\n                             w('extend_fieldset');\n                             extendFieldset = extend_fieldset;\n                           }\n                         }\n                         if (novalidateOnElements === undefined) {\n                           if (novalidate_on_elements === undefined) {\n                             novalidateOnElements = !strict;\n                           } else {\n                             w('novalidate_on_elements');\n                             novalidateOnElements = novalidate_on_elements;\n                           }\n                         }\n                         if (preventImplicitSubmit === undefined) {\n                           if (prevent_implicit_submit === undefined) {\n                             preventImplicitSubmit = false;\n                           } else {\n                             w('prevent_implicit_submit');\n                             preventImplicitSubmit = prevent_implicit_submit;\n                           }\n                         }\n                         if (revalidate === undefined) {\n                           /* other recognized values: 'oninput', 'onblur', 'onsubmit' and 'never' */\n                           revalidate = strict ? 'onsubmit' : 'hybrid';\n                         }\n                         if (validEvent === undefined) {\n                           if (valid_event === undefined) {\n                             validEvent = !strict;\n                           } else {\n                             w('valid_event');\n                             validEvent = valid_event;\n                           }\n                         }\n\n                         var settings = { debug: debug, strict: strict, preventImplicitSubmit: preventImplicitSubmit, revalidate: revalidate,\n                           validEvent: validEvent, extendFieldset: extendFieldset, classes: classes, novalidateOnElements: novalidateOnElements,\n                           validateNameless: validateNameless\n                         };\n\n                         if (form instanceof window.NodeList || form instanceof window.HTMLCollection || form instanceof Array) {\n                           return Array.prototype.map.call(form, function (element) {\n                             return hyperform(element, settings);\n                           });\n                         }\n\n                         return new Wrapper(form, settings);\n                       }\n\n                       hyperform.version = version;\n\n                       hyperform.checkValidity = checkValidity;\n                       hyperform.reportValidity = reportValidity;\n                       hyperform.setCustomValidity = setCustomValidity;\n                       hyperform.stepDown = stepDown;\n                       hyperform.stepUp = stepUp;\n                       hyperform.validationMessage = validationMessage;\n                       hyperform.ValidityState = ValidityState;\n                       hyperform.valueAsDate = valueAsDate;\n                       hyperform.valueAsNumber = valueAsNumber;\n                       hyperform.willValidate = willValidate;\n\n                       hyperform.setLanguage = function (lang) {\n                         set_language(lang);return hyperform;\n                       };\n                       hyperform.addTranslation = function (lang, catalog) {\n                         add_translation(lang, catalog);return hyperform;\n                       };\n                       hyperform.setRenderer = function (renderer, action) {\n                         Renderer.set(renderer, action);return hyperform;\n                       };\n                       hyperform.addValidator = function (element, validator) {\n                         custom_validator_registry.set(element, validator);return hyperform;\n                       };\n                       hyperform.setMessage = function (element, validator, message) {\n                         custom_messages.set(element, validator, message);return hyperform;\n                       };\n                       hyperform.addHook = function (hook, action, position) {\n                         add_hook(hook, action, position);return hyperform;\n                       };\n                       hyperform.removeHook = function (hook, action) {\n                         remove_hook(hook, action);return hyperform;\n                       };\n\n                       // TODO: Remove in next non-patch version\n                       hyperform.set_language = function (lang) {\n                         w('set_language');set_language(lang);return hyperform;\n                       };\n                       hyperform.add_translation = function (lang, catalog) {\n                         w('add_translation');add_translation(lang, catalog);return hyperform;\n                       };\n                       hyperform.set_renderer = function (renderer, action) {\n                         w('set_renderer');Renderer.set(renderer, action);return hyperform;\n                       };\n                       hyperform.add_validator = function (element, validator) {\n                         w('add_validator');custom_validator_registry.set(element, validator);return hyperform;\n                       };\n                       hyperform.set_message = function (element, validator, message) {\n                         w('set_message');custom_messages.set(element, validator, message);return hyperform;\n                       };\n                       hyperform.add_hook = function (hook, action, position) {\n                         w('add_hook');add_hook(hook, action, position);return hyperform;\n                       };\n                       hyperform.remove_hook = function (hook, action) {\n                         w('remove_hook');remove_hook(hook, action);return hyperform;\n                       };\n\n                       if (document.currentScript && document.currentScript.hasAttribute('data-hf-autoload')) {\n                         hyperform(window);\n                       }\n\n                       return hyperform;\n\n}());"

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingButton__ = __webpack_require__(49);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var forms = document.querySelectorAll('.js-form');

  if (forms) {
    ;[].concat(_toConsumableArray(forms)).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var button = form.querySelector('.c-button');

        Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["c" /* setLoading */])(button); // Set button to loading

        if (!form.checkValidity()) return;

        sendForm(form).then(handleFetch).then(function (r) {
          if (r.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["b" /* setInitial */])(button);
            return;
          }
          Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["a" /* setFinished */])(button);
          sendGTMEvent(form);
          setTimeout(function () {
            window.location = r.action;
            Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["b" /* setInitial */])(button);
            resetForm(form);
          }, 1000);
        }).catch(function (e) {
          console.error(e);
          Object(__WEBPACK_IMPORTED_MODULE_1__LoadingButton__["b" /* setInitial */])(button);
          window.alert('Het formulier is niet verzonden, dit kan komen doordat het bijgevoegde bestand te groot is. Probeer het opnieuw.');
        });
      });
    });
  }

  var sendForm = function sendForm(form) {
    return window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      credentials: 'same-origin',
      method: 'post',
      body: new window.FormData(form)
    });
  };

  var resetForm = function resetForm(form) {
    return form.reset();
  };

  var handleFetch = function handleFetch(r) {
    if (!r.ok) {
      var error = {
        error: 'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
      };
      return error;
    } else {
      return r.json();
    }
  };

  var sendGTMEvent = function sendGTMEvent(form) {
    window.dataLayer = window.dataLayer || [];
    var data = {
      event: 'formSent',
      form: form.querySelector("input[name='form_id']") !== undefined && form.querySelector("input[name='form_id']") !== null ? form.querySelector("input[name='form_id']").value : 'Onbekend'
    };
    window.dataLayer.push(data);
  };
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setInitial;
/* harmony export (immutable) */ __webpack_exports__["c"] = setLoading;
/* harmony export (immutable) */ __webpack_exports__["a"] = setFinished;
/* unused harmony export LoadingButton */
/**
 * Set button to a loading or finished state
 *
 * @since 1.0.0
 */

function setInitial(el) {
  el.classList.remove('c-button--loading');
  el.classList.remove('c-button--finished');
}

function setLoading(el) {
  el.classList.add('c-button--loading');
}

function setFinished(el) {
  el.classList.remove('c-button--loading');
  el.classList.add('c-button--finished');
}

function LoadingButton() {
  var buttons = document.querySelectorAll('.js-loading-button');
  if (buttons.length) {
    Array.from(buttons).forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        setLoading(button);
        setTimeout(function () {
          setFinished(button);
          setTimeout(function () {
            setInitial(button);
          }, 2000);
        }, 2000);
      });
    });
  }
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Depends On
 *
 * Hide/show form inputs based on
 * a radio/select input value
 * @since 1.0.0
 */

var DependsOn = function DependsOn() {
  var containers = document.querySelectorAll('.js-depends-on');

  if (!containers) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {

    var input_name = container.dataset.name;
    var input_value = container.dataset.value;
    var form = container.closest('.js-form');
    var leader_inputs = form.querySelectorAll('input[name="' + input_name + '"],select[name="' + input_name + '"]');
    var depender_inputs = container.querySelectorAll('input,textarea,select');
    var current_value = ''

    // disable all inputs inside c-depends-on
    ;[].concat(_toConsumableArray(depender_inputs)).forEach(function (input) {
      input.disabled = true;
    });[].concat(_toConsumableArray(leader_inputs)).forEach(function (input) {

      if (input.checked) {
        // get checked radio button value
        current_value = input.value;
      }
      if (input.tagName === 'SELECT') {
        // get selected option value
        current_value = getCurrentOption(input);
      }

      // on first load
      if (current_value == input_value) {
        showDependers(container, depender_inputs);
      }

      // hide/show on click/change
      if (input.tagName !== 'SELECT') {
        // radio button
        input.addEventListener('click', function () {
          if (input.value == input_value) {
            showDependers(container, depender_inputs);
          } else {
            hideDependers(container, depender_inputs);
          }
        });
      } else {
        // select
        input.addEventListener('change', function () {
          current_value = getCurrentOption(input);
          if (current_value == input_value) {
            showDependers(container, depender_inputs);
          } else {
            hideDependers(container, depender_inputs);
          }
        });
      }
    }); // end foreach
  }); // end foreach
};

function getCurrentOption(input) {
  return input.options[input.selectedIndex].value;
}

function hideDependers(container, depender_inputs) {
  container.classList.remove('active');[].concat(_toConsumableArray(depender_inputs)).forEach(function (input) {
    input.disabled = true;
  });
}

function showDependers(container, depender_inputs) {
  container.classList.add('active');[].concat(_toConsumableArray(depender_inputs)).forEach(function (input) {
    input.disabled = false;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (DependsOn);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Lazy Load Images
 * 
 * NOTE: polyfill in /lib/Settings.php
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if (!lazyImages) return;

  var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var lazyImage = entry.target;

        if (lazyImage.dataset.src) {
          lazyImage.src = lazyImage.dataset.src;
        }
        if (lazyImage.dataset.srcset) {
          lazyImage.srcset = lazyImage.dataset.srcset;
        }
        if (lazyImage.dataset.sizes) {
          lazyImage.sizes = lazyImage.dataset.sizes;
        }

        lazyImage.classList.add('loaded');
        lazyImageObserver.unobserve(lazyImage);
      }
    });
  });

  lazyImages.forEach(function (lazyImage) {
    lazyImageObserver.observe(lazyImage);
  });
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Lazy Load Picture
 * 
 * NOTE: polyfill in /lib/Settings.php
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var lazyPictures = [].slice.call(document.querySelectorAll("picture.lazy"));

  if (!lazyPictures) return;

  var lazyPictureObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var lazyPicture = entry.target;
        var elements = [].slice.call(lazyPicture.querySelectorAll("img,source"));

        elements.forEach(function (element) {
          if (element.dataset.src) {
            element.src = element.dataset.src;
          }
          if (element.dataset.srcset) {
            element.srcset = element.dataset.srcset;
          }
          if (element.dataset.sizes) {
            element.sizes = element.dataset.sizes;
          }
        });

        lazyPicture.classList.add('loaded');
        lazyPictureObserver.unobserve(lazyPicture);
      }
    });
  });

  lazyPictures.forEach(function (lazyPicture) {
    lazyPictureObserver.observe(lazyPicture);
  });
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Lazy Load Video
 * 
 * NOTE: polyfill in /lib/Settings.php
 * 
 * We iterate through all of the child <source> elements 
 * and flip their data-src attributes to src attributes. 
 * Then we need to trigger loading of the video by calling the element's load method, 
 * after which the media will begin playing automatically per the autoplay attribute.
 * https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/#for_video_acting_as_an_animated_gif_replacement
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if (!lazyVideos) return;

  var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var video = entry.target;

        for (var source in video.children) {
          var videoSource = video.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE" && videoSource.dataset.src) {
            videoSource.src = videoSource.dataset.src;
          }
        }

        video.load();
        video.classList.add("loaded");
        lazyVideoObserver.unobserve(video);
      }
    });
  });

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var UploadButton = function UploadButton() {

  var buttons = document.querySelectorAll('.js-upload-button');

  if (!buttons) return;[].concat(_toConsumableArray(buttons)).forEach(function (button) {

    var content = button.querySelector('.js-upload-content');
    var originalContent = content.innerHTML;
    var input = button.querySelector('.js-upload-input');
    var eraser = button.querySelector('.js-upload-eraser');

    button.addEventListener('change', function () {
      content.innerHTML = input.value.replace(/^.*\\/, '');

      if (input.files.length > 0 && input.files[0].size > 2000000) {
        window.alert('Het bestand is groter dan 2MB, probeer een kleiner bestand te versturen.');
        input.value = '';
        content.innerHTML = 'Selecteer een kleiner bestand.';
      }

      if (input.value != '') {
        eraser.classList.add('active');
      }

      if (input.value == '') {
        content.innerHTML = originalContent;
        eraser.classList.remove('active');
      }
    });

    eraser.addEventListener('click', function () {
      input.value = '';
      content.innerHTML = originalContent;
      eraser.classList.remove('active');
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (UploadButton);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-read-more');
  if (!containers) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {
    // console.log(container)
    var trigger = container.querySelector('.js-read-more-trigger');
    var panel = container.querySelector('.js-read-more-panel');
    var text = container.querySelector('.js-read-more-text');
    // console.log(trigger)
    var more = trigger.dataset.more;
    var less = trigger.dataset.less;

    if (!trigger || !panel || !text || !more || !less) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      container.classList.toggle('active');
      trigger.classList.toggle('active');
      panel.classList.toggle('active');

      if (trigger.classList.contains('active')) {
        text.innerHTML = less;
      } else {
        text.innerHTML = more;
      }
    });
  });
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-video-container');[].concat(_toConsumableArray(containers)).forEach(function (container) {
    var video = container.querySelector('.js-video');
    var playButton = container.querySelector('.js-video-play');
    var overlay = container.querySelector('.js-video-overlay');
    var image = container.querySelector('.js-video-image');

    // Video has buffered enough to play
    video.addEventListener('canplay', function () {

      if (video.autoplay) {
        // Fade out the image if video is autoplay
        image.classList.add('hidden');
      }
    });

    // Play video
    if (playButton) {
      playButton.addEventListener('click', function () {
        image.classList.add('hidden');
        overlay.classList.add('hidden');
        playButton.classList.add('hidden');
        video.classList.add('active');

        video.currentTime = 0;
        video.controls = true;
        video.muted = false;
        video.play();

        // Turn on any subtitles
        for (var i = 0; i < video.textTracks.length; i++) {
          video.textTracks[i].mode = 'showing';
        }
      });
    }
  });
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var headers = document.querySelectorAll('.js-sticky-header');
  var scrollPos = 0;
  var scrolledUp = false;

  if (!headers) return;

  window.addEventListener('scroll', handleScroll);

  function handleScroll() {
    scrolledUp = document.body.getBoundingClientRect().top > scrollPos

    // loop through all headers
    ;[].concat(_toConsumableArray(headers)).forEach(function (header) {
      // we're NOT at the top of the page
      if (window.pageYOffset > 300) {
        // we're scrolling up
        if (scrolledUp) {
          if (!header.classList.contains('active')) {
            document.body.classList.add('sticky-header-active');
            header.classList.add('active');
          }
          // we're scrolling down
        } else {
          if (header.classList.contains('active')) {
            header.classList.remove('active');
            document.body.classList.remove('sticky-header-active');
          }
        }

        // we're at the top of the page
      } else {
        if (header.classList.contains('active')) {
          header.classList.remove('active');
          document.body.classList.remove('sticky-header-active');
        }
      }
    });

    // saves the new position for iteration.
    scrollPos = document.body.getBoundingClientRect().top;
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var buttons = document.querySelectorAll('.js-toggle-mobile-cover');
  var closeButtons = document.querySelectorAll('.js-close-mobile-cover');
  var cover = document.querySelector('.js-mobile-cover');
  var childCovers = document.querySelectorAll('.js-mobile-child-cover');
  var coverContainer = document.querySelector('.js-mobile-cover-container');
  var childTriggers = document.querySelectorAll('.js-mobile-cover-trigger');
  var childClosers = document.querySelectorAll('.js-mobile-cover-close-child');
  var header = document.querySelector('.c-mobile-sticky-header');

  if (!buttons || !cover || !coverContainer) return;
  if (header.classList.contains('active')) cover.classList.add('sticky-header');[].concat(_toConsumableArray(buttons)).forEach(function (button) {
    button.addEventListener('click', function (e) {
      if (!document.body.classList.contains('child-active')) {
        if (document.body.classList.contains('menu-open')) {
          console.log('Menu open');[].concat(_toConsumableArray(childCovers)).forEach(function (childCover) {
            childCover.classList.remove('active');
            childCover.classList.remove('active-sticky');
            Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
          });

          cover.classList.remove('active');
          document.body.classList.remove('menu-open');

          if (header.classList.contains('active')) {
            cover.classList.remove('active-sticky');
          }

          Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
        } else {
          cover.classList.add('active');
          document.body.classList.add('menu-open');
          Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(coverContainer);

          if (header.classList.contains('active')) {
            cover.classList.add('active-sticky');
          }
        }
      } else {
        console.log('Child active');
        cover.classList.remove('active');
        document.body.classList.remove('menu-open');
        document.body.classList.remove('child-active');

        if (header.classList.contains('active')) {
          cover.classList.remove('active-sticky');
        }

        ;[].concat(_toConsumableArray(childCovers)).forEach(function (childCover) {
          childCover.classList.remove('active');
          childCover.classList.remove('active-sticky');
          Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
        });

        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
      }
    });
  });[].concat(_toConsumableArray(closeButtons)).forEach(function (button) {
    button.addEventListener('click', function (e) {
      cover.classList.remove('active');
      cover.classList.remove('active-sticky')

      // Also close every active child
      ;[].concat(_toConsumableArray(childCovers)).forEach(function (childCover) {
        childCover.classList.remove('active');
        childCover.classList.remove('active-sticky');
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
      });

      // If active, disable scrolling for everything but coverContainer
      if (cover.classList.contains('active')) {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(coverContainer);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
      }
    });
  });[].concat(_toConsumableArray(childTriggers)).forEach(function (childTrigger) {
    childTrigger.addEventListener('click', function (e) {
      var childCover = document.getElementById(childTrigger.dataset.target);
      var childContainer = childCover.querySelector('.js-mobile-child-cover-container');
      // Enable body scroll on default cover again
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();

      // Set child cover as active
      childCover.classList.add('active');
      document.body.classList.add('child-active');

      // Disable body scroll for every element but the cover
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(childContainer);

      // Remove active class from parent
      cover.classList.remove('active');
    });
  });[].concat(_toConsumableArray(childClosers)).forEach(function (childCloser) {
    childCloser.addEventListener('click', function (e) {
      var childCover = document.getElementById(childCloser.dataset.target);

      childCover.classList.remove('active');

      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();

      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(coverContainer);

      cover.classList.add('active');
    });
  });

  // Close mobile cover if click outside coverContainer
  cover.addEventListener('click', function (e) {
    if (!e.target.closest('.js-mobile-cover-container')) {
      cover.classList.remove('active');
      cover.classList.remove('active-sticky');
      document.body.classList.remove('menu-open');
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["clearAllBodyScrollLocks"])();
    }
  });
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var mobileHeaders = document.querySelectorAll('.js-mobile-header');
  if (mobileHeaders.length < 1) return;[].concat(_toConsumableArray(mobileHeaders)).forEach(function (header) {
    var buttons = header.querySelectorAll('.js-toggle-mobile-search');
    var wrapper = header.querySelector('.js-mobile-search');
    var container = header.querySelector('.js-mobile-header-container');

    if (buttons.length < 1 || !wrapper) return;[].concat(_toConsumableArray(buttons)).forEach(function (button) {
      button.addEventListener('click', function (e) {
        wrapper.classList.toggle('active');
        container.classList.toggle('active');

        // If active, disable scrolling for everything but wrapper
        if (wrapper.classList.contains('active')) {
          Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(wrapper);
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(wrapper);
        }
      });
    });

    // Close if click outside
    wrapper.addEventListener('click', function (e) {

      if (!e.target.closest('.js-mobile-search-field')) {
        wrapper.classList.remove('active');
        container.classList.remove('active');
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(wrapper);
      }
    });
  });
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NumberFormat__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Woocommerce: Calculate Price
 *
 * Calculate the product price on a single product,
 * based on the width and length.
 *
 * @since 1.0.0
 */






/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Grab all necessary elements
  var cartForm = document.querySelector('form.cart');
  if (!cartForm) return;

  var priceBar = cartForm.querySelector('.js-woo-price-bar');

  if (!priceBar) return;
  if (priceBar.dataset.default === 'yes') return;

  var widthInput = cartForm.querySelector('.js-woo-width');
  var lengthInput = cartForm.querySelector('.js-woo-length');
  var diameterInput = cartForm.querySelector('.js-woo-diameter');
  var rubberRadios = cartForm.querySelectorAll('.js-woo-rubber');
  var fillingRadios = cartForm.querySelectorAll('.js-woo-filling-mat-option');
  var AdditionalRadios = cartForm.querySelectorAll('.js-woo-additional-product-option');
  var cutterCheckbox = cartForm.querySelector('.js-woo-cutter');
  var quantityInput = cartForm.querySelector('.qty');
  var typeRadios = cartForm.querySelectorAll('.js-woo-type');
  var hiddenPrice = cartForm.querySelector('.js-hidden-price');
  var defaultSelect = cartForm.querySelector('.js-woo-default-select');
  var fillingMatOptions = cartForm.querySelector('.js-woo-filling-mat-option') ? cartForm.querySelectorAll('.js-woo-filling-mat-option') : false;
  var fillingMatOption = fillingMatOptions ? cartForm.querySelector('.js-woo-filling-mat-option.active') : false;
  var additionalMatOptions = cartForm.querySelector('.js-woo-additional-product-option') ? cartForm.querySelectorAll('.js-woo-additional-product-option') : false;
  var additionalMatOption = additionalMatOptions ? cartForm.querySelectorAll('.js-woo-additional-product-option.active') : false;
  var mobilePriceField = document.querySelector('.js-woo-product-sticky-price') ? document.querySelector('.js-woo-product-sticky-price') : false;

  // Set cartButton to disabled by default
  var cartButton = cartForm.querySelector('.js-woo-cart-button');
  var cartSecondButton = document.querySelector('.js-woo-cart-second-button');
  if (cartButton) cartButton.disabled = true;
  if (cartSecondButton) cartSecondButton.classList.add('disabled');

  // Make an array of elements to pass around easily
  var elements = {
    widthInput: widthInput,
    diameterInput: diameterInput,
    lengthInput: lengthInput,
    rubberCheckbox: rubberRadios,
    cutterCheckbox: cutterCheckbox,
    quantityInput: quantityInput,
    typeRadios: typeRadios,
    cartButton: cartButton,
    cartSecondButton: cartSecondButton,
    defaultSelect: defaultSelect,
    fillingMatOption: fillingMatOption,
    mobilePriceField: mobilePriceField,
    fillingCheckbox: fillingRadios,
    additionalMatOption: additionalMatOptions,
    additionalCheckbox: AdditionalRadios

    // Standard values
  };var width = 0;
  var length = 0;
  var timer = 0;
  var hasRubber = 0;
  var hasCutter = 0;
  var quantity = quantityInput ? quantityInput.value : 1;
  var validation = {};
  var fillingMat = fillingMatOption ? fillingMatOption : 0;
  var additionalMat = additionalMatOption ? additionalMatOption : 0;

  // Get price by diameter
  if (diameterInput && widthInput && lengthInput) {
    diameterInput.addEventListener('input', function (e) {
      width = e.target.value;
      length = e.target.value;
      clearTimeout(timer);

      timer = setTimeout(function () {
        validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
        if (validation.status === false) {
          disableOtherFields(elements);
        }
        calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);
      }, 1000);
    });
  }

  // Get price by width
  if (widthInput) {
    widthInput.addEventListener('input', function (e) {
      width = e.target.value;
      clearTimeout(timer);
      timer = setTimeout(function () {
        validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
        if (validation.status === false) {
          disableOtherFields(elements);
        }
        calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);

        calculateRubberPrices(width, length, quantity, priceBar);

        if (fillingMatOptions) calculateFillingMatPrices(width, length, quantity, fillingMatOptions);
        if (additionalMatOptions) calculateAdditionalMatPrices(width, length, quantity, additionalMatOptions);
      }, 1000);
    });
  }

  // Get price by length
  if (lengthInput) {
    lengthInput.addEventListener('input', function (e) {
      length = e.target.value;
      clearTimeout(timer);

      timer = setTimeout(function () {
        validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
        if (validation.status === false) {
          disableOtherFields(elements);
        }
        calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);

        calculateRubberPrices(width, length, quantity, priceBar);

        if (fillingMatOptions) calculateFillingMatPrices(width, length, quantity, fillingMatOptions);
        if (additionalMatOptions) calculateAdditionalMatPrices(width, length, quantity, additionalMatOptions);
      }, 1000);
    });
  }

  // Get price by rubber edge
  if (rubberRadios) {
    ;[].concat(_toConsumableArray(rubberRadios)).map(function (rubberRadio) {
      rubberRadio.addEventListener('change', function (e) {
        hasRubber = e.target.checked;
        if ((e.target.value === '1' || e.target.value === '2') && hasRubber) {
          hasRubber = e.target.value;
        } else {
          hasRubber = 0;
        }

        var extras = document.querySelector('.js-options-extras');
        if (extras) {
          extras.classList.remove('inactive');
          extras.classList.add('active');
        }

        validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
        calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);
      });
    });
  }

  // Get price by additional mats
  if (additionalMatOptions) {
    ;[].concat(_toConsumableArray(additionalMatOptions)).map(function (matOption) {
      matOption.addEventListener('click', function (e) {
        validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
        calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);
      });
    });
  }

  // Get price by cutter
  if (cutterCheckbox) {
    cutterCheckbox.addEventListener('change', function (e) {
      hasCutter = e.target.checked;
      if (hasCutter) {
        hasCutter = 1;
      } else {
        hasCutter = 0;
      }

      validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
      calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);
    });
  }

  // Get price by quantity
  quantityInput.addEventListener('input', function (e) {
    quantity = e.target.value;

    validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
    calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat);
  });

  // Get active filling mat
  if (fillingMatOption) {
    var activeFillingMatOption = [];
    activeFillingMatOption.push(cartForm.querySelector('.js-woo-filling-mat-option.active'));[].concat(_toConsumableArray(fillingMatOptions)).forEach(function (option) {
      option.addEventListener('click', function (e) {
        // AANPASSEN
        if (option.classList.contains('active')) {
          option.classList.remove('active');

          if (activeFillingMatOption.length > 0) {
            var indexToRemove = activeFillingMatOption.indexOf(option);
            if (indexToRemove !== -1) {
              activeFillingMatOption.splice(indexToRemove, 1);
            }
          }
        } else {
          option.classList.add('active');
          activeFillingMatOption.push(option);
        }

        // // Remove the active state
        // ;[...fillingMatOptions].forEach(item => {
        //   if (item.classList.contains('active')) item.classList.remove('active')
        // })

        // option.classList.add('active')
        // fillingMat = option

        fillingMat = activeFillingMatOption;
        clearTimeout(timer);

        timer = setTimeout(function () {
          validation = Object(__WEBPACK_IMPORTED_MODULE_1__DimensionsValidation__["b" /* dimensionsValidation */])(width, length, hasRubber, cartForm);
          if (validation.status === false) {
            disableOtherFields(elements);
          }
          calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat);
        }, 1000);
      });
    });
  }
});

function calculateFillingMatPrices(width, length, quantity, array) {
  ;[].concat(_toConsumableArray(array)).forEach(function (option) {
    var fillingMatID = option.dataset.id;
    var fillingMatPrice = 0;
    var fillingMatRawPrice = 0;
    var fillingMatTotalPrice = 0;

    if (fillingMatID != 0) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        headers: {
          credentials: 'same-origin'
        },
        url: '/wp-json/mattador/v1/calculate_price/?product_id=' + fillingMatID + '&mattador_width=' + width + '&mattador_length=' + length
      }).then(function (response) {
        var matResult = response.data;
        fillingMatPrice = parseFloat(matResult.price);
        fillingMatRawPrice = (fillingMatPrice * quantity).toFixed(2);
        fillingMatTotalPrice = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(fillingMatRawPrice, 2, ',', '.');

        var fillingMatPriceContainer = option.querySelector('.js-woo-filling-mat-price');
        fillingMatPriceContainer.innerHTML = '\u20AC' + fillingMatTotalPrice;

        return fillingMatTotalPrice;
      }).catch(function (error) {
        console.log(error);
        return fillingMatPriceContainer.innerHTML = 'Er is iets misgegaan. Ververs de pagina.';
      });
    }
  });
}

function calculateAdditionalMatPrices(width, length, quantity, array) {
  ;[].concat(_toConsumableArray(array)).forEach(function (option) {
    var additionalMatID = option.dataset.id;
    var additionalMatPrice = 0;
    var additionalMatRawPrice = 0;
    var additionalMatTotalPrice = 0;
    console.log(option.dataset);
    console.log(option.dataset.parent);
    if (option.dataset.parent) return;

    if (additionalMatID != 0) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        headers: {
          credentials: 'same-origin'
        },
        url: '/wp-json/mattador/v1/calculate_price/?product_id=' + additionalMatID + '&mattador_width=' + width + '&mattador_length=' + length
      }).then(function (response) {
        var matResult = response.data;
        additionalMatPrice = parseFloat(matResult.price);
        additionalMatRawPrice = (additionalMatPrice * quantity).toFixed(2);
        additionalMatTotalPrice = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(additionalMatRawPrice, 2, ',', '.');

        var additionalMatPriceContainer = option.querySelector('.js-woo-additional-mat-price');
        additionalMatPriceContainer.innerHTML = '\u20AC' + additionalMatTotalPrice;

        return additionalMatTotalPrice;
      }).catch(function (error) {
        console.log(error);
        return additionalMatPriceContainer.innerHTML = 'Er is iets misgegaan. Ververs de pagina.';
      });
    }
  });
}

function calculateRubberPrices(width, length, quantity, priceBar) {
  var rubberMatPriceContainers = document.querySelectorAll('.js-woo-rubber-mat-price');
  var productID = priceBar.dataset.product;
  var productWithRubberPrice = 0;
  var productWithRubberRawPrice = 0;
  var productWithoutRubberPrice = 0;
  var productWithoutRubberRawPrice = 0;
  var rubberTotalPrice = 0;

  if (!productID) {
    return;
  }

  if (rubberMatPriceContainers.length > 0) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      method: 'get',
      headers: {
        credentials: 'same-origin'
      },
      url: '/wp-json/mattador/v1/calculate_price/?product_id=' + productID + '&mattador_width=' + width + '&mattador_length=' + length + '&mattador_cutter=0&mattador_rubber=0'
    }).then(function (withoutRubberResponse) {
      var withoutRubberResult = withoutRubberResponse.data;
      productWithoutRubberPrice = parseFloat(withoutRubberResult.price);
      productWithoutRubberRawPrice = (productWithoutRubberPrice * quantity).toFixed(2);[].concat(_toConsumableArray(rubberMatPriceContainers)).forEach(function (rubberMatPriceContainer) {
        var rubberMatValue = rubberMatPriceContainer.dataset.value;

        // Calculate rubber price
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'get',
          headers: {
            credentials: 'same-origin'
          },
          url: '/wp-json/mattador/v1/calculate_price/?product_id=' + productID + '&mattador_width=' + width + '&mattador_length=' + length + '&mattador_cutter=0&mattador_rubber=' + rubberMatValue
        }).then(function (withRubberResponse) {
          var rubberResult = withRubberResponse.data;
          productWithRubberPrice = parseFloat(rubberResult.price);
          productWithRubberRawPrice = (productWithRubberPrice * quantity).toFixed(2);

          // Calculate without rubber price
          rubberTotalPrice = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(productWithRubberRawPrice - productWithoutRubberRawPrice, 2, ',', '.');
          rubberMatPriceContainer.innerHTML = '\u20AC' + rubberTotalPrice;
        }).catch(function (error) {
          console.log(error);
        });
      });
    }).catch(function (error) {
      console.log(error);
    });
  }
}

function calculatePrice(validation, width, length, hasRubber, hasCutter, quantity, priceBar, elements, hiddenPrice, fillingMat, additionalMat) {
  // Return early if invalid entry
  if (!validation.status && elements.cartButton) {
    elements.cartButton.disabled = true;
    return;
  }

  // Get price elements
  var priceField = priceBar.querySelector('.js-woo-price');
  var regularPriceField = priceBar.querySelector('.js-woo-regular-price');
  var taxFields = priceBar.querySelectorAll('.js-woo-price-tax');
  var result = '';
  var singlePrice = 0;
  var rawPrice = 0;
  var totalPrice = 0;
  var totalRawPrice = 0;
  var fillingMatPrice = 0;
  var fillingMatRawPrice = 0;
  var fillingMatTotalPrice = 0;
  var fillingMatSelectionArray = [];
  var additionalMatPrice = 0;
  var additionalMatRawPrice = 0;
  var additionalMatTotalPrice = 0;
  var additionalMatSelectionArray = [];

  // Get product id
  var productID = priceBar.dataset.product;
  if (!productID) {
    priceField.innerHTML = 'Product informatie kon niet opgehaald worden. Ververs de pagina.';
    if (regularPriceField) {
      regularPriceField.innerHTML = '';
    }
    return;
  }

  // Show some feedback
  priceField.innerHTML = 'Berekenen...';[].concat(_toConsumableArray(taxFields)).forEach(function (taxField) {
    taxField.innerHTML = 'incl. btw'; //removes 'vanaf'
  });
  if (regularPriceField) {
    regularPriceField.classList.add('active');
    regularPriceField.innerHTML = '';
  }

  // Temporarily disable fields
  disableFields(elements);

  // Fetch price
  __WEBPACK_IMPORTED_MODULE_3_axios___default()({
    method: 'get',
    headers: {
      credentials: 'same-origin'
    },
    url: '/wp-json/mattador/v1/calculate_price/?product_id=' + productID + '&mattador_width=' + width + '&mattador_length=' + length + '&mattador_cutter=' + hasCutter + '&mattador_rubber=' + hasRubber
  }).then(function (response) {
    result = response.data;

    singlePrice = parseFloat(result.price * quantity);
    rawPrice = (singlePrice * quantity).toFixed(2);
    totalPrice = singlePrice;
    totalRawPrice = singlePrice;

    if (fillingMat && fillingMat.length > 1) {
      ;[].concat(_toConsumableArray(fillingMat)).forEach(function (mat) {
        var fillingMatID = mat ? mat.dataset.id : false;

        if (fillingMatID != 0) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default()({
            method: 'get',
            headers: {
              credentials: 'same-origin'
            },
            url: '/wp-json/mattador/v1/calculate_price/?product_id=' + fillingMatID + '&mattador_width=' + width + '&mattador_length=' + length
          }).then(function (matResponse) {
            var matResult = matResponse.data;
            fillingMatPrice = parseFloat(matResult.price);
            fillingMatRawPrice = (fillingMatPrice * quantity).toFixed(2);
            fillingMatTotalPrice = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(fillingMatRawPrice, 2, ',', '.');
            fillingMat = document.querySelector('.js-woo-filling-mat-option[data-id="' + fillingMatID + '"]');

            var fillingMatPriceContainer = fillingMat.querySelector('.js-woo-filling-mat-price');
            fillingMatPriceContainer.innerHTML = '\u20AC' + fillingMatTotalPrice;

            totalRawPrice = fillingMat && fillingMatTotalPrice != 0 ? totalRawPrice + fillingMatPrice * quantity : singlePrice;

            totalPrice = fillingMat && fillingMatTotalPrice != 0 ? Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(totalRawPrice, 2, ',', '.') : Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(singlePrice, 2, ',', '.');

            priceField.innerHTML = '\u20AC' + totalPrice;
            hiddenPrice.value = totalPrice;
            if (elements.mobilePriceField) elements.mobilePriceField.innerHTML = '\u20AC' + totalPrice;

            var fillingMatSelection = document.querySelector('.js-woo-filling-mat-selection');
            fillingMatSelectionArray.push(fillingMatID);
            fillingMatSelection.setAttribute('value', JSON.stringify(fillingMatSelectionArray));

            if (regularPriceField) {
              var regularPrice = parseFloat(result.regular_price);
              var rawRegularPrice = (regularPrice * quantity).toFixed(2);
              regularPriceField.classList.remove('active');
              regularPriceField.innerHTML = '\u20AC' + Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(rawRegularPrice, 2, ',', '.');
            }

            // Turn fields back on
            return enableFields(elements);
          }).catch(function (error) {
            console.log(error);
            return priceField.innerHTML = 'Er is iets misgegaan. Ververs de pagina.';
          });
        }
      });
    } else {
      // Set price (formatted for Dutch)
      singlePrice = parseFloat(result.price);
      rawPrice = (singlePrice * quantity).toFixed(2);
      totalPrice = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(rawPrice, 2, ',', '.');

      priceField.innerHTML = '\u20AC' + totalPrice;
      hiddenPrice.value = totalPrice;
      if (elements.mobilePriceField) elements.mobilePriceField.innerHTML = '\u20AC' + totalPrice;

      if (regularPriceField) {
        var regularPrice = parseFloat(result.regular_price);
        var rawRegularPrice = (regularPrice * quantity).toFixed(2);
        regularPriceField.classList.remove('active');
        regularPriceField.innerHTML = '\u20AC' + Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(rawRegularPrice, 2, ',', '.');
      }

      // Turn fields back on
      return enableFields(elements);
    }
  }).then(function (res) {
    if (additionalMat && additionalMat.length > 0) {
      additionalMat = document.querySelectorAll('.js-woo-additional-product-option.active');[].concat(_toConsumableArray(additionalMat)).forEach(function (mat) {
        var additionalMatID = mat ? mat.dataset.id : false;
        if (additionalMatID != 0) {
          priceField.innerHTML = 'Berekenen...';
          disableFields(elements);
          __WEBPACK_IMPORTED_MODULE_3_axios___default()({
            method: 'get',
            headers: {
              credentials: 'same-origin'
            },
            url: '/wp-json/mattador/v1/calculate_price/?product_id=' + additionalMatID + '&mattador_width=' + width + '&mattador_length=' + length
          }).then(function (matResponse) {
            additionalMat = document.querySelector('.js-woo-additional-product-option[data-id="' + additionalMatID + '"]');

            var additionalMatPriceContainer = additionalMat.querySelector('.js-woo-additional-mat-price');
            var matResult = matResponse.data;

            if (additionalMat.dataset.parent) {
              additionalMatPrice = parseFloat(additionalMatPriceContainer.dataset.price.replace('€', '').replace(',', '.'));
            } else {
              additionalMatPrice = parseFloat(matResult.price);
            }

            additionalMatRawPrice = (additionalMatPrice * quantity).toFixed(2);
            additionalMatTotalPrice = Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(additionalMatRawPrice, 2, ',', '.');
            console.log('Price 1:');
            console.log(additionalMatPrice);
            console.log(quantity);
            console.log(additionalMatRawPrice);
            console.log(additionalMatTotalPrice);

            additionalMatPriceContainer.innerHTML = '\u20AC' + additionalMatTotalPrice;

            totalRawPrice = additionalMat && additionalMatTotalPrice != 0 ? totalRawPrice + additionalMatPrice * quantity : singlePrice;

            totalPrice = additionalMat && additionalMatTotalPrice != 0 ? Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(totalRawPrice, 2, ',', '.') : Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(singlePrice, 2, ',', '.');

            priceField.innerHTML = '\u20AC' + totalPrice;
            hiddenPrice.value = totalPrice;
            if (elements.mobilePriceField) elements.mobilePriceField.innerHTML = '\u20AC' + totalPrice;

            var additionalMatSelection = document.querySelector('.js-woo-additional-product-selection');

            if (additionalMat.dataset.parent) {
              additionalMatSelectionArray.push(additionalMat.dataset.parent + ';' + additionalMatID);
            } else {
              additionalMatSelectionArray.push(additionalMatID);
            }

            additionalMatSelection.setAttribute('value', JSON.stringify(additionalMatSelectionArray));

            if (regularPriceField) {
              var regularPrice = parseFloat(result.regular_price);
              var rawRegularPrice = (regularPrice * quantity).toFixed(2);
              regularPriceField.classList.remove('active');
              regularPriceField.innerHTML = '\u20AC' + Object(__WEBPACK_IMPORTED_MODULE_2__NumberFormat__["a" /* numberFormat */])(rawRegularPrice, 2, ',', '.');
            }

            // Turn fields back on
            return enableFields(elements);
          }).catch(function (error) {
            console.log(error);
            return priceField.innerHTML = 'Er is iets misgegaan. Ververs de pagina.';
          });
        }
      });
    }
  }).catch(function (error) {
    console.log(error);
    return priceField.innerHTML = 'Er is iets misgegaan. Ververs de pagina.';
  });
}

function disableOtherFields(elements) {
  if (elements.rubberCheckbox) {
    ;[].concat(_toConsumableArray(elements.rubberCheckbox)).forEach(function (el) {
      el.disabled = true;
    });
  }
  if (elements.cutterCheckbox) {
    elements.cutterCheckbox.disabled = true;
  }
}

/**
 * Disable all input fields and cart button
 */
function disableFields(elements) {
  if (elements.rubberCheckbox) {
    ;[].concat(_toConsumableArray(elements.rubberCheckbox)).forEach(function (el) {
      el.disabled = true;
    });
  }
  if (elements.fillingCheckbox) {
    ;[].concat(_toConsumableArray(elements.fillingCheckbox)).forEach(function (el) {
      el.classList.add('disabled');
    });
  }
  if (elements.additionalCheckbox) {
    ;[].concat(_toConsumableArray(elements.additionalCheckbox)).forEach(function (el) {
      el.classList.add('disabled');
    });
  }
  if (elements.cutterCheckbox) {
    elements.cutterCheckbox.disabled = true;
  }
  if (elements.widthInput) {
    elements.widthInput.disabled = true;
  }
  if (elements.lengthInput) {
    elements.lengthInput.disabled = true;
  }
  if (elements.quantityInput) {
    elements.quantityInput.disabled = true;
  }
  if (elements.cartButton) {
    elements.cartButton.disabled = true;
  }
  if (elements.cartSecondButton) {
    elements.cartSecondButton.classList.add('disabled');
  }
  if (elements.typeRadios) {
    ;[].concat(_toConsumableArray(elements.typeRadios)).forEach(function (radio) {
      radio.disabled = true;
    });
  }
  if (elements.defaultSelect) {
    elements.defaultSelect.disabled = true;
  }
}

/**
 * Enable all input fields and cart button
 */
function enableFields(elements) {
  if (elements.rubberCheckbox) {
    ;[].concat(_toConsumableArray(elements.rubberCheckbox)).forEach(function (el) {
      el.disabled = false;
    });
  }
  if (elements.fillingCheckbox) {
    ;[].concat(_toConsumableArray(elements.fillingCheckbox)).forEach(function (el) {
      el.classList.remove('disabled');
    });
  }
  if (elements.additionalCheckbox) {
    ;[].concat(_toConsumableArray(elements.additionalCheckbox)).forEach(function (el) {
      el.classList.remove('disabled');
    });
  }
  if (elements.cutterCheckbox) {
    elements.cutterCheckbox.disabled = false;
  }
  if (elements.widthInput) {
    elements.widthInput.disabled = false;
  }
  if (elements.lengthInput) {
    elements.lengthInput.disabled = false;
  }
  if (elements.quantityInput) {
    elements.quantityInput.disabled = false;
  }
  if (elements.cartButton) {
    elements.cartButton.disabled = false;
  }
  if (elements.cartSecondButton) {
    elements.cartSecondButton.classList.remove('disabled');
  }
  if (elements.typeRadios) {
    ;[].concat(_toConsumableArray(elements.typeRadios)).forEach(function (radio) {
      radio.disabled = false;
    });
  }
  if (elements.defaultSelect) {
    elements.defaultSelect.disabled = false;
  }
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(62);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(16);
var Axios = __webpack_require__(63);
var mergeConfig = __webpack_require__(22);
var defaults = __webpack_require__(9);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(10);
axios.CancelToken = __webpack_require__(77);
axios.isCancel = __webpack_require__(21);
axios.VERSION = __webpack_require__(23).version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(78);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(79);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(17);
var InterceptorManager = __webpack_require__(64);
var dispatchRequest = __webpack_require__(65);
var mergeConfig = __webpack_require__(22);
var validator = __webpack_require__(76);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(66);
var isCancel = __webpack_require__(21);
var defaults = __webpack_require__(9);
var Cancel = __webpack_require__(10);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var defaults = __webpack_require__(9);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(20);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(72);
var combineURLs = __webpack_require__(73);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(23).version;

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(10);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DimensionsValidation__ = __webpack_require__(15);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Woocommerce: Dimensions Feedback
 *
 * Give feedback on the values entered
 * in the width and length
 *
 * @since 1.0.0
 */



/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Grab all necessary elements
  var cartForm = document.querySelector('form.cart');
  if (!cartForm) return;

  var widthInput = cartForm.querySelector('.js-woo-width');
  var lengthInput = cartForm.querySelector('.js-woo-length');
  var diameterInput = cartForm.querySelector('.js-woo-diameter');
  var rubberRadios = cartForm.querySelectorAll('.js-woo-rubber');
  var feedbackField = cartForm.querySelector('.js-woo-dimensions-feedback');

  if (!widthInput || !lengthInput || !feedbackField) {
    return;
  }

  // Standard values
  var message = '';
  var width = 0;
  var length = 0;
  var diameter = 0;
  var hasRubber = 0;
  var timer = 0;

  // Increase max dimension if user has checked rubber_edge
  if (rubberRadios) [].concat(_toConsumableArray(rubberRadios)).map(function (rubberRadio) {
    rubberRadio.addEventListener('change', function (e) {
      hasRubber = e.target.value === '1' && e.target.checked ? 1 : 0;
      message = Object(__WEBPACK_IMPORTED_MODULE_0__DimensionsValidation__["a" /* dimensionsFeedback */])(width, length, hasRubber, cartForm);
      feedbackField.innerHTML = message;
    });
  });

  // Change feedback based on width value
  widthInput.addEventListener('input', function (e) {
    width = e.target.value;
    clearTimeout(timer);

    // Wait for user to finish typing
    timer = setTimeout(function () {
      // Determine validation message
      message = Object(__WEBPACK_IMPORTED_MODULE_0__DimensionsValidation__["a" /* dimensionsFeedback */])(width, length, hasRubber, cartForm);

      if (!width) {
        // Validate empty length
        message = 'Voer het gewenste formaat in.';
      }

      feedbackField.innerHTML = message;
    }, 500);
  });

  // Change feedback based on length value
  lengthInput.addEventListener('input', function (e) {
    length = e.target.value;
    clearTimeout(timer);

    // Wait for user to finish typing
    timer = setTimeout(function () {
      // Determine validation message
      message = Object(__WEBPACK_IMPORTED_MODULE_0__DimensionsValidation__["a" /* dimensionsFeedback */])(width, length, hasRubber, cartForm);

      if (!length) {
        // Validate empty length
        message = 'Voer het gewenste formaat in.';
      }

      feedbackField.innerHTML = message;
    }, 500);
  });

  // Change feedback based on width value
  if (diameterInput) {
    diameterInput.addEventListener('input', function (e) {
      width = e.target.value;
      length = e.target.value;
      diameter = e.target.value;
      widthInput.value = width;
      lengthInput.value = length;
      clearTimeout(timer);

      // Wait for user to finish typing
      timer = setTimeout(function () {
        // Determine validation message
        message = Object(__WEBPACK_IMPORTED_MODULE_0__DimensionsValidation__["a" /* dimensionsFeedback */])(width, length, hasRubber, cartForm, diameter);

        if (!diameter) {
          // Validate empty length
          message = 'Voer het gewenste formaat in.';
        }

        feedbackField.innerHTML = message;
      }, 500);
    });
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Show Options
 *
 * Hide additional options until any of the parental radio buttons has been clicked
 * (will show all if javascript is off)
 *
 * @since 1.0.0
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-woo-options');
  if (!container) return;
  if (container.dataset.default === 'yes') return;
  var sizeContainer = container.querySelector('.js-woo-sizes');
  var dimensionsContainer = container.querySelector('.js-woo-dimensions');
  var defaultSizesContainer = container.querySelector('.js-woo-default-sizes');

  if (!sizeContainer || !dimensionsContainer || !defaultSizesContainer) return;

  dimensionsContainer.classList.add('inactive');
  defaultSizesContainer.classList.add('inactive');
  var customButton = sizeContainer.querySelector('.js-woo-sizes-custom');
  var defaultButton = sizeContainer.querySelector('.js-woo-sizes-default');
  var customBack = dimensionsContainer.querySelector('.js-woo-back');
  var defaultBack = defaultSizesContainer.querySelector('.js-woo-back');
  var select = defaultSizesContainer.querySelector('.js-woo-default-select');

  customButton.addEventListener('click', function (e) {
    showOption(dimensionsContainer);
    hideOption(sizeContainer);
  });

  defaultButton.addEventListener('click', function (e) {
    showOption(defaultSizesContainer);
    hideOption(sizeContainer);
  });

  if (customBack) {
    customBack.addEventListener('click', function (e) {
      showOption(sizeContainer);
      hideOption(dimensionsContainer);
    });
  }

  if (defaultBack) {
    defaultBack.addEventListener('click', function (e) {
      showOption(sizeContainer);
      hideOption(defaultSizesContainer);
    });
  }

  if (select) {
    select.addEventListener('change', function (e) {
      var sizes = e.currentTarget.value.split('x');
      var width = sizes[1];
      var height = sizes[0];
      enterDefaultDimensions(container, width, height);
      select.disabled = true;
    });
  }

  // if (input.value == 'standard') {
  //   // Enter default dimensions
  //   enterDefaultDimensions(container)
  // }
  // if (input.value == 'custom') {
  //   showCustomDimensions(container)
  // }
});

function enterDefaultDimensions(container, width, height) {
  var widthInput = container.querySelector('.js-woo-width');
  var lengthInput = container.querySelector('.js-woo-length');

  if (!widthInput || !lengthInput) return;

  // Set to default dimensions
  widthInput.value = Number(width);
  lengthInput.value = Number(height);

  // Trigger events in order to trigger CalculatePrice
  widthInput.dispatchEvent(new Event('input', { bubbles: true }));
  lengthInput.dispatchEvent(new Event('input', { bubbles: true }));
}

function showOption(container) {
  if (container && container.classList.contains('inactive')) {
    container.classList.remove('inactive');
  }
}

function hideOption(container) {
  if (container) {
    container.classList.add('inactive');
  }
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Product Filters
 * 
 * @since 1.0.0
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var forms = document.querySelectorAll('.js-product-filters');
  if (forms.length < 1) return;[].concat(_toConsumableArray(forms)).forEach(function (form) {
    // Submit form whenever a filter is chosen
    var savers = form.querySelectorAll('.js-product-run-filter');

    if (savers.length > 0) {
      ;[].concat(_toConsumableArray(savers)).forEach(function (saver) {
        saver.addEventListener('click', function () {
          form.submit();
        });
      });
    }

    // Submit form whenever a sort filter is chosen
    var sorter = form.querySelector('.js-product-run-sort-filter');

    if (sorter) {
      sorter.addEventListener('change', function () {
        form.submit();
      });
    }
  });
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Product Filters Toggle
 * 
 * @since 1.0.0
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-product-filter-toggle');
  if (!container) return;

  var triggers = container.querySelectorAll('.js-product-filter-toggle-trigger');
  var panels = container.querySelectorAll('.js-product-filter-toggle-panel');
  var closers = container.querySelectorAll('.js-product-filter-toggle-close');

  if (triggers.length < 1 || panels.length < 1 || triggers.length !== panels.length) return;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    trigger.addEventListener('click', addActive);
  });

  if (closers.length > 1) {
    ;[].concat(_toConsumableArray(closers)).forEach(function (closer) {
      closer.addEventListener('click', closeAll);
    });
  }

  /**
   * Toggle .active classes if click a trigger
   */
  function addActive(e) {
    var clickedTrigger = e.target.closest('.js-product-filter-toggle-trigger');
    var name = clickedTrigger.dataset.name;
    var matchingPanel = container.querySelector('.js-product-filter-toggle-panel[data-name=' + name + ']');

    // Toggle .active if clicking the same trigger twice
    if (clickedTrigger.classList.contains('active')) {
      clickedTrigger.classList.remove('active');
      matchingPanel.classList.remove('active');
      return;

      // Set new .active
    } else {
      closeAll();
      clickedTrigger.classList.add('active');
      matchingPanel.classList.add('active');
    }
  }

  /**
   * Remove all .active classes
   */
  function closeAll() {
    ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
      if (trigger.classList.contains('active')) {
        trigger.classList.remove('active');
      }
    });[].concat(_toConsumableArray(panels)).forEach(function (panel) {
      if (panel.classList.contains('active')) {
        panel.classList.remove('active');
      }
    });
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Monitor if the value of the variation has changed, if so, set the variation ID
  jQuery('input.variation_id').change(function () {
    jQuery('input.sample_variation_id').val(jQuery('input.variation_id').val());
    if (document.getElementById('pa_afmetingen')) {
      var priceContainer = document.querySelector('.js-woo-default-variation-price');
      var priceField = document.querySelector('.js-woo-price');

      if (priceContainer) {
        var bdi = priceContainer.querySelector('bdi');
        var cleanPrice = bdi.innerHTML.replace(/(<([^>]+)>)/gi, '').replace('€&nbsp;', '');
        if (priceField) {
          priceField.innerHTML = cleanPrice;
        }
      }
    }
  });
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var forms = document.querySelectorAll('.js-add-to-cart-form');
  if (forms.length > 0) {
    ;[].concat(_toConsumableArray(forms)).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var formData = new window.FormData(form);
        var data = {};
        formData.forEach(function (value, key) {
          data[key] = value;
        });
        window.dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            add: {
              // 'add' actionFieldObject measures.
              products: [{
                name: data.product_name,
                id: data.product_id,
                price: data.hidden_price,
                variant: data.attribute_pa_kleur ? data.attribute_pa_kleur : '',
                quantity: data.quantity,
                category_0: data.category_0,
                category_1: data.category_1,
                width: data.mattador_width,
                length: data.mattador_length,
                rubber: data.mattador_rubber ? data.mattador_rubber : '',
                filler_mat: data.filler_mat ? data.filler_mat : ''
              }]
            }
          }
        });

        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'EUR',
            value: data.hidden_price,
            items: [{
              item_name: data.product_name,
              item_id: data.product_id,
              price: data.hidden_price,
              variant: data.attribute_pa_kleur ? data.attribute_pa_kleur : '',
              quantity: data.quantity,
              category_0: data.category_0,
              category_1: data.category_1,
              width: data.mattador_width,
              length: data.mattador_length,
              rubber: data.mattador_rubber ? data.mattador_rubber : '',
              filler_mat: data.filler_mat ? data.filler_mat : ''
            }]
          }
        });

        // let eventSend = false
        // if (!eventSend) {
        //   e.preventDefault()

        //   try {
        //     const formData = new window.FormData(form)
        //     const data = {}
        //     formData.forEach((value, key) => {data[key] = value});
        //     window.dataLayer.push({
        //       'event': 'addToCart',
        //       'ecommerce': {
        //         'add': {                                // 'add' actionFieldObject measures.
        //           'products': [{
        //             name: data.product_name,
        //             id: data.product_id,
        //             price: data.hidden_price,
        //             variant: data.attribute_pa_kleur ? data.attribute_pa_kleur : '',
        //             quantity: data.quantity,
        //             category_0: data.category_0,
        //             category_1: data.category_1,
        //             width: data.mattador_width,
        //             length: data.mattador_length,
        //             rubber: data.mattador_rubber ? data.mattador_rubber : ''
        //           }]
        //         }
        //       },
        //       'eventCallback': function() {
        //         eventSend = true
        //         form.submit()
        //       }
        //     });
        //   } catch(e) {
        //     console.error(e)
        //     eventSend = true
        //     form.submit()
        //   }

        // } else {
        //   form.submit()
        // }
      });
    });
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var buttons = document.querySelectorAll('.js-chat-activity');
  if (buttons.length < 1) return;
  var chatInterval = void 0;
  var interval = void 0
  // Can fail locally
  ;[].concat(_toConsumableArray(buttons)).forEach(function (button) {
    var pulse = button.querySelector('.js-pulse');
    if (window.HubSpotConversations) {
      chatInterval = window.setInterval(checkChatStatus, 5000, button, pulse);
      interval = window.setInterval(checkCookieStatus, 1000);
    } else {
      window.hsConversationsOnReady = [function () {
        chatInterval = window.setInterval(checkChatStatus, 5000, button, pulse);
        interval = window.setInterval(checkCookieStatus, 1000);
      }];
    }
  });

  var checkChatStatus = function checkChatStatus(button, pulse) {
    var status = window.HubSpotConversations.widget.status();
    if (status.loaded) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        window.HubSpotConversations.widget.open();
      });
      pulse.classList.remove('c-pulse--off');
      pulse.classList.add('c-pulse--on');
      window.clearInterval(chatInterval);
    } else {
      pulse.classList.remove('c-pulse--on');
      pulse.classList.add('c-pulse--off');
    }
  };

  var checkCookieStatus = function checkCookieStatus() {
    var status = window.HubSpotConversations.widget.status();
    var notice = document.querySelector('.js-cookie-notice');

    // If the chat is loaded and the cookie notice is still available, remove the chat. Refresh will reinstate the chat
    if (status.loaded && notice) {
      window.HubSpotConversations.widget.remove();
      window.clearInterval(interval);
    } else if (!notice) {
      window.clearInterval(interval);
    }
  };
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var link = document.querySelector('.js-open-filler-mat');
  if (!link) return;

  link.addEventListener('click', function (e) {
    e.preventDefault();
    var r = window.confirm('Weet je zeker dat je naar een andere pagina wilt navigeren? Je ingevulde gegevens gaan dan verloren.');
    if (r == true) {
      window.location = e.currentTarget.href;
    }
  });
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var colorContainer = document.getElementById('picker_pa_kleur');
  if (!colorContainer) return;

  var colors = colorContainer.querySelectorAll('.select-option');[].concat(_toConsumableArray(colors)).forEach(function (color) {
    if (color.dataset.attribute && color.dataset.attribute === 'pa_kleur') {
      color.addEventListener('click', function (e) {
        updateURL(color.dataset.value);
      });
    }
  });

  var updateURL = function updateURL(color) {
    // Update URL so page is set on refresh
    if (history.pushState) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + ('?attribute_pa_kleur=' + color);
      window.history.pushState({ path: newurl }, '', newurl);
    }
  };
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollmonitor__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ScrollAnimation = function () {
  function ScrollAnimation() {
    _classCallCheck(this, ScrollAnimation);

    this.animationCount = 1;
    this.animationDelay = 1000;
    this.isScrolling = false;
    this.isAnimating = false;
    this.layerOne = document.querySelector('.js-animated-content-layer-1');
    this.layerTwo = document.querySelector('.js-animated-content-layer-2');
    this.layerThree = document.querySelector('.js-animated-content-layer-3');
    this.layerFour = document.querySelector('.js-animated-content-layer-4');
    this.largePulse = document.querySelector('.js-animated-content-pulse');
    this.secondLargePulse = document.querySelector('.js-animated-content-pulse-second');
    this.wrapper = document.querySelector('.js-animated-content-wrapper');
    this.container = document.querySelector('.js-animated-content');
    this.isFinished = false;
  }

  _createClass(ScrollAnimation, [{
    key: 'start',
    value: function start() {
      var _this = this;

      var scrollContainer = document.querySelector('.js-animated-content-scroll');

      if (!this.container) return;

      // Watchers
      var watcherContainer = __WEBPACK_IMPORTED_MODULE_0_scrollmonitor__["a" /* default */].create(this.container);

      watcherContainer.fullyEnterViewport(function () {
        if (!_this.isFinished) {
          _this.container.classList.add('fixed');
          _this.wrapper.classList.add('full-view');
          _this.layerOne.classList.add('fixed');
          _this.layerTwo.classList.add('hidden');
          _this.layerThree.classList.add('hidden');
          _this.layerFour.classList.add('hidden');

          Object(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])(_this.wrapper);

          _this.animate();

          scrollContainer.addEventListener('scroll', function (e) {
            if (!_this.isScrolling && !_this.isAnimating) _this.animate();

            _this.isScrolling = true;

            window.setTimeout(function () {
              _this.isScrolling = false;
            }, 500);
          });
        }
      });
    }
  }, {
    key: 'animate',
    value: function animate() {
      var _this2 = this;

      this.layerOne.classList.add('animation-1');
      if (this.animationCount === 1) {
        console.log('starting stap 1');
        this.isAnimating = true;
        window.setTimeout(function (e) {
          _this2.layerOne.classList.add('animation-1-hidden');
          _this2.largePulse.classList.add('active');
          _this2.animationCount++;
          console.log('stap 1');
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 2) {
        console.log('starting stap 2');
        this.isAnimating = true;
        window.setTimeout(function (e) {
          _this2.layerOne.classList.add('animation-1-hidden');
          _this2.animationCount++;
          console.log('stap 2');
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 3) {
        console.log('starting stap 3');
        this.isAnimating = true;
        window.setTimeout(function (e) {
          _this2.largePulse.classList.add('active');
          console.log('stap 3');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 4) {
        this.isAnimating = true;
        console.log('starting stap 4');
        window.setTimeout(function (e) {
          _this2.largePulse.classList.add('pulse-increase');
          _this2.largePulse.classList.remove('active');

          _this2.layerOne.classList.add('fixed');
          _this2.layerTwo.classList.add('hidden');
          _this2.layerTwo.classList.remove('fixed');
          _this2.largePulse.classList.remove('pulse-hidden');
          _this2.secondLargePulse.classList.remove('pulse-hidden');
          _this2.animationCount++;
          console.log('stap 4');
          _this2.isAnimating = false;
        }, 1500);
      }

      if (this.animationCount === 5) {
        console.log('starting stap 5');
        this.isAnimating = true;
        window.setTimeout(function (e) {
          _this2.layerTwo.classList.remove('hidden');
          _this2.layerTwo.classList.add('fixed');
          _this2.layerOne.classList.remove('fixed');
          _this2.layerOne.classList.add('hidden');
          _this2.layerTwo.classList.remove('active');
          _this2.secondLargePulse.classList.add('pulse-increase');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 6) {
        this.isAnimating = true;
        console.log('starting stap 6');
        window.setTimeout(function (e) {
          _this2.secondLargePulse.classList.remove('pulse-increase');
          _this2.secondLargePulse.classList.remove('pulse-hidden');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 7) {
        this.isAnimating = true;
        console.log('starting stap 7');
        window.setTimeout(function (e) {
          _this2.secondLargePulse.classList.add('pulse-hidden');
          _this2.layerTwo.classList.remove('active');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 8) {
        this.isAnimating = true;
        console.log('starting stap 8');
        window.setTimeout(function (e) {
          _this2.layerTwo.classList.add('active');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 9) {
        console.log('starting stap 9');
        this.isAnimating = true;
        window.setTimeout(function (e) {
          _this2.layerTwo.classList.remove('active');

          _this2.layerThree.classList.add('hidden');
          _this2.layerThree.classList.remove('fixed');
          _this2.layerTwo.classList.remove('zoom-image');
          _this2.layerThree.classList.remove('fadein-image');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 3000);
      }

      if (this.animationCount === 10) {
        this.isAnimating = true;
        console.log('starting stap 10');
        window.setTimeout(function (e) {
          _this2.layerTwo.classList.add('zoom-image');

          _this2.layerThree.classList.remove('hidden');
          _this2.layerThree.classList.add('fixed');
          _this2.layerThree.classList.add('fadein-image');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 11) {
        this.isAnimating = true;
        console.log('starting stap 11');
        window.setTimeout(function (e) {
          _this2.layerTwo.classList.remove('fixed');
          _this2.layerTwo.classList.add('hidden');
          _this2.layerTwo.classList.remove('zoom-image');
          _this2.layerThree.classList.remove('active');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 12) {
        this.isAnimating = true;
        console.log('starting stap 12');
        window.setTimeout(function (e) {
          _this2.layerThree.classList.add('active');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 13) {
        this.isAnimating = true;
        console.log('starting stap 13');
        window.setTimeout(function (e) {
          _this2.layerThree.classList.remove('active');
          _this2.layerFour.classList.add('hidden');
          _this2.layerFour.classList.remove('fixed');
          _this2.layerThree.classList.remove('zoom-image');
          _this2.layerFour.classList.remove('fadein-image');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 3000);
      }

      if (this.animationCount === 14) {
        this.isAnimating = true;
        console.log('starting stap 14');
        window.setTimeout(function (e) {
          _this2.layerThree.classList.add('zoom-image');

          _this2.layerFour.classList.remove('hidden');
          _this2.layerFour.classList.add('fixed');
          _this2.layerFour.classList.add('fadein-image');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 15) {
        this.isAnimating = true;
        console.log('starting stap 15');
        window.setTimeout(function (e) {
          _this2.layerThree.classList.remove('fixed');
          _this2.layerThree.classList.add('hidden');
          _this2.layerThree.classList.remove('zoom-image');
          _this2.layerFour.classList.remove('active');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 16) {
        this.isAnimating = true;
        console.log('starting stap 16');
        window.setTimeout(function (e) {
          _this2.layerFour.classList.remove('active');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 17) {
        this.isAnimating = true;
        console.log('starting stap 17');
        window.setTimeout(function (e) {
          _this2.layerFour.classList.add('active');
          _this2.layerFour.classList.add('fixed');
          _this2.animationCount++;
          _this2.isAnimating = false;
        }, 1000);
      }

      if (this.animationCount === 18) {
        this.isAnimating = true;
        console.log('starting stap 18');
        window.setTimeout(function (e) {
          _this2.layerFour.classList.remove('fixed');
          _this2.wrapper.classList.remove('full-view');
          _this2.container.classList.remove('fixed');
          _this2.layerTwo.classList.add('active');
          _this2.layerThree.classList.add('active');

          Object(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["enableBodyScroll"])(_this2.wrapper);

          _this2.isFinished = true;
          _this2.layerTwo.classList.remove('hidden');
          _this2.layerThree.classList.remove('hidden');

          document.getElementById('c-animation-three-layers__end').scrollIntoView();
        }, 1000);
      }
    }
  }]);

  return ScrollAnimation;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScrollAnimation);

/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-trigger-target');

  if (containers.length < 1) return;

  if (!('IntersectionObserver' in window)) {
    return;
  }

  [].concat(_toConsumableArray(containers)).forEach(function (container) {
    var triggers = container.querySelectorAll('.js-trigger-target--trigger');
    var targets = container.querySelectorAll('.js-trigger-target--target');
    var dots = container.querySelectorAll('.js-trigger-target--dot');
    var sliderObserver = '';

    if (window.innerWidth < 768) {
      sliderObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var name = entry.target.dataset.content;
            var target = container.querySelector('[data-target="' + name + '"]');
            var trigger = container.querySelector('[data-content="' + name + '"]');
            var dot = container.querySelector('[data-index="' + name + '"]');

            console.log(name);

            [].concat(_toConsumableArray(dots)).forEach(function (item) {
              if (item !== dot) {
                item.classList.remove('active');
              }
            });

            ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
              if (trigger.classList.contains('active')) {
                trigger.classList.remove('active');
              }
            });[].concat(_toConsumableArray(targets)).forEach(function (target) {
              if (target.classList.contains('active')) {
                target.classList.remove('active');
              }
            });

            target.classList.add('active');
            trigger.classList.add('active');
            // trigger.scrollIntoView({
            //   behavior: 'auto',
            //   block: 'center',
            //   inline: 'center'
            // })
            dot.classList.add('active');
          }
        });
      }, { threshold: 0.8, root: container.querySelector('.c-static-three-layers__container') });
    }

    ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
      trigger.addEventListener('click', addActive);

      if (window.innerWidth < 768) {
        sliderObserver.observe(trigger);
      }
    });

    container.querySelector('.js-trigger-target--target[data-target="descr_1"]').classList.add('active');
    container.querySelector('.js-trigger-target--trigger[data-content="descr_1"]').classList.add('active');

    function addActive(e) {
      var clickedTrigger = e.currentTarget;
      var name = clickedTrigger.dataset.content;
      var matchingContent = container.querySelector('.js-trigger-target--target[data-target=' + name + ']');
      var matchingDot = container.querySelector('.js-trigger-target--dot[data-index=' + name + ']');

      if (!clickedTrigger.classList.contains('active')) {
        closeAll();
        clickedTrigger.classList.add('active');
        matchingContent.classList.add('active');
        matchingDot.classList.add('active');
      }
    }

    function closeAll() {
      ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
        if (trigger.classList.contains('active')) {
          trigger.classList.remove('active');
        }
      });[].concat(_toConsumableArray(targets)).forEach(function (target) {
        if (target.classList.contains('active')) {
          target.classList.remove('active');
        }
      });[].concat(_toConsumableArray(dots)).forEach(function (dot) {
        if (dot.classList.contains('active')) {
          dot.classList.remove('active');
        }
      });
    }
  });
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var checkoutSteps = document.querySelector('.js-checkout-steps');
  if (!checkoutSteps) return;

  // Parent
  var billingFirstnameParent = document.querySelector('#billing_first_name_field');
  var billingLastnameParent = document.querySelector('#billing_last_name_field');
  var billingAddressParent = document.querySelector('#billing_address_1_field');
  var billingPostcodeParent = document.querySelector('#billing_postcode_field');
  var billingCityParent = document.querySelector('#billing_city_field');
  var billingCompanyParent = document.querySelector('#billing_company_field');
  var shippingCompanyParent = document.querySelector('#shipping_company_field');
  var billingCountryParent = document.querySelector('#billing_country_field');
  var billingPhoneParent = document.querySelector('#billing_phone_field');
  var billingEmailParent = document.querySelector('#billing_email_field');

  var shippingFirstnameParent = document.querySelector('#shipping_first_name_field');
  var shippingLastnameParent = document.querySelector('#shipping_last_name_field');
  var shippingAddressParent = document.querySelector('#shipping_address_1_field');
  var shippingPostcodeParent = document.querySelector('#shipping_postcode_field');
  var shippingCityParent = document.querySelector('#shipping_city_field');
  var shippingCountryParent = document.querySelector('#shipping_country_field');

  // Input field
  var billingFirstname = document.querySelector('#billing_first_name');
  var billingLastname = document.querySelector('#billing_last_name');
  var billingAddress = document.querySelector('#billing_address_1');
  var billingPostcode = document.querySelector('#billing_postcode');
  var billingCity = document.querySelector('#billing_city');
  var billingCountry = document.querySelector('#billing_country');
  var billingPhone = document.querySelector('#billing_phone');
  var billingEmail = document.querySelector('#billing_email');
  var billingCompany = document.querySelector('#billing_company');

  var shippingFirstname = document.querySelector('#shipping_first_name');
  var shippingLastname = document.querySelector('#shipping_last_name');
  var shippingAddress = document.querySelector('#shipping_address_1');
  var shippingPostcode = document.querySelector('#shipping_postcode');
  var shippingCity = document.querySelector('#shipping_city');
  var shippingCountry = document.querySelector('#shipping_country');
  var shippingCompany = document.querySelector('#shipping_company');

  setTimeout(function () {
    if (billingPostcodeParent && billingPostcodeParent.classList.contains('woocommerce-invalid')) {
      billingPostcodeParent.classList.remove('woocommerce-invalid');
      billingPostcodeParent.classList.remove('woocommerce-invalid-required-field');
    }
  }, 500);

  if (billingFirstname.value) billingFirstnameParent.classList.add('focus');
  if (billingLastname.value) billingLastnameParent.classList.add('focus');
  if (billingAddress.value) billingAddressParent.classList.add('focus');
  if (billingPostcode.value) billingPostcodeParent.classList.add('focus');
  if (billingCity.value) billingCityParent.classList.add('focus');
  if (billingCountry.value) billingCountryParent.classList.add('focus');
  if (billingPhone.value) billingPhoneParent.classList.add('focus');
  if (billingEmail.value) billingEmailParent.classList.add('focus');
  if (billingCompany.value) billingCompanyParent.classList.add('focus');

  if (shippingFirstname.value) shippingFirstnameParent.classList.add('focus');
  if (shippingLastname.value) shippingLastnameParent.classList.add('focus');
  if (shippingAddress.value) shippingAddressParent.classList.add('focus');
  if (shippingPostcode.value) shippingPostcodeParent.classList.add('focus');
  if (shippingCity.value) shippingCityParent.classList.add('focus');
  if (shippingCountry.value) shippingCountryParent.classList.add('focus');
  if (shippingCompany.value) shippingCompanyParent.classList.add('focus');
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var checkoutSteps = document.querySelector('.js-checkout-steps');
  if (!checkoutSteps) return;

  var nextButtons = [].concat(_toConsumableArray(document.querySelectorAll('.js-checkout-button-next')));[].concat(_toConsumableArray(nextButtons)).forEach(function (button) {
    return button.addEventListener('click', function () {
      // Value fields
      var billingFirstname = document.querySelector('.c-woocommerce-billing-fields__billing-firstname').innerHTML = document.querySelector('#billing_first_name').value;
      var billingLastname = document.querySelector('.c-woocommerce-billing-fields__billing-lastname').innerHTML = document.querySelector('#billing_last_name').value;
      var billingAddress = document.querySelector('.c-woocommerce-billing-fields__billing-address').innerHTML = document.querySelector('#billing_address_1').value;
      var billingPostcode = document.querySelector('.c-woocommerce-billing-fields__billing-zipcode').innerHTML = document.querySelector('#billing_postcode').value;
      var billingCity = document.querySelector('.c-woocommerce-billing-fields__billing-city').innerHTML = document.querySelector('#billing_city').value;
      var billingCountry = document.querySelector('.c-woocommerce-billing-fields__billing-country').innerHTML = document.querySelector('#billing_country').value;

      var shippingFirstname = document.querySelector('.c-woocommerce-billing-fields__shipping-firstname').innerHTML = document.querySelector('#shipping_first_name').value ? document.querySelector('#shipping_first_name').value : document.querySelector('#billing_first_name').value;
      var shippingLastname = document.querySelector('.c-woocommerce-billing-fields__shipping-lastname').innerHTML = document.querySelector('#shipping_last_name').value ? document.querySelector('#shipping_last_name').value : document.querySelector('#billing_last_name').value;
      var shippingAddress = document.querySelector('.c-woocommerce-billing-fields__shipping-address').innerHTML = document.querySelector('#shipping_address_1').value ? document.querySelector('#shipping_address_1').value : document.querySelector('#billing_address_1').value;
      var shippingPostcode = document.querySelector('.c-woocommerce-billing-fields__shipping-zipcode').innerHTML = document.querySelector('#shipping_postcode').value ? document.querySelector('#shipping_postcode').value : document.querySelector('#billing_postcode').value;
      var shippingCity = document.querySelector('.c-woocommerce-billing-fields__shipping-city').innerHTML = document.querySelector('#shipping_city').value ? document.querySelector('#shipping_city').value : document.querySelector('#billing_city').value;
      var shippingCountry = document.querySelector('.c-woocommerce-billing-fields__shipping-country').innerHTML = document.querySelector('#shipping_country').value ? document.querySelector('#shipping_country').value : document.querySelector('#billing_country').value;

      var shippingFirstnameValue = document.querySelector('#shipping_first_name').value;
      var shippingLastnameValue = document.querySelector('#shipping_last_name').value;
      var shippingAddressValue = document.querySelector('#shipping_address_1').value;
      var shippingcontainer = document.querySelector('.c-woocommerce-billing-fields__shipping');

      if (shippingFirstnameValue && shippingLastnameValue && shippingAddressValue) {
        shippingcontainer.classList.remove('hidden');
      }
    });
  });
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-faq-toggle');
  if (!containers.length > 0) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {
    var trigger = container.querySelector('.js-faq-toggle-trigger');
    var panel = container.querySelector('.js-faq-toggle-panel');

    trigger.addEventListener('click', function (e) {
      if (container.classList.contains('active')) {
        container.classList.remove('active');
      } else {
        ;[].concat(_toConsumableArray(containers)).forEach(function (wrapper) {
          wrapper.classList.remove('active');
        });

        container.classList.add('active');
      }
    });
  });
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var triggers = document.querySelectorAll('.js-trigger-click');
  if (triggers.length < 1) return;

  [].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    var child = trigger.querySelector('.js-target-click');

    trigger.addEventListener('click', function (e) {
      if (e.target.type == 'checkbox') child.classList.toggle('active');
    });
  });
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var triggers = document.querySelectorAll('.js-parent-click');
  if (triggers.length < 1) return;

  // [...triggers].forEach(trigger => {
  //   const children = trigger.querySelectorAll('.js-child-click');

  //   [...children].forEach(child => {
  //     child.addEventListener('click', e => {
  //       trigger.classList.toggle('activated');
  //     });
  //   });
  // });

  [].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    // console.log(trigger)
    var child = trigger.querySelector('.js-child-click');

    child.addEventListener('click', function (e) {
      // console.log(trigger)
      // console.log(child)
      trigger.classList.toggle('activated');
    });
  });
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleActiveClick; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var toggleActiveClick = function toggleActiveClick() {
  var triggers = document.querySelectorAll('.js-active-click');
  if (triggers.length < 1) return;

  [].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      trigger.classList.toggle('active');
    });
  });
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-checkout-steps');
  var validateButton = document.querySelector('.js-checkout-button-validate');
  if (!validateButton) return;
  var steps = document.querySelectorAll('.js-checkout-step-content');
  var prevButtons = [].concat(_toConsumableArray(document.querySelectorAll('.js-checkout-button-prev')));
  var errorMessage = document.querySelector('.js-checkout-error');
  var errorMessageHouseNumber = document.querySelector('.js-checkout-error-number');
  var errorMessageStreetName = document.querySelector('.js-checkout-error-street');
  var stepData = document.querySelector('.js-checkout-step[data-step="1"]');
  var index = 1;

  sendDatalayer('begin_checkout', container.dataset.datalayer);
  sendDatalayer('add_shipping_info', container.dataset.datalayer)

  // Check field values
  ;[].concat(_toConsumableArray(steps)).forEach(function (step) {
    if (step.classList.contains('active') && step.classList.contains('col-1')) {
      var nextButton = step.querySelector('.js-checkout-button-next');

      nextButton.addEventListener('click', function () {
        var billingFirstname = document.querySelector('#billing_first_name').value;
        var billingLastname = document.querySelector('#billing_last_name').value;
        var billingAddress = document.querySelector('#billing_address_1').value;
        var billingPostcode = document.querySelector('#billing_postcode').value;
        var billingCity = document.querySelector('#billing_city').value;
        var billingPhone = document.querySelector('#billing_phone').value;
        var billingMail = document.querySelector('#billing_email').value;

        if (/\d/.test(billingAddress) && /[A-Za-z]+/.test(billingAddress)) {
          errorMessageHouseNumber.classList.remove('active');
          errorMessageStreetName.classList.remove('active');

          if (billingFirstname && billingLastname && billingAddress && billingPostcode && billingCity && billingPhone && billingMail) {
            nextStep();
          } else {
            displayError();
          }
        } else {
          if (!/\d/.test(billingAddress)) {
            if (/[A-Za-z]+/.test(billingAddress)) {
              errorMessageStreetName.classList.remove('active');
            }
            displayErrorHouseNumber();
          }

          console.log(/[A-Za-z]+/.test(billingAddress));

          if (!/[A-Za-z]+/.test(billingAddress)) {
            if (/\d/.test(billingAddress)) {
              errorMessageHouseNumber.classList.remove('active');
            }
            displayErrorStreetName();
          }
        }
      });
    }
  })

  // Back to previous step
  ;[].concat(_toConsumableArray(prevButtons)).forEach(function (button) {
    return button.addEventListener('click', function () {
      var error = document.querySelector('.woocommerce-error');

      if (error) {
        error.style.display = 'none';
      }

      if (index > 1) {
        var currentCheckoutStep = document.querySelector('.js-checkout-step-content[data-content="' + index + '"]');

        var currentStep = document.querySelector('.js-checkout-step[data-step="' + index + '"]');

        index--;

        var prevCheckoutStep = document.querySelector('.js-checkout-step-content[data-content="' + index + '"]');

        var prevStep = document.querySelector('.js-checkout-step[data-step="' + index + '"]');

        prevStep.classList.add('active');
        currentCheckoutStep.classList.remove('active');
        prevCheckoutStep.classList.add('active');
        currentStep.classList.remove('active');
      }

      index !== 1 ? document.querySelector('.c-woocommerce-notice').setAttribute('style', 'display:none;') : document.querySelector('.c-woocommerce-notice').setAttribute('style', 'display:block;');
    });
  });

  // Functions
  function nextStep() {
    var currentIndex = index;
    index++;

    if (index === 2) {
      sendDatalayer('add_payment_info', container.dataset.datalayer);
      stepData.classList.remove('js-checkout-button-disabled');
    } else {
      if (!stepData.classList.contains('js-checkout-button-disabled')) stepData.classList.add('js-checkout-button-disabled');
    }

    var nextStep = document.querySelector('.js-checkout-step[data-step="' + index + '"]');
    var currentStep = document.querySelector('.js-checkout-step[data-step="' + currentIndex + '"]');
    var currentCheckoutStep = document.querySelector('.js-checkout-step-content[data-content="' + currentIndex + '"]');
    var nextCheckoutStep = document.querySelector('.js-checkout-step-content[data-content="' + index + '"]');

    if (!nextStep.classList.contains('active')) {
      currentCheckoutStep.classList.remove('active');
      currentStep.classList.remove('active');
      currentStep.classList.add('cart');
      nextStep.classList.add('active');
      nextCheckoutStep.classList.add('active');
      window.scrollTo(0, 0);
    }

    errorMessage.classList.contains('active') ? errorMessage.classList.remove('active') : '';

    index !== 1 ? document.querySelector('.c-woocommerce-notice').setAttribute('style', 'display:none;') : document.querySelector('.c-woocommerce-notice').setAttribute('style', 'display:block;');
  }

  function displayError() {
    errorMessage.classList.add('active');
  }

  function displayErrorHouseNumber() {
    errorMessageHouseNumber.classList.add('active');
  }

  function displayErrorStreetName() {
    errorMessageStreetName.classList.add('active');
  }

  function sendDatalayer(event, data) {
    // Only send datalayer event once
    if (window.sessionStorage) {
      if (window.sessionStorage.getItem(event) === 'true') return;

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: event,
        ecommerce: JSON.parse(data)
      });

      window.sessionStorage.setItem(event, 'true');
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var cartButton = document.querySelector('.js-woo-cart-button');
  if (!cartButton) return;

  var popup = document.querySelector('.js-woocommerce-popup');
  var close = document.querySelector('.js-woocommerce-popup-close');
  var overlay = document.querySelector('.js-woocommerce-popup-overlay');
  var message = document.querySelector('.woocommerce-message');
  var cartForm = document.querySelector('form.cart');
  var widthInput = cartForm.querySelector('.js-woo-width');
  var lengthInput = cartForm.querySelector('.js-woo-length');

  cartButton.addEventListener('click', function () {
    sessionStorage.setItem('reloading', 'true');

    if (cartForm) {
      sessionStorage.setItem('mattador_width', widthInput.value);
      sessionStorage.setItem('mattador_length', lengthInput.value);
    }
  });

  if (close) {
    overlay.addEventListener('click', function () {
      closePopup(popup, message);
    });

    close.addEventListener('click', function () {
      closePopup(popup, message);
    });
  }

  function closePopup(popup, message) {
    popup.classList.remove('active');
    Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(popup);

    message.classList.add('fade');

    window.setTimeout(function () {
      message.classList.add('hide');
    }, 1000);
  }

  window.addEventListener('load', function () {
    var reloading = sessionStorage.getItem('reloading');
    if (reloading) {
      sessionStorage.removeItem('reloading');
      popup.classList.add('active');
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(popup);

      var priceInput = popup.querySelector('.js-woocommerce-popup-sizes');
      var width = sessionStorage.getItem('mattador_width');
      var height = sessionStorage.getItem('mattador_length');

      if (priceInput && width && length) {
        priceInput.innerHTML = 'Afmeting: L: ' + height + ' cm, B: ' + width + ' cm';
      }
    } else {
      if (message) {
        message.classList.add('hide');
      }
    }
  });
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var messages = document.querySelectorAll('.woocommerce-message', '.woocommerce-Message');

  var popup = document.querySelector('.js-woocommerce-popup');

  if (popup) return;
  if (messages.length < 1) return;[].concat(_toConsumableArray(messages)).forEach(function (message) {
    window.setTimeout(function () {
      message.classList.add('fade');
    }, 3000);

    window.setTimeout(function () {
      message.classList.add('hide');
    }, 4500);
  });
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_Toggle__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  jQuery(function ($) {
    console.log('Loaded');
    jQuery('.woocommerce').on('change', 'input.qty', function () {
      console.log('Change quantity');
      jQuery("[name='update_cart']").trigger('click');
    });
  });

  jQuery(document.body).on('updated_cart_totals', function () {
    var message = document.querySelector('.woocommerce-message');

    if (message) {
      window.setTimeout(function () {
        message.classList.add('fade');
      }, 3000);

      window.setTimeout(function () {
        message.classList.add('hide');
      }, 4500);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__modules_Toggle__["a" /* default */])();
  });
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollmonitor__ = __webpack_require__(6);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var wrapper = document.querySelector('.js-product-gallery');
  if (!wrapper) return;

  var targets = wrapper.querySelectorAll('.js-gallery-target');[].concat(_toConsumableArray(targets)).forEach(function (target) {
    var targetWatcher = __WEBPACK_IMPORTED_MODULE_0_scrollmonitor__["a" /* default */].create(target);
    var link = document.querySelector('a[href="#' + target.id + '"]');

    targetWatcher.stateChange(function () {
      if (link) {
        if (targetWatcher.isFullyInViewport) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  });
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-swipe-slider-parent');

  if (sliderParents.length < 1) return;
  if (document.body.clientWidth > 999) return;[].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    var slider = sliderParent.querySelector('.js-swipe-slider');
    var slides = sliderParent.querySelectorAll('.js-swipe-slide');
    var wrapper = sliderParent.querySelector('.js-swipe-slider-wrapper');
    var triggers = sliderParent.querySelectorAll('.js-swipe-slider-trigger');
    var next = sliderParent.querySelector('.js-thumbnail-slider-next') ? sliderParent.querySelector('.js-thumbnail-slider-next') : false;
    var prev = sliderParent.querySelector('.js-thumbnail-slider-prev') ? sliderParent.querySelector('.js-thumbnail-slider-prev') : false;
    var dots = sliderParent.querySelectorAll('.js-swipe-slider-dot');
    var thumbnailWrapper = sliderParent.querySelector('.js-swipe-slider-thumbnails');

    var positions = [];
    var thumbnailPositions = [];

    var slidesCount = sliderParent.querySelectorAll('.js-swipe-slide').length;
    var firstSlide = sliderParent.querySelector('.js-swipe-slide');
    var slideWidth = firstSlide.offsetWidth + 16;
    var sliderWidth = slider.offsetWidth;
    var sliderScrollWidth = slider.scrollWidth;

    var pos = 0;
    var shown = sliderWidth;

    if (!('IntersectionObserver' in window)) {
      return;
    }

    if (slides.length < 1) return;[].concat(_toConsumableArray(slides)).forEach(function (slide) {
      positions.push(slide.getBoundingClientRect());
    });[].concat(_toConsumableArray(triggers)).forEach(function (thumbnail) {
      thumbnailPositions.push(thumbnail.getBoundingClientRect());
    });[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        var target = trigger.dataset.pos;

        var position = positions[Number(target)];
        if (position) {
          wrapper.scrollTo({
            top: position.top,
            left: position.left,
            behavior: 'smooth'
          });
        }
      });
    });[].concat(_toConsumableArray(dots)).forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        var target = dot.dataset.pos;

        var position = positions[Number(target)];
        if (position) {
          wrapper.scrollTo({
            top: position.top,
            left: position.left,
            behavior: 'smooth'
          });
        }
      });
    });

    var sliderObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var target = entry.target.dataset.pos;
          var position = thumbnailPositions[Number(target)];

          if (position) {
            thumbnailWrapper.scrollTo({
              top: position.top,
              left: position.left - 16,
              behavior: 'smooth'
            });
          }

          ;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
            if (trigger.dataset.pos === entry.target.dataset.pos) {
              trigger.classList.add('active');
            } else {
              trigger.classList.remove('active');
            }
          });[].concat(_toConsumableArray(dots)).forEach(function (dot) {
            if (dot.dataset.pos === entry.target.dataset.pos) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      });
    }, { threshold: 0.8 });[].concat(_toConsumableArray(slides)).forEach(function (slide) {
      sliderObserver.observe(slide);
    });

    if (next && prev) {
      prev.addEventListener('click', function () {
        goPrev();
        navActivity();
      });

      next.addEventListener('click', function () {
        goNext();
        navActivity();
      });

      function setTransform() {
        slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
      }

      function goPrev() {
        if (pos > 0) {
          pos = Math.max(pos - 1, 0);
          setTransform();
          shown = shown - slideWidth;
        }
      }

      function goNext() {
        if (shown < sliderScrollWidth) {
          pos = Math.min(pos + 1, slidesCount - 1);
          setTransform();
          shown = shown + slideWidth;
        }
      }

      function navActivity() {
        if (pos > 0) {
          if (prev.classList.contains('inactive')) {
            prev.classList.remove('inactive');
          }
        } else {
          if (!prev.classList.contains('inactive')) {
            prev.classList.add('inactive');
          }
        }

        if (shown < sliderScrollWidth) {
          if (next.classList.contains('inactive')) {
            next.classList.remove('inactive');
          }
        } else {
          if (!next.classList.contains('inactive')) {
            next.classList.add('inactive');
          }
        }
      }
    }
  });
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var buttons = document.querySelectorAll('.js-go-back');
  if (buttons.length < 1) return;[].concat(_toConsumableArray(buttons)).forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      if (document.referrer.indexOf(window.location.host) !== -1) {
        window.history.go(-1);
      } else {
        window.location = 'https://mattador.nl/alle-producten/';
      }
    });
  });
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-swatches');

  if (containers.length < 1) return;[].concat(_toConsumableArray(containers)).forEach(function (container) {
    var triggers = container.querySelectorAll('.js-swatches-trigger');
    console.log(triggers);
    var target = container.querySelector('.js-swatches-color');
    var defaultVal = target.innerHTML;[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
      trigger.addEventListener('mouseover', function (e) {
        target.innerHTML = trigger.dataset.target;
      });

      trigger.addEventListener('mouseleave', function (e) {
        target.innerHTML = defaultVal;
      });
    });
  });
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-product-slider-parent');

  if (sliderParents.length < 1) return;
  if (document.body.clientWidth < 1000) return;[].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {

    // Variables
    var slider = sliderParent.querySelector('.js-product-slider');
    // const slides = sliderParent.querySelectorAll('.js-product-slide')
    var firstSlide = sliderParent.querySelector('.js-product-slide');
    var next = sliderParent.querySelector('.js-product-slider-next');
    var prev = sliderParent.querySelector('.js-product-slider-prev');

    var slidesCount = sliderParent.querySelectorAll('.js-product-slide').length;
    var slideWidth = firstSlide.offsetWidth;
    var sliderWidth = slider.offsetWidth;
    var sliderScrollWidth = slider.scrollWidth;

    var pos = 0;
    var shown = sliderWidth;

    // Recalculate on resize
    window.addEventListener('resize', function () {
      slideWidth = firstSlide.offsetWidth;
      sliderWidth = slider.offsetWidth;
      sliderScrollWidth = slider.scrollWidth;
      pos = 0;
      shown = sliderWidth;
      setTransform();
      navActivity();
    });

    // Events
    prev.addEventListener('click', function () {
      goPrev();
      navActivity();
      // currentSlide()
    });

    next.addEventListener('click', function () {
      goNext();
      navActivity();
      // currentSlide()
    });

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 39) {
        goNext();
        navActivity();
      }
      if (e.keyCode === 37) {
        goPrev();
        navActivity();
      }
    });

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0);
        setTransform();
        shown = shown - slideWidth;
      }
    }

    function goNext() {
      if (shown < sliderScrollWidth) {
        pos = Math.min(pos + 1, slidesCount - 1);
        setTransform();
        shown = shown + slideWidth;
      }
    }

    function navActivity() {

      if (pos > 0) {
        if (prev.classList.contains('inactive')) {
          prev.classList.remove('inactive');
        }
      } else {
        if (!prev.classList.contains('inactive')) {
          prev.classList.add('inactive');
        }
      }

      if (shown < sliderScrollWidth) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive');
        }
      } else {
        if (!next.classList.contains('inactive')) {
          next.classList.add('inactive');
        }
      }
    }
  }); // end foreach
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-product-sticky');
  var scrollPos = 0;
  var scrolledUp = false;

  if (containers.length < 1) return;
  window.addEventListener('scroll', handleScroll);
  var stickyHeader = document.querySelector('.c-sticky-header');
  var scrollHeight = window.innerWidth < 768 ? 700 : 1200;

  function handleScroll() {
    scrolledUp = document.body.getBoundingClientRect().top > scrollPos;

    [].concat(_toConsumableArray(containers)).forEach(function (header) {
      // we're NOT at the top of the page
      if (window.pageYOffset > scrollHeight) {
        if (!header.classList.contains('activated')) header.classList.add('activated');

        stickyHeader.classList.contains('active') ? header.classList.add('activated-header') : header.classList.remove('activated-header');
        // we're at the top of the page
      } else {
        if (header.classList.contains('activated')) {
          header.classList.remove('activated');
          header.classList.remove('activated-header');
        }
      }
    });

    // saves the new position for iteration.
    scrollPos = document.body.getBoundingClientRect().top;
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-single-product-swatches');
  if (containers.length < 1) return;

  [].concat(_toConsumableArray(containers)).forEach(function (container) {
    var trigger = container.querySelector('.js-single-product-swatches-trigger');
    var target = container.querySelector('.js-single-product-swatches-target');
    var first = container.querySelector('.js-single-product-swatches-first');

    trigger.addEventListener('click', function (e) {
      target.classList.remove('hidden');
      trigger.classList.add('hidden');
      first.classList.add('hidden');
    });
  });
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Lightbox = function Lightbox() {
  var images = document.querySelectorAll('.js-lightbox-image, .dco-image-attachment-link');
  if (images.length < 1) return;[].concat(_toConsumableArray(images)).forEach(function (image) {
    image.addEventListener('click', addLightbox);
  });
};

function addLightbox(e) {
  e.preventDefault();

  // get img src
  var url = e.target.closest('.js-lightbox-image, .dco-image-attachment-link');
  var src = url.getAttribute('href');

  // create lightbox elements
  var lightbox = document.createElement('div');
  var loader = document.createElement('div');
  var image = document.createElement('img');
  var cross = document.createElement('div');

  // set elements
  lightbox.setAttribute('id', 'js-lightbox');
  lightbox.setAttribute('class', 'c-lightbox');
  loader.setAttribute('class', 'c-lightbox__loader');
  image.setAttribute('class', 'c-lightbox__image');
  image.setAttribute('src', src);
  cross.setAttribute('class', 'c-lightbox__cross');

  // add to dom
  document.body.appendChild(lightbox);
  lightbox.appendChild(loader);
  lightbox.appendChild(image);
  lightbox.appendChild(cross);

  // on image load
  image.addEventListener('load', function () {
    image.classList.add('c-lightbox__image--loaded');
    loader.classList.add('c-lightbox__loader--loaded');
  });

  // remove if clicked again
  lightbox.addEventListener('click', removeLightbox);
}

function removeLightbox() {
  var lightbox = document.getElementById('js-lightbox');
  document.body.removeChild(lightbox);
}

/* harmony default export */ __webpack_exports__["a"] = (Lightbox);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sampleLink = document.querySelector('.js-open-sample-tab');
  var sampleTab = document.getElementById('proefstaaltjes');
  if (!sampleLink || !sampleTab) return;

  sampleLink.addEventListener('click', function (e) {
    e.preventDefault();
    var trigger = sampleTab.querySelector('.js-toggle-trigger');
    var target = sampleTab.querySelector('.js-toggle-panel');

    var y = target.getBoundingClientRect().top - 120;

    trigger.classList.add('active');
    target.classList.add('active');

    window.scrollTo({ top: y, behavior: 'smooth' });
  });
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-woo-filling-mat');
  if (!container) return;

  var allOptions = container.querySelectorAll('.js-woo-filling-mat-option');
  var productLength = document.querySelector('.js-woo-length');
  var productWidth = document.querySelector('.js-woo-width');
  var optionError = container.querySelector('.js-woo-filling-mat-error');
  var defaultMatWidthContent = container.querySelector('.js-woo-filling-mat-total-width');
  var defaultMatWidth = parseInt(container.querySelector('.js-woo-filling-mat-total-width').dataset.width);[].concat(_toConsumableArray(allOptions)).forEach(function (option) {
    option.addEventListener('click', function (e) {
      var matWidth = parseInt(option.dataset.width);

      setTimeout(function () {
        if (option.classList.contains('active')) {
          // option.classList.remove('active')
          defaultMatWidth = defaultMatWidth ? defaultMatWidth + matWidth : matWidth;
        } else {
          // option.classList.add('active');
          defaultMatWidth = defaultMatWidth ? defaultMatWidth - matWidth : matWidth;
        }

        defaultMatWidthContent.innerHTML = defaultMatWidth + 'mm';
      }, 500);

      if (productLength.value > 125 || productWidth.value > 125) {
        optionError.classList.add('active');
      }
    });
  });
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliders = document.querySelectorAll('.js-item-slider');
  if (!sliders) return;

  [].concat(_toConsumableArray(sliders)).forEach(function (slider) {
    var slides = slider.querySelectorAll('.js-item-slide');
    var firstSlide = slider.querySelector('.js-item-slide');
    var slidesCount = slider.querySelectorAll('.js-item-slide').length;
    if (slides.length == 0) return;
    var slideWidth = firstSlide.offsetWidth;
    var pos = 0;

    // Recalculate on resize
    window.addEventListener('resize', function () {
      slideWidth = firstSlide.offsetWidth;
      pos = 0;
      setTransform();
      clearInterval(autoSlider);
    });

    var autoSlider = setInterval(function () {
      goNext();
    }, 5000);

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
    }

    function goNext() {
      if (pos == slidesCount - 1) {
        pos = 0;
        setTransform();
      } else if (pos < slidesCount - 1) {
        pos++;
        setTransform();
      }
    }
  });
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var triggers = document.querySelectorAll('.js-trigger-fillmat-popup');
  var popups = document.querySelectorAll('.js-fillmat-popup');
  if (triggers.length < 1) return;
  if (popups.length < 1) return;

  ;[].concat(_toConsumableArray(popups)).forEach(function (popup) {
    var close = popup.querySelector('.js-fillmat-close');
    var bgcontainer = popup.querySelector('.js-fillmat-popup-bg');
    var popupContent = popup.querySelector('.js-fillmat-popup-content');

    close.addEventListener('click', function (e) {
      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(popupContent);
      popup.classList.remove('active');
    });

    bgcontainer.addEventListener('click', function (e) {
      if (popup.classList.contains('active')) {
        popup.classList.remove('active');
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(popupContent);
      }
    });
  });[].concat(_toConsumableArray(triggers)).forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      var popup = document.getElementById(trigger.dataset.target);
      if (!popup) return;
      var popupContent = popup.querySelector('.js-fillmat-popup-content');
      var close = popup.querySelector('.js-fillmat-close');

      Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["disableBodyScroll"])(popupContent);
      popup.classList.add('active');

      close.addEventListener('click', function (e) {
        Object(__WEBPACK_IMPORTED_MODULE_0_body_scroll_lock__["enableBodyScroll"])(popupContent);
        popup.classList.remove('active');
      });
    });
  });
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var forms = document.querySelectorAll('.js-add-to-cart-second-form');
  if (forms.length < 1) return;[].concat(_toConsumableArray(forms)).forEach(function (form) {
    var options = form.querySelector('.js-woo-options');
    var price = form.querySelector('.js-woo-price-bar');
    var methods = form.querySelector('.c-method-cards');
    var usps = form.querySelector('.c-single-product-usps');

    options.remove();
    price.remove();
    methods.remove();
    usps.remove();
  });
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-project-slider-parent');
  if (document.body.clientWidth < 1000) return;
  if (sliderParents.length < 1) return;

  [].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    // Variables
    var slider = sliderParent.querySelector('.js-project-slider');
    var slide = sliderParent.querySelector('.js-project-slide');
    var filler = sliderParent.querySelector('.js-project-filler');
    var slides = sliderParent.querySelectorAll('.js-project-slide');
    var next = sliderParent.querySelector('.js-project-slider-next');
    var prev = sliderParent.querySelector('.js-project-slider-prev');

    if (slides.length < 1) return;
    var slided = 1;
    filler.style['min-width'] = slide.offsetWidth * 2 + 'px';
    filler.style['max-width'] = slide.offsetWidth * 2 + 'px';

    // Next function
    next.addEventListener('click', function (e) {
      slider.scrollTo({
        top: 0,
        left: slide.offsetWidth * slided - 1,
        behavior: 'smooth'
      });

      if (slided != slides.length) slided++;
      prev.classList.remove('inactive');

      if (slided == slides.length) next.classList.add('inactive');
    });

    // Prev function
    prev.addEventListener('click', function (e) {
      slider.scrollTo({
        top: 0,
        left: slide.offsetWidth * slided - slide.offsetWidth * 2,
        behavior: 'smooth'
      });

      if (slided != 1) slided--;
      next.classList.remove('inactive');
      if (slided == 1) prev.classList.add('inactive');
    });
  }); // end foreach
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-project-slider-parent');
  if (document.body.clientWidth > 1000) return;
  if (sliderParents.length < 1) return;

  [].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    // Variables
    var slider = sliderParent.querySelector('.js-project-slider');
    var slide = sliderParent.querySelector('.js-project-slide');
    var filler = sliderParent.querySelector('.js-project-filler');
    var slides = sliderParent.querySelectorAll('.js-project-slide');
    if (slides.length < 1) return;
    var slided = 1;
    filler.style['min-width'] = slide.offsetWidth * 2 + 'px';
    filler.style['max-width'] = slide.offsetWidth * 2 + 'px';

    if (!('IntersectionObserver' in window)) {
      return;
    }

    // Make sure we update the slided count if the user scrolls through the slider
    var sliderObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var target = entry.target.dataset.target;
          slided = target;
        }
      });
    }, { threshold: 0.8, root: slider });

    [].concat(_toConsumableArray(slides)).forEach(function (slide) {
      sliderObserver.observe(slide);
    });
  }); // end foreach
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var billing_checkbox = document.querySelector('#billing_business');
  var billing_company_field = document.querySelector('#billing_company_field');
  var woocommerce_eu_vat_number_field = document.querySelector('#woocommerce_eu_vat_number_field');

  if (billing_checkbox && billing_company_field) {
    billing_checkbox.addEventListener('click', function () {
      if (billing_checkbox.checked === true) {
        if (billing_company_field) {
          billing_company_field.classList.add('show-business');
        }
        if (woocommerce_eu_vat_number_field) {
          woocommerce_eu_vat_number_field.classList.add('show-business');
        }
      } else {
        if (billing_company_field.classList.contains('show-business')) {
          billing_company_field.classList.remove('show-business');
        }
        if (woocommerce_eu_vat_number_field) {
          if (woocommerce_eu_vat_number_field.classList.contains('show-business')) {
            woocommerce_eu_vat_number_field.classList.remove('show-business');
          }
        }
      }
    });
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.getElementById('order_review');
  if (!container) return;
  if (window.innerWidth > 768) return;

  var cartPrice = document.querySelector('.js-checkout-price-update-price bdi');
  var cartPriceHTML = cartPrice.innerHTML.split('&nbsp;');
  var cartPriceCurrency = cartPriceHTML[0];
  var cartPriceValue = cartPriceHTML[1];

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var paymentContainer = document.getElementById('payment');
      cartPriceValue = paymentContainer.dataset.price;
      cartPrice.innerHTML = cartPriceCurrency + ' ' + cartPriceValue;
    });
  });

  observer.observe(container, {
    subtree: true,
    childList: true
  });
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containers = document.querySelectorAll('.js-search');
  if (containers.length < 1) return;

  [].concat(_toConsumableArray(containers)).forEach(function (container) {
    var header = document.querySelector('.c-page-header');
    var trigger = container.querySelector('.js-search-trigger');
    var target = container.querySelector('.js-search-target');
    var close = container.querySelector('.js-search-close');

    trigger.addEventListener('click', function (e) {
      target.classList.toggle('active');

      if (header) {
        header.classList.toggle('active');
      }
    });

    close.addEventListener('click', function (e) {
      if (target.classList.contains('active')) target.classList.remove('active');

      if (header && header.classList.contains('active')) {
        setTimeout(function () {
          header.classList.toggle('active');
        }, 250);
      }
    });
  });
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-options-rubber');
  if (!container) return;

  var trigger = container.querySelector('.js-options-rubber--trigger');
  var width = document.querySelector('.js-woo-width') ? document.querySelector('.js-woo-width') : false;
  var height = document.querySelector('.js-woo-length') ? document.querySelector('.js-woo-length') : false;
  var defaultDimensions = document.querySelector('.js-woo-default-select') ? document.querySelector('.js-woo-default-select') : false;
  var matPrices = document.querySelector('.js-woo-rubber-mat-price') ? document.querySelectorAll('.js-woo-rubber-mat-price') : false;

  trigger.addEventListener('click', function (e) {
    console.log('Clicked on product option: Rubber');

    if (width.value && height.value || defaultDimensions.value) {
      container.classList.remove('active-error');

      if (container.classList.contains('active')) {
        container.classList.remove('active');
      } else {
        container.classList.add('active');
      }
    } else {
      if (container.classList.contains('active-error')) {
        container.classList.remove('active-error');
        container.classList.remove('active');
      } else {
        container.classList.add('active-error');
        container.classList.add('active');
      }

      if (matPrices) {
        ;[].concat(_toConsumableArray(matPrices)).forEach(function (matPrice) {
          matPrice.innerHTML = '€0,00';
        });
      }
    }
  });
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-woo-filling-mat');
  if (!container) return;

  var trigger = container.querySelector('.js-woo-filling--trigger');
  var width = document.querySelector('.js-woo-width') ? document.querySelector('.js-woo-width') : false;
  var height = document.querySelector('.js-woo-length') ? document.querySelector('.js-woo-length') : false;
  var defaultDimensions = document.querySelector('.js-woo-default-select') ? document.querySelector('.js-woo-default-select') : false;
  var matPrices = document.querySelector('.js-woo-filling-mat-price') ? document.querySelectorAll('.js-woo-filling-mat-price') : false;

  trigger.addEventListener('click', function (e) {
    console.log('Clicked on product option: Filling mat');

    if (!width.value || !height.value || !defaultDimensions.value) {
      if (container.classList.contains('active-error')) {
        container.classList.remove('active-error');
        container.classList.remove('active');
      } else {
        container.classList.add('active-error');
        container.classList.add('active');
      }

      // if (matPrices) {
      //   [...matPrices].forEach(matPrice => {
      //     matPrice.innerHTML = '€0,00';
      //   })
      // }
    } else {
      container.classList.remove('active-error');

      if (container.classList.contains('active')) {
        container.classList.remove('active');
      } else {
        container.classList.add('active');
      }
    }
  });
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-woo-additional-products');
  if (!container) return;

  var trigger = container.querySelector('.js-woo-additional-products--trigger');
  var options = container.querySelectorAll('.js-woo-additional-product-option');
  var selection = container.querySelector('.js-woo-additional-product-selection');
  var selectionArray = [];

  trigger.addEventListener('click', function (e) {
    console.log('Clicked on product option: Additional product');

    if (container.classList.contains('active')) {
      container.classList.remove('active');
    } else {
      container.classList.add('active');
    }
  });

  [].concat(_toConsumableArray(options)).forEach(function (option) {
    option.addEventListener('click', function (e) {
      var productId = option.dataset.id;
      console.log('You selected product: ' + productId);

      if (option && typeof option.classList !== 'undefined') {
        option.classList.contains('active') ? option.classList.remove('active') : option.classList.add('active');
      }

      selectionArray.includes(productId) ? selectionArray = selectionArray.filter(function (item) {
        return item !== productId;
      }) : selectionArray.push(productId);

      selection.setAttribute('value', JSON.stringify(selectionArray));
    });
  });
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var container = document.querySelector('.js-afmetingen-buitenmat');
  var select = document.getElementById('pa_afmetingen');
  var variationInput = document.querySelector('input.variation_id');
  if (!container && !select) return;

  var options = container.querySelectorAll('.js-afmetingen-buitenmat-item');

  [].concat(_toConsumableArray(options)).forEach(function (option) {
    option.addEventListener('click', function () {
      // Remove active class from all options
      [].concat(_toConsumableArray(options)).forEach(function (item) {
        item.classList.remove('active');
      });
      option.classList.add('active');

      // Set the value of the select
      var value = this.getAttribute('data-value');
      var id = this.getAttribute('data-id');
      var price = this.getAttribute('data-price');
      select.value = value;
      variationInput.value = id;

      // Trigger change event on the select element
      var event = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      select.dispatchEvent(event);
    });
  });
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sliderParents = document.querySelectorAll('.js-cards-slider-parent');
  if (document.body.clientWidth < 1000) return;
  if (sliderParents.length < 1) return;

  [].concat(_toConsumableArray(sliderParents)).forEach(function (sliderParent) {
    var slider = sliderParent.querySelector('.js-cards-slider');
    var slides = sliderParent.querySelectorAll('.js-cards-slide');
    var slide = sliderParent.querySelector('.js-cards-slide');
    var next = sliderParent.querySelector('.js-cards-slider-next');
    var prev = sliderParent.querySelector('.js-cards-slider-prev');

    if (slides.length < 1) return;
    var slided = 1;

    // Next function
    next.addEventListener('click', function (e) {
      slider.scrollTo({
        top: 0,
        left: (slide.offsetWidth + 10) * slided - 1,
        behavior: 'smooth'
      });

      if (slided != slides.length) slided++;
      prev.classList.remove('inactive');

      if (slided == slides.length - 4) next.classList.add('inactive');
    });

    // Prev function
    prev.addEventListener('click', function (e) {
      slider.scrollTo({
        top: 0,
        left: slide.offsetWidth * slided - slide.offsetWidth * 2,
        behavior: 'smooth'
      });

      if (slided != 1) slided--;
      next.classList.remove('inactive');
      if (slided == 1) prev.classList.add('inactive');
    });
  }); // end foreach
});

/***/ })
],[38]);


// WEBPACK FOOTER //
// main.ea64fdcdc54f60a90484.js